(function() {
    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();
(function($) {
    'use strict';

    $.validator.setDefaults({
        ignore:
            ':hidden:not([class~=selectized]),:hidden > .selectized, .selectize-control .selectize-input input', // Set for '.selectize
        wrapper: 'ul',
        errorElement: 'li',
        errorPlacement: function(error, element) {
            if (element.is(':checkbox') || element.is(':radio')) {
                var label = element.closest('label');
                error.insertAfter(label);
            } else {
                error.insertAfter(element);
            }
            error.addClass('error-tooltip');
        },
    });

    $.validator.addMethod(
        'alphanumeric',
        function(value, element) {
            return this.optional(element) || /^[\w\s\-()]+$/i.test(value);
        },
        '',
    );

    $.validator.addMethod(
        'alphabet',
        function(value, element) {
            return this.optional(element) || /^[a-z ]+$/i.test(value);
        },
        '',
    );

    $.validator.addMethod(
        'ordernumber',
        function(value, element) {
            return this.optional(element) || /^[\w\d\-]+$/i.test(value);
        },
        '',
    );

    $.validator.addMethod(
        'pwdpolicy',
        function(value, element) {
            var result =
                this.optional(element) ||
                (value.length >= 8 && (/\d/.test(value) || /[!@#$%]/i.test(value)));
            return result;
        },
        '',
    );

    $.validator.addMethod(
        'notEqualTo',
        function(value, element, param) {
            var target = $(param);
            if (value) return value != target.val();
            else return this.optional(element);
        },
        '',
    );

    $.validator.addMethod(
        'state',
        function(value, element) {
            var $form = $(element).closest('form'),
                state = $form.find('#drpState').val(),
                country = $form.find('#drpCountry').val();

            if ((country === 'US' || country === 'CA') && !$.trim(state)) {
                return false;
            }

            return true;
        },
        '',
    );

    $.validator.addMethod(
        'cardtype',
        function(value, element) {
            var $form = $(element).closest('form'),
                $txtSecurityCode = $form.find('#txtSecurityCode'),
                $txtCreditCardNumber = $form.find('#txtCreditCardNumber');

            /* edit page does not have security code field */
            if ($txtSecurityCode.length > 0) {
                $txtSecurityCode.attr({ maxlength: 3, minlength: 3 });

                if (value == 'AX') {
                    $txtSecurityCode.attr({ maxlength: 4, minlength: 4 });
                }
            }

            /* edit page does not have credit card number field */
            if ($txtCreditCardNumber.length > 0) {
                if (value == 'VI') {
                    $txtCreditCardNumber.attr({ maxlength: 16, minlength: 13 });
                } else if (value == 'MC') {
                    $txtCreditCardNumber.attr({ maxlength: 16, minlength: 16 });
                } else if (value == 'DI') {
                    $txtCreditCardNumber.attr({ maxlength: 16, minlength: 16 });
                } else if (value == 'AX') {
                    $txtCreditCardNumber.attr({ maxlength: 15, minlength: 15 });
                }
            }

            return true;
        },
        '',
    );

    $.validator.addMethod(
        'creditValidation',
        function(value, element) {
            var $form = $(element).closest('form');
            var cardType = $form.find('#drpCardType').val();
            var cardno = $(element).val();

            if (cardType == 'AX' && /^3[47][0-9]{13}/.test(cardno)) {
                return value.length === 15;
            } else if (cardType == 'DI' && /^6[0-9]{15}/.test(cardno)) {
                return value.length === 16;
            } else if (cardType == 'MC' && /^5[0-5][0-9]{14}/.test(cardno)) {
                return value.length === 16;
            } else if (cardType == 'VI') {
                if (/4[0-9]{15}/.test(cardno)) {
                    return value.length === 16;
                }
                if (/4[0-9]{12}/.test(cardno)) {
                    return value.length === 13;
                }
            }

            return false;
        },
        '',
    );

    $.validator.addMethod(
        'cscDigit',
        function(value, element) {
            var $form = $(element).closest('form'),
                cardType = $form.find('#drpCardType').val();

            if (/^\d+$/.test(value)) {
                if (cardType == 'AX') {
                    return value.length === 4;
                } else if (cardType == 'DI' || cardType == 'MC' || cardType == 'VI') {
                    return value.length === 3;
                }
            } else {
                return false;
            }
        },
        '',
    );

    $.validator.addMethod(
        'cardexpired',
        function(value, element) {
            var $form = $(element).closest('form'),
                expYear = $form.find('#drpExpYear').val();

            if (expYear !== '') {
                var today = new Date(),
                    currDate = new Date(today.getFullYear(), today.getMonth(), 1),
                    expDate = new Date(expYear, parseInt(value, 10) - 1, 1);

                return Date.parse(currDate) <= Date.parse(expDate);
            }

            return true;
        },
        '',
    );

    $.validator.addMethod(
        'taxStateExcemption',
        function(value, element) {
            var $form = $(element).closest('form'),
                radio = $form.find('input[name=radTaxExcem]:checked').attr('data-function');

            if (radio == 'stateTaxExcem') {
                if (
                    $(element)
                        .find('option:selected')
                        .index() === 0
                ) {
                    return false;
                }
            }

            return true;
        },
        '',
    );

    $.validator.addMethod(
        'taxProvinceExcemption',
        function(value, element) {
            var $form = $(element).closest('form'),
                radio = $form.find('input[name=radTaxExcem]:checked').attr('data-function');

            if (radio == 'provinceTaxExcem') {
                if (
                    $(element)
                        .find('option:selected')
                        .index() === 0
                ) {
                    return false;
                }
            }

            return true;
        },
        '',
    );

    $.validator.addMethod(
        'dateTimePicker',
        function(value, element) {
            var $form = $(element).closest('form'),
                radio = $form.find('input[name=radCertiExpiry]:checked').attr('data-function'),
                date = $(element).val();

            if (radio == 'expiresOn') {
                if (!$.trim(date)) {
                    return false;
                }
            }

            return true;
        },
        '',
    );

    $.validator.addMethod(
        'phonenumber',
        function(value, element, param) {
            var country = param.toLowerCase(),
                pattern = '',
                jsnRegex = {};

            jsnRegex = {
                at: '^[\\+][4][3][ ]?\\d{7,12}$',
                be: '^[\\+][3][2][ ]?\\d{8,10}$',
                ca: '^\\d{3}[-]\\d{3}[-]\\d{4}$',
                us: '^\\d{3}[-]\\d{3}[-]\\d{4}$',
                cz: '^[\\+][4][2][0][ ]?\\d{9}$',
                de: '^[\\+][4][9][ ]?\\d{3,12}$',
                dk: '^[\\+][4][5][ ]?\\d{8}$',
                es: '^[\\+][3][4][ ]?\\d{9}$',
                fi: '^[\\+][3][5][8][ ]?\\d{5,12}$',
                fr: '^[\\+][3][3][ ]?\\d{9}$',
                uk: '^[\\+][4][4][ ]?\\d{10}$',
                ie: '^[\\+][3][5][3][ ]?\\d{6,10}$',
                it: '^[\\+][3][9][ ]?\\d{8,11}$',
                lu: '^[\\+][3][5][2][ ]?\\d{6,10}$',
                nl: '^[\\+][3][1][ ]?\\d{9}$',
                no: '^[\\+][4][7][ ]?\\d{8}$',
                pl: '^[\\+][4][8][ ]?\\d{3,9}$',
                pt: '^[\\+][3][5][1][ ]?\\d{9}$',
                se: '^[\\+][4][6][ ]?\\d{6,9}$',
            };

            pattern = new RegExp(jsnRegex[country]);
            return this.optional(element) || pattern.test(value);
        },
        '',
    );

    $.validator.addMethod(
        'generalphone',
        function(value, element) {
            var pattern = /^[0-9- ()+]{5,20}$/;
            return this.optional(element) || pattern.test(value);
        },
        '',
    );

    $.validator.addMethod(
        'zipcode',
        function(value, element, param) {
            var country = param.toLowerCase(),
                pattern = '',
                jsnRegex = {};

            jsnRegex = {
                at: '^\\d{4}$',
                be: '^\\d{4}$',
                ca: '^[A-Za-z][0-9][A-Za-z][ -]?[0-9][A-Za-z][0-9]$',
                us: '^(\\d{5})[ -]?(\\d{4})$|^(\\d{5})[ -]?$',
                cz: '^\\d{3}[ ]\\d{2}$',
                de: '^\\d{5}$',
                dk: '^\\d{4}$',
                es: '^\\d{5}$',
                fi: '^\\d{5}$',
                fr: '^\\d{5}$',
                uk: '^([A-Za-z0-9]{2,4})[ ]\\d([A-Za-z0-9]{2})$',
                ie: '',
                it: '^\\d{5}$',
                lu: '^\\d{4}$',
                nl: '^\\d{4}[ ][A-Za-z]{2}$',
                no: '^\\d{4}$',
                pl: '^\\d{2}[-]\\d{3}$',
                pt: '^\\d{4}[-]\\d{3}$',
                se: '^\\d{3}[ ]\\d{2}$',
            };

            pattern = new RegExp(jsnRegex[country]);
            return this.optional(element) || pattern.test(value);
        },
        '',
    );

    $.validator.addMethod(
        'multiemail',
        function(value, element) {
            if (this.optional(element)) {
                // if element is optional and empty, returns true, if element is optional and not empty returns false, if element is not optional returns false
                return true;
            }

            var email = value.split(/[;,]+/); // split element by , and ;
            var valid = true;
            for (var i in email) {
                value = email[i];
                valid = valid && jQuery.validator.methods.email.call(this, $.trim(value), element);
            }
            return valid;
        },
        '',
    );

    $.validator.addMethod(
        'quantity',
        function(value) {
            return /^[1-9]\d*$/.test(value);
        },
        '',
    );

    $.validator.addMethod(
        'vatid',
        function(value, element, param) {
            var country = param.toLowerCase(),
                pattern = '',
                jsnRegex = {};

            jsnRegex = {
                at: '^$|^[A][T][U]\\d{8}$',
                be: '^$|^[B][E]\\d{10}$',
                ca: '',
                us: '',
                cz: '^$|^[C][Z]\\d{8}$|^[C][Z]\\d{9}$|^[C][Z]\\d{10}$',
                de: '^$|^[D][E]\\d{9}$',
                dk: '^$|^[D][K]\\d{8}$',
                es:
                    '^$|^[E][S][A-Za-z]\\d{7}[A-Za-z]$|^[E][S][A-Za-z]\\d{8}$|^[E][S]\\d{8}[A-Za-z]$',
                fi: '^$|^[F][I]\\d{8}$',
                fr: '^$|^[F][R][0-9A-Za-z]{2}\\d{9}$',
                uk: '^$|^[G][B]\\d{9}$|^[G][B]\\d{12}$|^[G][B][G][D]\\d{3}$|^[G][B][H][A]\\d{3}$',
                ie:
                    '^$|^[I][E][0-9]([A-Za-z]|[0-9]|[+]|[*])\\d{5}[A-Za-z]$|^[I][E]\\d{7}[A-Z]$|^[I][E]\\d{7}[A-Z][A-Z]$|^[I][E]\\d{1}[A-Z]\\d{5}$',
                it: '^$|^[I][T]\\d{11}$',
                lu: '^$|^[L][U]\\d{8}$',
                nl: '^$|^[N][L]\\d{9}[B]\\d{2}$',
                no: '',
                pl: '^$|^[P][L]\\d{10}$',
                pt: '^$|^[P][T]\\d{9}$',
                se: '^$|^[S][E]\\d{12}$',
            };

            pattern = new RegExp(jsnRegex[country]);
            return this.optional(element) || pattern.test(value);
        },
        '',
    );

    $.validator.addMethod(
        'daterange',
        function(value, element, param) {
            if (this.optional(element)) {
                // return true on optional element
                return true;
            }

            var form = $(element).closest('form'),
                txtFrom = form.find(param.split(' ')[0]).val(),
                txtTo = form.find(param.split(' ')[1]).val(),
                arrFrom = [],
                arrTo = [],
                startDate = '',
                endDate = '',
                valid = true;

            if ($.trim(txtFrom) && $.trim(txtTo)) {
                arrFrom = txtFrom.split('/');
                arrTo = txtTo.split('/');

                startDate = new Date(
                    parseInt(arrFrom[2], 10),
                    parseInt(arrFrom[0], 10) - 1,
                    parseInt(arrFrom[1], 10),
                );
                endDate = new Date(
                    parseInt(arrTo[2], 10),
                    parseInt(arrTo[0], 10) - 1,
                    parseInt(arrTo[1], 10),
                );

                valid = startDate <= endDate;
            }

            return valid;
        },
        '',
    );

    /* Added for email popin/footer */
    // Email
    $.validator.methods.email = function(value, element) {
        return this.optional(element) || /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value);
    };
})(jQuery);

/**
 * Global Modules definition
 * These global module variables are accessed from other legacy code located in external files
 * */

var modulesNames = [
    'apcCommon',
    'globalNav',
    'tradeFilter',
    'apcData',
    'myAccount',
    'productPages',
    'sessionExpiry',
    'pdp',
    'miniCart',
    'tokenizr',
    'checkout',
    'toggleSlider',
    'poms',
    'search',
    'changeSite',
    'dynamicParams',
];

modulesNames.forEach(function(moduleName) {
    window[moduleName] = {};
});

(function($) {
    'use strict';

    apcCommon = {
        modules: [],
        message_bar_clear: null,
        arrCountry: [],

        init: function() {
            apcCommon.onloadShowLoader();
            apcCommon.initMessageBar();
            apcCommon.stateAutoPopuplate();
            apcCommon.formatPhoneZip();
            apcCommon.initVatDropdown();
            apcCommon.multiSelect();
            apcCommon.enableButtons();
            apcCommon.multiLogin();

            /* check is the touchscreen device or not */
            if (!apcCommon.isTouchDevice()) {
                document.body.className += ' hasHover';
            }
            /* initialize tooltips */
            $('[data-toggle="tooltip"]').tooltip({ html: true });

            /* initialize print */
            $('span.print, a.print').on('click', function() {
                window.print();
            });

            if ($('.lnk-logout').length && $('[data-logout-url]').length) {
                $('.lnk-logout').attr('href', $('[data-logout-url]').data('logout-url'));
            }

            /* logout */
            $('body').on('click', 'a.lnk-logout', function() {
                apcCommon.performSignOut();
            });

            /* logout new header */
            $('body').on('click', 'a.logout', function() {
                apcCommon.performSignOut();
            });
        },

        /*
         * Initialize Message Bar
         * If Message bar is already available in the page then it will auto hide after 10 seconds.
         * On click on 'Hide' link / 'X' button on the message bar, the message bar is hidden.
         * 'Click' even for 'Hide' link / 'X' button is delegated, as in some cases the message bar gets created dynamically
         */
        initMessageBar: function() {
            var $message_bar = $('div#notice-panel > div.message-bar');

            if ($message_bar.length > 0) {
                $message_bar.show();

                apcCommon.message_bar_clear = setTimeout(function() {
                    $message_bar.slideUp('slow');
                }, 10000);
            }

            $('body').on(
                'click',
                'div.message-bar a.message-hide, div.message-bar button.close',
                function(event) {
                    var $message_bar = $('div#notice-panel > div.message-bar');

                    event.preventDefault();

                    clearTimeout(apcCommon.message_bar_clear);
                    $message_bar.stop().slideUp('slow');
                },
            );
        },

        /*
         * Dynamically creates message bar if it does not exists
         * Add success/error class based on the type param
         * Appends success/error message into the message bar
         * Pre-requisite: div#notice-panel should be available in the page
         */
        createMessageBarWithClose: function(type, message) {
            var message_bar_html,
                $notice_panel = $('#notice-panel'),
                $message_bar = $('div#notice-panel > div.message-bar');

            if ($message_bar.length === 0) {
                message_bar_html =
                    '<div class="message-bar">' +
                    '<span aria-hidden="true" class="glyphicon glyphicon-exclamation-sign"></span>' +
                    '<button type="button" class="close"><span>x</span></button>' +
                    '<div class="message"> </div>' +
                    '</div>';

                $message_bar = $(message_bar_html);

                $notice_panel.empty();
                $notice_panel.append($message_bar);
            }

            if (type === 'success') {
                $notice_panel
                    .find('div.message-bar')
                    .removeClass('server-error-panel')
                    .addClass('server-success-panel');
            } else {
                $notice_panel
                    .find('div.message-bar')
                    .removeClass('server-success-panel')
                    .addClass('server-error-panel');
            }

            clearTimeout(apcCommon.message_bar_clear);

            if ($message_bar.is(':animated')) {
                $message_bar.finish();
            }

            $message_bar
                .find('.message')
                .empty()
                .html(message);
            $message_bar.show();

            apcCommon.message_bar_clear = setTimeout(function() {
                $message_bar.slideUp('slow');
            }, 10000);
        },

        /*
         * Dynamically creates message bar if it does not exists
         * Add success/error class based on the type param
         * Appends success/error message into the message bar
         * Pre-requisite: div#notice-panel should be available in the page
         */
        createMessageBarNoClose: function(type, message) {
            var message_bar_html,
                $notice_panel = $('#notice-panel'),
                $message_bar = $('div#notice-panel > div.message-bar-noclose');

            if ($message_bar.length === 0) {
                message_bar_html =
                    '<div class="message-bar-noclose">' +
                    '<span aria-hidden="true" class="glyphicon glyphicon-exclamation-sign"></span>' +
                    '<p> <span class="message">Message will be shown here</span></p>' +
                    '</div>';

                $message_bar = $(message_bar_html);

                $notice_panel.empty();
                $notice_panel.append($message_bar);
            }

            if (type === 'success') {
                $notice_panel
                    .find('div.message-bar-noclose')
                    .removeClass('server-error-panel')
                    .addClass('server-success-panel');
            } else {
                $notice_panel
                    .find('div.message-bar-noclose')
                    .removeClass('server-success-panel')
                    .addClass('server-error-panel');
            }

            $message_bar
                .find('.message')
                .empty()
                .html(message);
        },

        /*
         * dynamic population of states based on country selection
         */
        populateStates: function(fldCountry, state) {
            var country = '',
                $drp_state = '',
                selected = '',
                $form = $(fldCountry).closest('form');

            if ($form.find('#userState').length !== 0) {
                $form.find('#userState').val(state);
            }

            if (fldCountry.value == 'US' || fldCountry.value == 'CA') {
                $drp_state = $form.find('select#drpState');
                $drp_state.empty();
                country = fldCountry.value;

                if (!apcCommon.arrCountry[country]) {
                    apcCommon.arrCountry[country] = $.ajax({
                        type: 'POST',
                        cache: false,
                        dataType: 'json',
                        url: contextPath + '/myaccount/generateStateList.jsp',
                        data: { country: country },
                    });
                }

                apcCommon.arrCountry[country].done(function(data) {
                    $drp_state.append('<option value=""> -- Select State -- </option>');
                    $.each(data, function(index, value) {
                        selected = '';
                        if (value.code == state) {
                            selected = 'selected';
                        }
                        $drp_state.append(
                            '<option value="' +
                                value.code +
                                '" ' +
                                selected +
                                '>' +
                                value.displayName +
                                '</option>',
                        );
                    });
                    $form.find('.state-dropdown').show();
                    $form.find('.state-textbox').hide();
                });
            } else {
                $form.find('input#txtState').val(state);
                $form.find('.state-textbox').show();
                $form.find('.state-dropdown').hide();
            }
        },

        /*
         * dynamic population of states based on country selection
         * If country is available on load of page, get the states list and populate state dropdown - This is in case of US and Canada
         * On change of the country dropdown, get state list of the country selected
         */
        stateAutoPopuplate: function() {
            var $form = null,
                state = '';

            $('select.drp-country:visible').each(function() {
                $form = $(this).closest('form');
                $form.find('.state-dropdown, .state-textbox').hide();

                if ($.trim(this.value)) {
                    state =
                        $form.find('#userState').length !== 0 ? $form.find('#userState').val() : '';
                    apcCommon.populateStates(this, state);
                }
            });

            $('input.hdn-country').each(function() {
                $form = $(this).closest('form');
                $form.find('.state-dropdown, .state-textbox').hide();

                if ($.trim(this.value)) {
                    state =
                        $form.find('#userState').length !== 0 ? $form.find('#userState').val() : '';
                    apcCommon.populateStates(this, state);
                }
            });

            $('body').on('change', 'select.drp-country', function() {
                state = '';
                apcCommon.populateStates(this, state);
            });

            $('body').on('change', 'select.drp-state, input.txt-state', function() {
                var state = $(this).val(),
                    form = $(this).closest('form');

                if (form.find('#userState').length !== 0) {
                    form.find('#userState').val(state);
                }
            });
        },

        /*
         * Update the help note for phone and zip format on change of country
         */
        formatPhoneZip: function() {
            var form = null,
                fldPhone = null,
                fldZip = null,
                phoneFormat = '',
                zipFormat = '',
                country = '',
                code = '',
                zipRequired = true,
                validator = null;

            $('body').on('change', 'select.drp-country', function() {
                country = this.value;
                form = $(this).closest('form');
                fldPhone = form.find('input#txtPhone');
                fldZip = form.find('input#txtZip');
                phoneFormat = apcConfig.phoneFormat[country] ? apcConfig.phoneFormat[country] : '';
                zipFormat = apcConfig.zipFormat[country] ? apcConfig.zipFormat[country] : '';
                code = '';
                validator = form.data('validator') ? form.data('validator') : null;

                if (phoneFormat.indexOf('+') != -1) {
                    code = phoneFormat.split(' ')[0] + ' ';
                }

                /* CR : 1452 : If postal code is empty, make the field non mandatory */
                if (!$.trim(zipFormat)) {
                    zipRequired = false;
                    $('span.zip-required-sign, p.zip-help-block').addClass('hide');
                } else {
                    zipRequired = true;
                    $('span.zip-required-sign, p.zip-help-block').removeClass('hide');
                }
                fldPhone
                    .attr({ placeholder: phoneFormat })
                    .data('rule-phonenumber', country)
                    .val(code);

                form.find('span.zip-format').text(zipFormat);

                fldZip
                    .attr({ placeholder: zipFormat })
                    .data('rule-zipcode', country)
                    .data('rule-required', zipRequired)
                    .val('');

                if (validator && !zipRequired) {
                    validator.element('input#txtZip');
                }
            });
        },

        getVatIdServiceStatus: function(config, data) {
            var prmOrderDetails = apcData.get(
                config,
                'Please wait, while we are calculating your order details...',
                true,
            );

            /* update order details panel in case of success */
            prmOrderDetails.done(function(data) {
                $('#order-summary')
                    .empty()
                    .append($(data));

                if (window.vatNotificationType === 'error') {
                    var convert = function(convert) {
                        return $('<span />', { html: convert }).text();
                    };

                    $('#topVatIdNoticePanel .vat-info-panel').addClass('server-error-panel');
                    $('#topVatIdNoticePanel .message').html(convert(window.vatNotification));

                    $('#vatIdNoticePanel .message').text(window.vatNotificationField);
                    $('#vatIdNoticePanel .vat-info-panel').addClass('server-error-panel');

                    $('#txtVatId').addClass('server-error');
                    $('#vatIdNoticePanel .vat-info-panel').removeClass('info-panel');
                    window.vatNotificationType = '';
                } else if (window.vatNotificationType === 'warning') {
                    var convert = function(convert) {
                        return $('<span />', { html: convert }).text();
                    };

                    $('#topVatIdNoticePanel .vat-info-panel').addClass('info-panel');
                    $('#topVatIdNoticePanel .message').html(convert(window.vatNotification));

                    $('#vatIdNoticePanel .message').empty();
                    $('#vatIdNoticePanel .vat-info-panel').removeClass('server-error-panel');

                    window.vatNotificationType = '';
                } else {
                    $('#topVatIdNoticePanel .message').empty();
                    $('#topVatIdNoticePanel .vat-info-panel').removeClass('server-error-panel');
                    $('#topVatIdNoticePanel .vat-info-panel').removeClass('info-panel');

                    $('#vatIdNoticePanel .message').empty();
                    $('#vatIdNoticePanel .vat-info-panel').removeClass('server-error-panel');

                    $('#txtVatId').removeClass('error');
                    $('#txtVatId').removeClass('server-error');
                }

                /* reinitialize tool tips */
                $('#order-summary [data-toggle="tooltip"]').tooltip();

                apcData.hideAjaxLoader();

                $('html, body').animate({ scrollTop: 0 }, 'slow');
            });

            /* show error panel in case of failure */
            prmOrderDetails.fail(function(jqXHR, textStatus, errorThrown) {
                apcCommon.createMessageBarNoClose('error', errorThrown);
                apcData.hideAjaxLoader();
            });
        },

        initVatDropdown: function() {
            var dropdown = document.getElementById('vat-dropdown');

            if (dropdown === null) return;

            dropdown.addEventListener('change', function(event) {
                var inputElement = document.getElementById('txtVatId');
                inputElement.setAttribute('data-config-postfix', event.target.value);
                // var value = inputElement.value;
                var clonedInputElement = inputElement.cloneNode(true);
                inputElement.parentElement.replaceChild(clonedInputElement, inputElement);
                // eslint-disable-next-line no-new
                console.warn('Initializing VAT mask from apc.js');
                new MaskValidation(inputElement.dataset.ruleMaskvatnumber, [
                    {
                        helperLabelClassName: '.vat-format',
                        selector: '#txtVatId',
                        maskConstructor: MaskValidation.maskClasses.vat,
                    },
                ]).init();

                var vatIDErrEl = document.getElementById('txtVatId-error');

                if (vatIDErrEl) {
                    var errorPopup = vatIDErrEl.parentElement;
                    errorPopup.parentElement.removeChild(errorPopup);
                }

                clonedInputElement.focus();
                clonedInputElement.classList.remove('error');

                var data = {
                    vatid: $('#txtVatId').val(),
                    shippingmethod: $('#drpShippingMethod').val(),
                };

                var vatTypeEl = $('#vat-dropdown');

                if (vatTypeEl) {
                    data.userVatIdType = vatTypeEl.val();
                }

                var config = {
                    data: data,
                    dataType: 'html',
                    url: apcConfig.orderdetailsurl,
                };

                if (
                    $('#form-shipping-logged-user').length === 0 ||
                    data.vatid.indexOf('_') !== -1 || data.vatid === ''
                ) {
                    return;
                }

                apcCommon.getVatIdServiceStatus(config, data);
            });
        },

        /*
         * show the loader in case when page is taking long time to respond.
         */
        onloadShowLoader: function() {
            if (!$('#ajax-loader').hasClass('show-onload')) return;

            $('body').addClass('overflow-hidden');
            // $('#content-area').addClass('apc-hidden');

            $(document).ready(() => {
                apcData.hideAjaxLoader();
            });
        },

        performSignOut: function() {
            $.ajax({
                type: 'POST',
                url: contextPath + '/includes/userLoginCheck.jsp',
                success: function(profileStatus) {
                    if (!profileStatus) {
                        $('#logout-full').submit();
                    } else {
                        var newContextPath = '';
                        if (contextPath.includes('/tradeups')) {
                            newContextPath = contextPath.replace('/tradeups', '');
                        } else {
                            newContextPath = contextPath;
                        }
                        window.location.href = newContextPath + '/categories';
                    }
                },
            });
        },

        isIE: function() {
            var myNav = navigator.userAgent.toLowerCase();
            return myNav.indexOf('msie') != -1 ? parseInt(myNav.split('msie')[1]) : false;
        },

        isEmpty: function(element) {
            return !$.trim(element.html());
        },

        multiSelect: function() {
            if ($.fn.multiselect && $('.custom-multi-select').length > 0) {
                $('.custom-multi-select').multiselect({
                    buttonText: function(options, select) {
                        return $(select).attr('data-defaultText');
                    },
                    onChange: function(option, checked, select) {
                        const customEvent = new CustomEvent('select-option', {
                            bubbles: true,
                            cancelable: false,
                        });
                        $(option)
                            .get(0)
                            .dispatchEvent(customEvent);
                        location = $(option).val();
                    },
                });
            }
        },

        /* IEP-4513
         * Show multilogin container on click on Sign In link in the header
         */
        multiLogin: function() {
            var header_wrap = 'div#header-right',
                linkPos = 0,
                headerRightWidth = 0,
                loginLinkWidth = 0,
                rightPos = 0,
                checkout = false;

            $('body').on('mouseenter', 'a.login-link', function() {
                // var linkPos = $('a.login-link').length > 0 ? $('#header-right a.login-link').position() : '';
                // linkPos !== '' ? $('.multi-login-container').css('left', linkPos['left']) : '';
                // var multiPos = $('.multi-login-container').position();
                // $('.multi-login-container').css('left', 0 - linkPos['left'] - 15);
                // $('.multi-login-tab').css('width', $('#header-right a.login-link').outerWidth());

                var linkPos = $(header_wrap + ' a.login-link').position(),
                    headerRightWidth = $(header_wrap).outerWidth(),
                    loginLinkWidth = $('a.login-link').outerWidth(),
                    rightPos = headerRightWidth - linkPos['left'] - loginLinkWidth;

                $('.atg-multi-login-tab').css('width', loginLinkWidth);
                $('.atg-multi-login-container').css('right', rightPos - 13);

                $('.atg-multi-login-container').css('display', 'block');
            });

            $('body')
                .on('mouseenter', 'div.atg-multi-login-container', function() {
                    $('.atg-multi-login-container').css('display', 'block');
                })
                .on('mouseleave', 'div.atg-multi-login-container', function() {
                    $('.atg-multi-login-container').css('display', 'none');
                });
        },

        /*
         * Fix: 4517
         * Enable the add to cart buttons only after page load
         */
        enableButtons: function() {
            function enableElement(i, el) {
                if (el && el.removeAttribute) {
                    el.removeAttribute('disabled');
                }
            }

            $(
                'input.btn-enable-onpageload, button.btn-enable-onpageload, a.btn-enable-onpageload',
            ).each(enableElement);
        },

        /*
         * Fix: in scope of APCG-7274
         * Check is device toucheble or not
         */
        isTouchDevice: function() {
            return (
                'ontouchstart' in document.documentElement ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0
            );
        },
    };

    apcCommon.modules.push(apcCommon.init);

    $(function() {
        var isReSellersPartners = $('#isReSellersPartners').val();
        $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
            if ($(e.target).attr('href') == '#credit-card') {
                if (isReSellersPartners == 'true') {
                    $('#form-payment-resetCreditcard').submit();
                }
            } else if ($(e.target).attr('href') == '#bank-transfer') {
                if (isReSellersPartners == 'true') {
                    $('#form-payment-resetBankTransfer').submit();
                }
            } else if ($(e.target).attr('href') == '#purchase-order') {
                if (isReSellersPartners == 'true') {
                    $('#form-payment-resetPurchaseOrder').submit();
                }
            }
        });

        var p = $('#descrptnABC p');
        var divh = $('#descrptnABC').height();
        while ($(p).outerHeight() > divh) {
            $(p).text(function(index, text) {
                return text.replace(/\W*\s(\S)*$/, '...');
            });
            if ($(p).text() === '...') {
                break;
            }
        }

        for (var mdl = 0; mdl < apcCommon.modules.length; mdl++) {
            apcCommon.modules[mdl]();
        }
        // apcCommon.init();
        // globalNav.init();
        // myAccount.init();
    });
    /*$('#vertical-carousel').carousel({
            interval: 2000
    });
    $('#vertical-carousel .item').each(function(){
        var next = $(this).next();
        if (!next.length) {
        next = $(this).siblings(':first');
        }
        next.children(':first-child').clone().appendTo($(this));

        for (var i=0;i<2;i++) {
        next=next.next();
        if (!next.length) {
        next = $(this).siblings(':first');
        }

        next.children(':first-child').clone().appendTo($(this));
        }
    });
    $(".small-thumbnail img").on( "click", function() {
            console.log('imageClick');
            $('#DataDisplay').attr("src", $(this).attr("data-display"));
            $('.small-thumbnail').removeClass('active');
            $(this).closest('.small-thumbnail').addClass('active');
        });*/
})(jQuery);
(function($) {
    'use strict';

    tokenizr = {
        container: '[data-token]',

        init: function() {
            tokenizr.replaceContent();
            tokenizr.replaceContentECR();
        },
        replaceContent: function() {
            var _ele = $('body').find(tokenizr.container);
            if (_ele.length < 1) return false;

            _ele.each(function(i, item) {
                var _item = $(item),
                    itemContent = _item.html(),
                    token = _item.data('token'),
                    tokenContent = $('#header').find('span[data-token-replace="' + token + '"]');

                if (tokenContent.length !== 0) {
                    tokenContent.replaceWith(itemContent);
                    $('[data-token="' + _item.data('token') + '"]').remove();
                }
            });
        },
        replaceContentECR: function() {
            var _ele = $('body').find(tokenizr.container);
            if (_ele.length < 1) return false;

            _ele.each(function(i, item) {
                var _item = $(item),
                    itemContent = _item.html(),
                    token = _item.data('token'),
                    tokenContent = $('.main-menu').find('span[data-token-replace="' + token + '"]');
                //console.log(itemContent);
                if (tokenContent.length !== 0) {
                    tokenContent.replaceWith(itemContent);
                    $('[data-token="' + _item.data('token') + '"]').remove();
                }
            });
        },
    };

    if ($(tokenizr.container).length > 0) {
        apcCommon.modules.push(tokenizr.init);
    }
})(jQuery);
(function($) {
    'use strict';
    var APC_NAV_WRAPPER = '.apc-nav-wrapper',
        APC_NAV = '.apc-nav',
        APC_NAV_DROPDOWN = '.apc-nav-dropdown',
        APC_NAV_PANEL = '.apc-nav-panel',
        APC_NAV_DELAY_HIDE = 200,
        APC_NAV_DELAY_DISPLAY = 100,
        APC_PNS_MENU = 'ul.pns_menu > li';

    globalNav = {
        init: function() {
            /* top navigation : start */
            var delayDisplay = null,
                delayHide = null,
                $LI = $(APC_NAV).children('li');

            $(APC_NAV_WRAPPER).on('mouseleave', function() {
                /*
                 * delay the hiding of panel by some short time
                 * if the user enters his mouse over the tab within this short time, the delay will be cleared
                 */
                delayHide = setTimeout(function() {
                    $(APC_NAV_PANEL).hide();
                    $(APC_NAV_DROPDOWN).hide();
                    $LI.removeClass('active-tab');
                }, APC_NAV_DELAY_HIDE);
            });

            $LI.each(function() {
                var panel = '#' + $(this).attr('id') + '_panel';

                $(this)
                    .on('mouseenter', function() {
                        clearTimeout(delayHide);

                        $LI.removeClass('active-tab');
                        $(this).addClass('active-tab');

                        /*
                         * Delay the display of panels so that it shows up only if the user keeps the mouse over the tab for a short period of time.
                         * This will stop the menu jumping open if the user just passes the mouse over the menu headings.
                         */
                        delayDisplay = setTimeout(function() {
                            $(APC_NAV_PANEL).hide(); // hide all panels
                            $(APC_NAV_DROPDOWN).show(); // hide panels wrapper
                            $(panel).show(); // show current panel
                        }, APC_NAV_DELAY_DISPLAY);
                    })
                    .on('mouseleave', function() {
                        clearTimeout(delayDisplay);
                    });
            });

            $(APC_PNS_MENU).on('mouseenter', function() {
                var index = $(this).index();

                $(APC_PNS_MENU).removeClass('active');
                $(this).addClass('active');

                $('div.pns_content > div')
                    .hide()
                    .eq(index)
                    .show();
            });
            /* top navigation : end */
        },
    };

    apcCommon.modules.push(globalNav.init);
})(jQuery);
(function($) {
    'use strict';

    /*
     * Handles Ajax Calls
     */
    apcData = {
        init: function() {
            $.ajaxSetup({
                cache: 'false',
                type: 'POST',
                dataType: 'json',
            });

            apcData.resizeOverlay();
        },

        resizeOverlay: function() {
            $(window).on('resize', function() {
                var divBlockPage = $('div#block-page'),
                    pageHeight = $(window).height(),
                    pageWidth = $(window).width();

                if (divBlockPage.is(':visible')) {
                    divBlockPage.css({
                        height: pageHeight,
                        width: pageWidth,
                    });
                }
            });
        },

        hideAjaxLoader: function() {
            var divBlockPage = $('div#block-page'),
                divAjaxLoader = $('div#ajax-loader');

            divBlockPage
                .css({
                    display: 'none',
                    height: 'auto',
                    width: 'auto',
                })
                .removeClass('show-onload');

            divAjaxLoader.css({ display: 'none' }).removeClass('show-onload');

            $('body').removeClass('overflow-hidden');
            $('#content-area').removeClass('apc-hidden');
        },

        showAjaxLoader: function(message) {
            var divBlockPage = $('div#block-page'),
                divAjaxLoader = $('div#ajax-loader'),
                divMessage = divAjaxLoader.find('div.message'),
                pageHeight = $(window).height(),
                pageWidth = $(window).width();

            divBlockPage.css({
                display: 'block',
                height: pageHeight,
                width: pageWidth,
            });

            divMessage.html(message);
            divAjaxLoader.css({ display: 'block' });

            $('body').addClass('overflow-hidden');
        },

        get: function(options, message, showloader) {
            var config = {
                beforeSend: function() {
                    if (typeof showloader !== undefined && showloader === true) {
                        apcData.showAjaxLoader(message);
                    }
                },
            };

            config = $.extend(config, options);

            return $.ajax(config);
        },
    };

    apcCommon.modules.push(apcData.init);
})(jQuery);
(function($) {
    'use strict';

    myAccount = {
        sortOrder: '',

        init: function() {
            /*
             * The init function will have modulewise function calls.
             * E.g. myAccount.orderHistoryDetails() -> This method will inturn will have calls to specific methods like myAccount.selectSortType(), myAccount.setActiveSortTab()
             */
            myAccount.rememberMe();
            myAccount.addressBook();
            myAccount.addEditAddress();
            myAccount.myList();
            myAccount.paymentMethod();
            myAccount.orderHistoryDetails();
            myAccount.taxPageFunctions();
            myAccount.UIMSTokenCheck();

            myAccount.formValidate();
            myAccount.modalWindow();
        },

        rememberMe: function() {
            var flag = null,
                _url = '',
                config = {};

            if ($('input#chkRememberMe').length !== 0) {
                flag = $('input#chkRememberMe').is(':checked');
                _url = $('input#chkRememberMe').data('url');

                if (flag) {
                    config = {
                        type: 'get',
                        dataType: 'html',
                        url: _url,
                        data: { flag: flag },
                    };
                    apcData.get(config, '', false);
                }

                $('input#chkRememberMe').on('click', function() {
                    flag = $('input#chkRememberMe').is(':checked');

                    config = {
                        type: 'get',
                        dataType: 'html',
                        url: _url,
                        data: { flag: flag },
                    };
                    apcData.get(config, '', false);
                });
            }
        },

        /* Address book : start */
        addressBook: function() {
            if ($('#ma-address-book').length === 0) return;

            /* on the address book page
             * to dynamically populate the address in the delete address modal window
             */
            $('#mdlDeleteAddress').on('show.bs.modal', function(e) {
                var addressKey = $(e.relatedTarget).data('delete');
                $('#key').val(addressKey);
                $.ajax({
                    type: 'POST',
                    cache: false,
                    dataType: 'html',
                    url: contextPath + '/myaccount/deleteAddress.jsp',
                    data: { addressKey: addressKey },
                }).done(function(data) {
                    $('#mdlDeleteAddress .dynamicContent')
                        .empty()
                        .append(data);
                });
            });

            /* make as primary delivery address */
            $('a.make-primary').on('click', function(e) {
                e.preventDefault();

                var lnkPrimary = $(this),
                    key = lnkPrimary.data('key'),
                    _url = lnkPrimary.data('url'),
                    address_wrap = lnkPrimary.closest('div.address-book-content'),
                    address = lnkPrimary.closest('div.address'),
                    details = { key: key },
                    config = {
                        data: details,
                        dataType: 'html',
                        url: _url,
                    },
                    lnkDelete = address.find('.delete'),
                    $message_bar = $('div#notice-panel > div.message-bar');

                var prmMakePrimary = apcData.get(config, 'Please wait...', true);

                /* set primary delivery method for respective panel and show 'Set as primary' for other panels */
                prmMakePrimary.done(function(data, textStatus, jqXHR) {
                    clearTimeout(apcCommon.message_bar_clear);
                    $message_bar.hide();

                    address_wrap
                        .find('a.make-primary')
                        .removeClass('hide')
                        .show();
                    lnkPrimary.hide();

                    address_wrap
                        .find('.delete')
                        .removeClass('hide')
                        .show();
                    lnkDelete.hide();

                    address_wrap.find('span.primary-delivery').hide();
                    address
                        .find('span.primary-delivery')
                        .removeClass('hide')
                        .show();

                    address_wrap.find('div.address').removeClass('highlight');
                    address.addClass('highlight');

                    apcData.hideAjaxLoader();
                });

                /* show error panel in case of failure */
                prmMakePrimary.fail(function(jqXHR, textStatus, errorThrown) {
                    apcCommon.createMessageBarWithClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                });
            });
        },
        /* Address book : end */

        /* Add / Edit Address : Start */
        addEditAddress: function() {
            /* On the edit address page,
             * when the user clicks on the checkbox its value will be added to a hidden field
             * this was not achieveable via JSP hence added here
             */
            if ($('#editProfile').length > 0) {
                $('#chkPrimaryBilling').on('focusout', function() {
                    var checkedBilling = $('#chkPrimaryBilling').checked;
                    if (checkedBilling !== true) {
                        $('#isDefaultBilling').val('reset');
                    }
                });
                $('#chkPrimaryDelivery').on('focusout', function() {
                    var checkedDelivery = $('#chkPrimaryDelivery').checked;
                    if (checkedDelivery !== true) {
                        $('#isDefaultShipping').val('reset');
                    }
                });
            }
        },
        /* Add / Edit Address : End */

        /* My List : start */
        customButtonStateChange: function(state) {
            if (state === true) {
                $('div.add-selected').removeClass('disabled');
                $('div.remove-selected').removeClass('disabled');
                $('div.email-selected').removeClass('disabled');
            } else {
                $('div.add-selected').addClass('disabled');
                $('div.remove-selected').addClass('disabled');
                $('div.email-selected').addClass('disabled');
            }
        },

        deleteListItem: function() {
            var $tr = null,
                delete_type = null,
                sku_id = null,
                gift_id = null,
                shopping_link = $('input[name=hdnShoppingLink]').val(),
                arr_sku_id = [],
                arr_gift_id = [],
                arr_tr = [];

            /*
             * Action for click on 'Remove' link
             */
            $('a.remove-item').on('click', function(e) {
                e.preventDefault();

                delete_type = 'single';
                $tr = $(this).closest('tr');

                $('#mdlConfirmDelete').modal('show');
            });

            /*
             * Action for click on 'Remove Selected' button
             */
            $('div.remove-selected').on('click', function() {
                delete_type = 'multiple';

                if ($('input[name=chkListItem]:checked').length !== 0) {
                    $('#mdlConfirmDelete').modal('show');
                }
            });

            /*
             * Delete item modal window
             */
            $('.js-delete-item-btn').on('click', function() {
                $('#mdlConfirmDelete').modal('hide');

                clearTimeout(apcCommon.message_bar_clear);

                if (delete_type === 'single') {
                    sku_id = $tr.find("input[name='chkListItem']").val();
                    gift_id = $tr.find("input[name='hdnGiftItemId']").val();
                } else {
                    arr_sku_id = [];
                    arr_gift_id = [];
                    arr_tr = [];

                    $('input[name=chkListItem]:checked').each(function() {
                        $tr = $(this).closest('tr');
                        arr_sku_id.push(this.value);
                        arr_gift_id.push($tr.find("input[name='hdnGiftItemId']").val());
                        arr_tr.push($tr);
                    });

                    sku_id = arr_sku_id.join(',');
                    gift_id = arr_gift_id.join(',');
                }

                var config = {
                    data: { skuid: sku_id, giftid: gift_id, shoppinglink: shopping_link },
                    dataType: 'html',
                    url: contextPath + '/wishlist/removeItemsFromList.jsp',
                };
                var prmRemoveItem = apcData.get(config, '', true);

                prmRemoveItem.done(function(data) {
                    apcData.hideAjaxLoader();

                    if ($(data).hasClass('success-message')) {
                        /* response received and success scenario */

                        if (delete_type === 'single') {
                            $tr.remove();
                        } else {
                            for (var i = 0; i < arr_tr.length; i++) {
                                arr_tr[i].remove();
                            }
                        }

                        /* if all items are removed, show empty message */
                        if ($('div.table-mylist tbody tr').length === 0) {
                            $('div.non-empty-list').remove();
                            $('div.empty-list').removeClass('hide');
                        }

                        apcCommon.createMessageBarWithClose('success', data);
                    } else if ($(data).hasClass('error-message')) {
                        /* response received but error scenario */

                        apcCommon.createMessageBarWithClose('error', data);
                    }

                    myAccount.customButtonStateChange(false);

                    $("input[name='chkListItem'], #chkAllList").prop('checked', false);
                });

                prmRemoveItem.fail(function(jqXHR, textStatus, errorThrown) {
                    apcData.hideAjaxLoader();
                    apcCommon.createMessageBarWithClose('error', errorThrown);
                });
            });
        },

        addListItem: function() {
            var arr_sku_id = [],
                arr_gift_id = null,
                sku_id = null,
                gift_id = null,
                config = {},
                flg_discontinued = false,
                flg_callforstock = false;
            /*
             * Action for click on 'add to cart' link
             */
            $('a.add-to-cart, .add-all, div.add-selected').on('click', function(e) {
                e.preventDefault();

                arr_sku_id = [];
                arr_gift_id = [];
                sku_id = null;
                flg_discontinued = false;
                flg_callforstock = false;

                if ($(e.target).hasClass('add-to-cart')) {
                    sku_id = $(this)
                        .closest('tr')
                        .find("input[name='chkListItem']")
                        .val();
                    gift_id = $(this)
                        .closest('tr')
                        .find("input[name='hdnGiftItemId']")
                        .val();
                } else if ($(e.target).hasClass('add-all')) {
                    $('input[name=chkListItem]').each(function() {
                        arr_sku_id.push(this.value);
                        arr_gift_id.push(
                            $(this)
                                .closest('tr')
                                .find("input[name='hdnGiftItemId']")
                                .val(),
                        );
                        if ($(this).data('discontinued')) {
                            flg_discontinued = true;
                        }
                        if (
                            $(this)
                                .closest('tr')
                                .find('div.calltoAction').length
                        ) {
                            flg_callforstock = true;
                        }
                    });
                    sku_id = arr_sku_id.join(',');
                    gift_id = arr_gift_id.join(',');
                } else if ($(e.target).hasClass('add-selected')) {
                    $('input[name=chkListItem]:checked').each(function() {
                        arr_sku_id.push(this.value);
                        arr_gift_id.push(
                            $(this)
                                .closest('tr')
                                .find("input[name='hdnGiftItemId']")
                                .val(),
                        );
                        if ($(this).data('discontinued')) {
                            flg_discontinued = true;
                        }
                        if (
                            $(this)
                                .closest('tr')
                                .find('div.calltoAction').length
                        ) {
                            flg_callforstock = true;
                        }
                    });
                    sku_id = arr_sku_id.join(',');
                    gift_id = arr_gift_id.join(',');
                }

                /*
                 * if 'Add Selected' button is clicked without clicking on the checkbox
                 */
                if (!$.trim(sku_id)) {
                    return;
                }

                /*
                 * if discontinued buttons are clicked show modal window
                 */
                if (flg_discontinued || flg_callforstock) {
                    $('#mdlCartDisabled').modal('show');
                    return;
                }

                config = {
                    dataType: 'html',
                    data: { skuid: sku_id, giftid: gift_id },
                    url: contextPath + '/wishlist/addItemsToCart.jsp',
                };

                var promiseAddToCart = apcData.get(config, '', true);

                /* Chaning ajax calls as two calls are required here to be triggred in sequence */
                promiseAddToCart
                    .then(
                        function(data) {
                            if ($(data).hasClass('error-message')) {
                                /* error scenario when add to cart wasn't successful */
                                return data;
                            } else {
                                config = {
                                    dataType: 'html',
                                    url: contextPath + '/cart/miniCart.jsp',
                                };
                                return apcData.get(config, '', false);
                            }
                        },
                        function(jqXHR, textStatus, errorThrown) {
                            return jqXHR;
                        },
                    )
                    .then(
                        function(data) {
                            var $data = $(data),
                                cart_count = $data.find('#hdnCartCount').val();

                            apcData.hideAjaxLoader();

                            if ($data.hasClass('error-message')) {
                                /* error scenario when add to cart wasn't successful and second ajax call was cancelled */

                                clearTimeout(apcCommon.message_bar_clear);
                                apcCommon.createMessageBarWithClose('error', data);
                                $('html, body').animate({ scrollTop: 0 }, 'slow');
                            } else {
                                if (window.refreshMiniCartItems) {
                                    window.refreshMiniCartItems();
                                }
                                miniCart.showCart();
                                $('html, body').animate({ scrollTop: 0 }, 'slow');
                            }
                        },
                        function(jqXHR, textStatus, errorThrown) {
                            apcData.hideAjaxLoader();
                            apcCommon.createMessageBarWithClose('error', errorThrown);
                        },
                    );
            });
        },

        emailListItem: function() {
            /*
             * modal for email in the list page
             */
            $('a.email-item, div.email-selected').on('click', function(e) {
                e.preventDefault();

                var arr_product_id = [],
                    product_id;

                if ($(e.target).hasClass('email-selected')) {
                    $('input[name=chkListItem]:checked').each(function() {
                        arr_product_id.push(
                            $(this)
                                .closest('tr')
                                .find("input[name='hdnProductItemId']")
                                .val(),
                        );
                    });

                    product_id = arr_product_id.join(',');
                } else {
                    product_id = $(this)
                        .closest('tr')
                        .find('input[name=hdnProductItemId]')
                        .val();
                }

                /*
                 * if checkboxes are not selected then return
                 */
                if (!$.trim(product_id)) {
                    return;
                }

                $('#mdlEmail').modal('show');
                $('#mdlEmail')
                    .find('input[name=hdnProductIds]')
                    .val(product_id);
            });

            /*
             * Reset the email modal window on close
             */
            $('#mdlEmail').on('hide.bs.modal', function() {
                $('#form-mylist-email')
                    .data('validator')
                    .resetForm(); // reset form
                $('#form-mylist-email')[0].reset();
            });
        },

        myList: function() {
            if ($('form#form-myList').length === 0) {
                return;
            }

            /*
             * Select All for MyList
             */
            $('#chkAllList').on('click', function() {
                $("input[name='chkListItem']").prop('checked', this.checked);
                myAccount.customButtonStateChange(this.checked);
            });

            /*
             * item specific checkbox click
             */
            $("input[name='chkListItem']").on('click', function() {
                if ($("input[name='chkListItem']:checked").length > 0) {
                    myAccount.customButtonStateChange(true);
                } else {
                    myAccount.customButtonStateChange(false);
                }

                if (
                    $("input[name='chkListItem']:checked").length ===
                    $("input[name='chkListItem']").length
                ) {
                    $('#chkAllList').prop('checked', true);
                } else {
                    $('#chkAllList').prop('checked', false);
                }
            });

            myAccount.deleteListItem();
            myAccount.addListItem();
            myAccount.emailListItem();
        },
        /* My List : end */

        /* Order History Details : start */
        selectSortType: function() {
            /*Select sort type for Order History Page*/

            $('.order-history-table table th a').each(function() {
                $(this).on('click', function(e) {
                    e.preventDefault();
                    sortElement = $(this).attr('class');
                    if (
                        $(this)
                            .find('span')
                            .hasClass('light') !== true &&
                        $(this)
                            .find('span')
                            .hasClass('glyphicon-triangle-bottom')
                    ) {
                        sortOrder = 'asc';
                        $(this)
                            .find('span')
                            .removeClass('glyphicon-triangle-bottom')
                            .addClass('glyphicon glyphicon-triangle-top');
                    } else {
                        $('.order-history-table table th a span').addClass('light');
                        $(this)
                            .find('span')
                            .removeClass('light');
                        $(this)
                            .find('span')
                            .removeClass('glyphicon-triangle-top')
                            .addClass('glyphicon-triangle-bottom');
                        sortOrder = 'des';
                    }
                    window.location.href = $(this).attr('href') + '&sortType=' + sortOrder;
                });
            });
        },

        setActiveSortTab: function() {
            if (typeof sortParam !== 'undefined') {
                if (sortParam != ':') {
                    sortvar = sortParam.split(':');

                    $('.order-history-table table th a').each(function() {
                        $(this)
                            .find('span')
                            .addClass('light');

                        if ($(this).attr('class') == sortvar[0]) {
                            $(this)
                                .find('span')
                                .removeClass('light');

                            if (sortvar[1] == 'asc') {
                                $(this)
                                    .find('span')
                                    .removeClass('glyphicon-triangle-bottom')
                                    .addClass('glyphicon glyphicon-triangle-top');
                            } else {
                                $(this)
                                    .find('span')
                                    .removeClass('glyphicon-triangle-top')
                                    .addClass('glyphicon-triangle-bottom');
                            }
                        }
                    });

                    var activeclass = sortvar[0];
                    $('.order-history-table table td').each(function() {
                        if ($(this).hasClass('sorted')) {
                            $('.order-history-table table td').removeClass('sorted');
                        }
                    });

                    if (activeclass !== '') {
                        $('.order-history-table table td[class*=' + activeclass + ']').addClass(
                            'sorted',
                        );
                    }
                }
            }
        },

        orderHistoryDetails: function() {
            myAccount.selectSortType();
            myAccount.setActiveSortTab();
        },
        /* Order History Details : end */

        /* Payment Method : start */
        paymentMethod: function() {
            if ($('#ma-payment-methods').length === 0) return;

            /* pre select the first radio button if none is checked */
            if ($("input[name='rdSavedAddress']:checked").length === 0) {
                $("input[name='rdSavedAddress']")
                    .eq(0)
                    .prop('checked', true);
            }

            $("input[name='rdSavedAddress']").on('click', function() {
                var type = $(this).data('type'),
                    $form = $(this).closest('form'),
                    country = $form.find("input[name='hdnStaticCountry']").val();

                if (type == 'add-address') {
                    $('#new-address').removeClass('hide');
                    $('#new-address h3.add').removeClass('hide');
                    $('#new-address h3.edit').addClass('hide');

                    $('#form-add-payment-method')
                        .data('validator')
                        .resetForm(); // reset form
                    $form.find("input[id='hdnAddressEdit']").val('false');

                    /* empty the form */
                    $form.find('.state-dropdown, .state-textbox').hide();
                    $form.find("input[name='txtFirstName']").val('');
                    $form.find("input[name='txtLastName']").val('');
                    $form.find("input[name='txtCompany']").val('');
                    $form.find("input[name='txtPhone']").val('');
                    $form.find("input[id='txtExtn']").val('');
                    $form.find("select[name='drpCountry']").val(country);
                    $form.find("select[id='drpState']").val('');
                    $form.find("input[id='txtState']").val('');
                    $form.find("input[name='txtAddress1']").val('');
                    $form.find("input[name='txtAddress2']").val('');
                    $form.find("input[name='txtCity']").val('');
                    $form.find("input[name='txtZip']").val('');

                    /* set phone and zip format */
                    myAccount.formatPhoneZip($form, country, 'add');
                } else {
                    $('#new-address').addClass('hide');
                }
            });

            $('#saved-address a.edit').on('click', function(e) {
                var radio = $(this).data('radio'),
                    $address = $(this).closest('div.address'),
                    $form = $(this).closest('form'),
                    $fldCountry = $form.find("select[name='drpCountry']"),
                    country = $address.find("input[name='hdnCountry']").val(),
                    state = $address.find("input[name='hdnState']").val();

                e.preventDefault();

                $('#form-add-payment-method')
                    .data('validator')
                    .resetForm(); // reset form
                $form.find("input[id='hdnAddressEdit']").val('true');

                $('#new-address').removeClass('hide');
                $('#new-address h3.add').addClass('hide');
                $('#new-address h3.edit').removeClass('hide');
                $('#rdSavedAddress' + radio).prop('checked', true);

                /* poupulate the form fields for the selected address to edit */
                $form
                    .find("input[name='txtFirstName']")
                    .val($address.find("input[name='hdnFirstName']").val());
                $form
                    .find("input[name='txtLastName']")
                    .val($address.find("input[name='hdnLastName']").val());
                $form
                    .find("input[name='txtCompany']")
                    .val($address.find("input[name='hdnCompany']").val());
                $form
                    .find("input[name='txtPhone']")
                    .val($address.find("input[name='hdnPhone']").val());
                $form.find("input[id='txtExtn']").val($address.find("input[name='hdnExtn']").val());
                $form.find("select[name='drpCountry']").val(country);
                $form
                    .find("input[name='txtAddress1']")
                    .val($address.find("input[name='hdnAddress1']").val());
                $form
                    .find("input[name='txtAddress2']")
                    .val($address.find("input[name='hdnAddress2']").val());
                $form
                    .find("input[name='txtCity']")
                    .val($address.find("input[name='hdnCity']").val());
                $form.find("input[name='txtZip']").val($address.find("input[name='hdnZip']").val());

                $form.find('.state-dropdown, .state-textbox').hide();
                apcCommon.populateStates($fldCountry.get(0), state);

                /* set phone and zip format */
                myAccount.formatPhoneZip($form, country, 'edit');
            });

            /* on the MyAccount payment method page
             * to dynamically populate the Credit card details in the delete payment  modal window
             */
            $('#mdlDeletePaymentMethod').on('show.bs.modal', function(e) {
                var creditCardKey = $(e.relatedTarget).data('delete');
                var creditCardId = $('#paymentMethodId').val();
                $('#ccKey').val(creditCardKey);
                $('.modal-body')
                    .html('')
                    .addClass('loading');
                $.ajax({
                    type: 'POST',
                    cache: false,
                    dataType: 'html',
                    url: contextPath + '/myaccount/deleteMyAccountPayment.jsp',
                    data: { creditCardKey: creditCardKey, creditCardId: creditCardId },
                }).done(function(data) {
                    $('#mdlDeletePaymentMethod .modal-body')
                        .empty()
                        .removeClass('loading')
                        .append(data);
                });
            });

            /* On the edit payment method page,
             * when the user clicks on the checkbox its value will be added to a hidden field
             * this was not achieveable via JSP hence added here
             */

            if ($('#editCreditcard').length > 0) {
                $('#chkPaymentMethod').on('focusout', function() {
                    var checkedMethod = $('#chkPaymentMethod').checked;
                    if (checkedMethod !== true) {
                        $('#isDefaultCreditCard').val('reset');
                    }
                });
            }

            /* make as primary payment method */
            $('a.make-primary').on('click', function(e) {
                e.preventDefault();

                var lnkPrimary = $(this),
                    key = lnkPrimary.data('key'),
                    _url = lnkPrimary.data('url'),
                    payment_wrap = lnkPrimary.closest('div.payment-method-content'),
                    payment_method = lnkPrimary.closest('div.address'),
                    details = { key: key },
                    config = {
                        data: details,
                        dataType: 'html',
                        url: _url,
                    },
                    $message_bar = $('div#notice-panel > div.message-bar');

                var prmMakePrimary = apcData.get(config, 'Please wait...', true);

                /* set primary payment method for respective panel and show 'Set as primary' for other panels */
                prmMakePrimary.done(function(data, textStatus, jqXHR) {
                    clearTimeout(apcCommon.message_bar_clear);
                    $message_bar.hide();

                    payment_wrap
                        .find('a.make-primary')
                        .removeClass('hide')
                        .show();
                    lnkPrimary.hide();

                    payment_wrap.find('a.not-primary').hide();
                    payment_method
                        .find('a.not-primary')
                        .removeClass('hide')
                        .show();

                    payment_wrap.find('span.primary-payment').hide();
                    payment_method
                        .find('span.primary-payment')
                        .removeClass('hide')
                        .show();

                    payment_wrap.find('div.address').removeClass('highlight');
                    payment_method.addClass('highlight');

                    apcData.hideAjaxLoader();
                });

                /* show error panel in case of failure */
                prmMakePrimary.fail(function(jqXHR, textStatus, errorThrown) {
                    apcCommon.createMessageBarWithClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                });
            });

            /* make as non-primary payment method */
            $('a.not-primary').on('click', function(e) {
                e.preventDefault();

                var lnkNotPrimary = $(this),
                    key = lnkNotPrimary.data('key'),
                    _url = lnkNotPrimary.data('url'),
                    payment_wrap = lnkNotPrimary.closest('div.payment-method-content'),
                    payment_method = lnkNotPrimary.closest('div.address'),
                    details = { key: key },
                    config = {
                        data: details,
                        dataType: 'html',
                        url: _url,
                    },
                    $message_bar = $('div#notice-panel > div.message-bar');

                var prmMakePrimary = apcData.get(config, 'Please wait...', true);

                /* set primary payment method for respective panel and show 'Set as primary' for other panels */
                prmMakePrimary.done(function(data, textStatus, jqXHR) {
                    clearTimeout(apcCommon.message_bar_clear);
                    $message_bar.hide();

                    lnkNotPrimary.hide();
                    payment_method.removeClass('highlight');
                    payment_method.find('span.primary-payment').hide();
                    payment_method
                        .find('a.make-primary')
                        .removeClass('hide')
                        .show();

                    apcData.hideAjaxLoader();
                });

                /* show error panel in case of failure */
                prmMakePrimary.fail(function(jqXHR, textStatus, errorThrown) {
                    apcCommon.createMessageBarWithClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                });
            });
        },
        /* Payment Method : end */

        /* Tax ID : start */
        invokeCalendar: function() {
            /* Invoke Calendar for Tax ID  */
            if ($('#datetimepicker').length >= 1) {
                var today = new Date();
                $('#datetimepicker')
                    .datepicker({
                        format: 'mm/dd/yyyy',
                        startDate: today,
                    })
                    .on('change', function() {
                        var dateElement = $(this);
                        dateElement.valid(); // triggers the validation test on change
                        $('#txtdatetimepicker').val(dateElement.val());
                        $('.datepicker').hide();
                    });
            }
        },

        manageTaxExcemption: function() {
            /* Cosmetic functionality for Tax ID  */
            $('#drpCountry').on('change', function(event) {
                var taxExcemption = $('.taxExcemption');
                var currentTargetVal = $(event.target).val();
                // reset form
                $('#form-taxID')
                    .data('validator')
                    .resetForm();
                $('#drpStateExemption')
                    .prop('disabled', true)
                    .val('');
                $('#drpProvinceExemption')
                    .prop('disabled', true)
                    .val('');
                $("input[name='radTaxExcem']")
                    .eq(0)
                    .prop('checked', true);
                $('#taxType').val($("input[name='radTaxExcem']:checked").val());
                if ($.trim(currentTargetVal)) {
                    taxExcemption.show();
                } else {
                    taxExcemption.hide();
                }

                $.ajax({
                    method: 'POST',
                    cache: 'false',
                    dataType: 'json',
                    url: contextPath + '/myaccount/generateStateList.jsp',
                    data: { country: currentTargetVal },
                }).done(function(data) {
                    var setStateorProvince = function(elementId) {
                        $.each(data, function(index, value) {
                            var selected = '';
                            if (value.code == $('#' + elementId).val()) {
                                selected = 'selected';
                            }
                            $('#' + elementId).append(
                                '<option value="' +
                                    value.code +
                                    '" ' +
                                    selected +
                                    '>' +
                                    value.displayName +
                                    '</option>',
                            );
                        });
                    };
                    if (currentTargetVal == 'US') {
                        setStateorProvince('drpStateExemption');
                        $('.stateTaxExcem').show();
                        $('.provinceTaxExcem').hide();
                        $('.TaxExcemption-group').show();
                        //$(".EMEA-group").hide();
                    } else if (currentTargetVal == 'CA') {
                        setStateorProvince('drpProvinceExemption');
                        $('.stateTaxExcem').hide();
                        $('.provinceTaxExcem').show();
                        //$(".EMEA-group").hide();
                        $('.TaxExcemption-group').show();
                    } else {
                        setStateorProvince('drpEMEAExemption');
                        //$(".EMEA-group").show();
                        $('.TaxExcemption-group').hide();
                    }
                });
            });

            $("input[name='radCertiExpiry']").on('click', function() {
                $('#txtdatetimepicker').val('');

                if ($(this).data('function') === 'never') {
                    $('#datetimepicker')
                        .prop('disabled', true)
                        .val('')
                        .addClass('mobile-hidden');

                    if (
                        $('#datetimepicker').hasClass('error') &&
                        $('#datetimepicker')
                            .parent()
                            .find('ul.error-tooltip')
                    ) {
                        $('#datetimepicker').removeClass('error');
                        $('#datetimepicker')
                            .parent()
                            .find('ul.error-tooltip')
                            .remove();
                    }
                } else {
                    $('#datetimepicker')
                        .prop('disabled', false)
                        .val('')
                        .removeClass('mobile-hidden');
                }
            });

            $("input[name='radTaxExcem']").on('click', function() {
                $('#taxState').val('');
                $('#txtdatetimepicker').val('');
                var elementSelected = $(this);
                var radiofunction = $(elementSelected).data('function');
                $('#taxType').val(elementSelected.val());
                if (radiofunction === 'stateTaxExcem') {
                    $('#drpStateExemption')
                        .prop('disabled', false)
                        .removeClass('mobile-hidden');
                } else if (radiofunction === 'provinceTaxExcem') {
                    $('#drpProvinceExemption')
                        .prop('disabled', false)
                        .removeClass('mobile-hidden');
                } else {
                    $('#drpStateExemption, #drpProvinceExemption').valid(); // to remove error message for State Excemption dropdown

                    $('#drpStateExemption, #drpProvinceExemption')
                        .prop('disabled', true)
                        .addClass('mobile-hidden');
                }
            });

            $('.drptaxState').on('change', function() {
                $('#taxState').val($(this).val());
            });
        },

        taxPageFunctions: function() {
            if ($('#ma-taxID').length > 0) {
                myAccount.invokeCalendar();
                myAccount.manageTaxExcemption();
            }
        },
        /* Tax ID : end */

        /* utility methods : start */
        UIMSTokenCheck: function() {
            if ($('#form-uims-hit').length === 0) return;

            var gotoValue = $('#goto_token').val();

            if (gotoValue == '' || gotoValue == null) {
                $('#form-uims-hit')[0].submit();
            }
        },

        formatPhoneZip: function(form, country, type) {
            var fldPhone = form.find('input#txtPhone'),
                fldZip = form.find('input#txtZip'),
                phoneFormat = apcConfig.phoneFormat[country] ? apcConfig.phoneFormat[country] : '',
                zipFormat = apcConfig.zipFormat[country] ? apcConfig.zipFormat[country] : '',
                code = '';

            if (phoneFormat.indexOf('+') != -1) {
                code = phoneFormat.split(' ')[0] + ' ';
            }

            fldPhone.attr({ placeholder: phoneFormat }).data('rule-phonenumber', country);

            form.find('span.zip-format').text(zipFormat);

            fldZip.attr({ placeholder: zipFormat }).data('rule-zipcode', country);

            if (type === 'add') {
                fldPhone.val(code);

                fldZip.val('');
            }
        },
        /* utility methods : end */

        formValidate: function() {
            $('form').attr('autocomplete', 'off');

            /* form validation for Create an account */
            $('#form-create-account').validate();

            /* form validation for sign-in */
            $('#form-sign-in').validate();

            /* form validation for profile */
            $('#form-profile').validate({
                rules: {
                    txtCompany: {
                        required: {
                            depends: function(element) {
                                if ($('#drpCustomerType').val() == 'HomeOffice') return false; // valid scenario
                                return true;
                            },
                        },
                    },
                },
            });

            /* form validation for forgot password */
            $('#form-forgot-password').validate();

            /* form validation for reset password */
            $('#form-reset-password').validate();

            /* form validation for add address */
            $('#form-add-address').validate();

            /* form validation for payment method add address */
            $('#form-add-payment-method').validate();

            /* form validation for Tax ID */
            $('#form-taxID').validate();

            /* form validation for Vat ID */
            $('#form-vatID').validate();

            /* form validation for email modal window on order details page */
            $('#form-order-details-email').validate({
                submitHandler: function(form) {
                    var $form = $(form),
                        $emailAddrs = $form.find('#emailAddresses'),
                        $txtEmailAddress = $form.find('#txtEmailAddress');

                    $emailAddrs.val($txtEmailAddress.val());
                    form.submit();
                },
            });

            /* form validation for email modal window on mylist page */
            $('#form-mylist-email').validate({
                submitHandler: function(form) {
                    var $form = $(form),
                        email = $form.find('#taEmailAddress').val(),
                        message = $form.find('#taEmailMessage').val(),
                        arrEmail = [];

                    arrEmail = email.split(/[;,]+/);
                    for (var i in arrEmail) {
                        arrEmail[i] = $.trim(arrEmail[i]);
                    }
                    email = arrEmail.join(',');

                    $(form)
                        .find('input[name=hdnEmailAddress]')
                        .val(email);
                    $(form)
                        .find('input[name=hdnEmailMessage]')
                        .val(message);

                    form.submit();
                },
            });

            /* form validation for order-lookup */
            $('#form-order-lookup').validate({
                submitHandler: function(form) {
                    var $form = $(form),
                        $orderNum = $form.find('#orderNum'),
                        $txtOrderNumber = $form.find('#txtOrderNumber'),
                        $emailAddress1 = $form.find('#emailAddress1'),
                        $txtEmailAddress = $form.find('#txtEmailAddress');

                    $emailAddress1.val($txtEmailAddress.val());
                    $orderNum.val($txtOrderNumber.val());

                    form.submit();
                },
            });
        },

        modalWindow: function() {},

        /* Utility : end */
    };

    apcCommon.modules.push(myAccount.init);
})(jQuery);
(function($) {
    'use strict';

    productPages = {
        init: function() {
            /*
             * video carousel in product sub category page
             */
            $('div#product-videos div.slider').slick({
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                appendArrows: $('div#product-videos'),
                prevArrow: '<a href="#" class="slick-prev">Previous</a>',
                nextArrow: '<a href="#" class="slick-next">Next</a>',
            });
            /*
             * video carousel in family page
             */
            $('div#family-videos div.slider').slick({
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                appendArrows: $('div#family-videos'),
                prevArrow: '<a href="#" class="slick-prev" style="left:0">Previous</a>',
                nextArrow: '<a href="#" class="slick-next" style="right:0">Next</a>',
            });
            /*
             * Opens a new window which plays the video
             */
            $('div#product-videos div.slider-content-wrap, div#family-videos> div').on(
                'click',
                function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var url = $(this).data('embed-code');
                    var $body = $('body');
                    $body.css('overflow', 'hidden');

                    var $videoContainer = $('<div />', {
                        class: 'popup-video-container',
                    });

                    $('<div />', {
                        class: 'popup-video-shadow',
                    })
                        .appendTo($videoContainer)
                        .one('click', closeVideoPopup);

                    var $videoFrame = $('<div />', {
                        class: 'popup-video-content',
                    })
                        .hide()
                        .appendTo($videoContainer);

                    $('<div />', {
                        class: 'video-preloader',
                    }).appendTo($videoContainer);

                    $('<div />', {
                        class: 'popup-video-closer',
                    })
                        .appendTo($videoFrame)
                        .one('click', closeVideoPopup);

                    $('<iframe />', {
                        src: url,
                        frameborder: 0,
                        allowfullscreen: true,
                        width: '100%',
                        height: '100%',
                    })
                        .appendTo($videoFrame)
                        .one('load', function() {
                            $videoFrame.show();
                        });

                    $videoContainer.prependTo($('body'));

                    function closeVideoPopup() {
                        $videoContainer.remove();
                        $body.css('overflow', 'visible');
                    }
                },
            );

            /* Functionalities for Product Family Page */
            if ($('#family-page').length !== 0) {
                productPages.productFamilyPage();
            }

            productPages.contentRollUp();
        },

        /*
         * reset sticky on change of tabs, as the page height changes based on tab content
         */
        familyPageTabChange: function() {
            $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
                $('div.sticky-right-nav').trigger('stickybox:recalc');

                if ($(e.target).attr('href') === '#modelInformation') {
                    $('div#model-filter-facets').trigger('stickybox:enablesticky');
                    $('div#model-filter-facets').trigger('stickybox:recalc');
                } else {
                    $('div#model-filter-facets').trigger('stickybox:disablesticky');
                }
            });
        },

        productFamilyPage: function() {
            productPages.familyPageTabChange();

            /* functions for compare model */
            productPages.setActiveTab();
            productPages.setPartNumber();
            productPages.wattCalculator();
            productPages.estimatedRuntime();
            productPages.removeProduct();
            productPages.loadPartNumber();
            productPages.validateCompare();
            productPages.compareAddtoCart();
            productPages.btnEvents();
            productPages.initFormSubmission();
        },

        btnEvents: function() {
            var returningUser = false;
            if (typeof selectedTab !== 'undefined' && selectedTab == 'compareModels') {
                returningUser = true;
            }
            $('body').on('click', '.action-compareModel', function() {
                if (!returningUser) {
                    $('.clear-trigger').trigger('click');
                    returningUser = true;
                }
            });
        },

        setActiveTab: function() {
            if (typeof selectedTab !== 'undefined') {
                $('.apc-tabs li a').each(function(index) {
                    if (
                        $(this)
                            .attr('href')
                            .indexOf(selectedTab) >= 0
                    ) {
                        $(this).trigger('click');
                    }
                });
            }
        },

        loadPartNumber: function() {
            $('.drpProductFamily').on('change', function() {
                var family = $(this).val(),
                    PartNum = $(this)
                        .closest('div.search-panel')
                        .find('.drpPartNo'),
                    label = PartNum.data('label');
                if (typeof productJsonArray !== undefined) {
                    PartNum.empty().append('<option value="0">' + label + '</option>');
                    $.each(productJsonArray, function(idx, obj) {
                        if (obj.category == family) {
                            var products = obj.products;
                            $.each(products, function(idx, obj) {
                                $(PartNum).append(
                                    '<option value="' +
                                        obj.id +
                                        '">' +
                                        obj.displayName +
                                        '</option>',
                                );
                            });
                        }
                    });
                }
            });
        },

        initFormSubmission: function() {
            if (!('CYS' in window)) {
                return;
            }
            var siteID = $('#siteId')
                .eq(0)
                .val();
            var addToCart = CYS(siteID);
            var $forms = $('.apc-table tr td.add-to-cart form');
            $forms.on('submit', function(event) {
                event.preventDefault();
                var $this = $(this),
                    productID = $this.find('#productID').val(),
                    skuID = $this.find('#skuID').val(),
                    quantity = $this.find('#txtqty').val() || 1;
                if (!$this.valid()) {
                    return;
                }
                addToCart({
                    productID: productID,
                    skuID: skuID,
                    quantity: quantity,
                });
            });
        },

        compareAddtoCart: function() {
            $('.btn-addtoCart').on('click', function() {
                var partNo =
                    "<input type='hidden' id='partno' value='" +
                    $(this)
                        .closest('td')
                        .data('partno') +
                    "''>";
                $('#form-action').val('AddtoCart');
                $(this)
                    .closest('form')
                    .append(partNo)
                    .submit();
            });
        },

        validateCompare: function() {
            var result1 = false,
                result2 = false;

            $('#form-compare-modal').on('submit', function(event) {
                $('.drpProductFamily').each(function() {
                    if (
                        $(this)
                            .find('option:selected')
                            .index() > 0
                    ) {
                        result1 = true;
                    }
                });

                if (!result1) {
                    $('.productFamily-error-message-required').show();
                } else {
                    $('.productFamily-error-message-required').hide();
                    return true;
                }

                $('.drpPartNo').each(function() {
                    if (
                        $(this)
                            .find('option:selected')
                            .index() > 0
                    ) {
                        result2 = true;
                    }
                });

                if (!result2) {
                    $('.partNo-error-message-required').show();
                } else {
                    $('.partNo-error-message-required').hide();
                }

                return false;
            });

            $('.drpProductFamily').on('change', function() {
                if (
                    $(this)
                        .find('option:selected')
                        .index() > 0
                ) {
                    $('.productFamily-error-message-required').hide();
                }
            });

            $('.drpPartNo').on('change', function() {
                if (
                    $(this)
                        .find('option:selected')
                        .index() > 0
                ) {
                    $('.partNo-error-message-required').hide();
                }

                if (result1 && result2) {
                    $(this)
                        .closest('form')
                        .submit();
                }
            });
        },

        removeProduct: function() {
            $('.remove').on('click', function() {
                var partNo =
                    "<input type='hidden' id='partno' value='" +
                    $(this)
                        .closest('th')
                        .data('partno') +
                    "''>";
                $('#form-action').val('Remove');
                $(this)
                    .closest('form')
                    .append(partNo)
                    .submit();
            });

            $('body').on('click', '.remove-action', function(e) {
                var thisData = $(this).data();
                $('.productId-remove').val(thisData.partno);
                $('.remove-trigger').trigger('click');
                e.preventDefault();
            });
        },

        estimatedRuntime: function() {
            $('.btn-runtime').on('click', function(e) {
                var _thisWatts = $('.watts-txt').val(),
                    _thishref = $(this).attr('href'),
                    _newHref = _thishref + '&watts=' + _thisWatts;

                window.location.replace(_newHref);
                e.preventDefault();
            });
        },

        wattCalculator: function() {
            $('.convert').on('click', function() {
                $('#txtVA').valid();
                var volts = $('#txtVA').val(),
                    watts = 0;

                if (volts <= 800) {
                    watts = volts * 0.6;
                } else if (volts <= 1400) {
                    watts = volts * 0.65;
                } else if (volts <= 16000) {
                    watts = volts * 0.7;
                } else {
                    watts = volts * 1;
                }

                $('#txtWatt').val(watts);
            });
        },

        setPartNumber: function() {
            //$(".drpProductFamily").on("change")
        },

        isEmpty: function(element) {
            return !$.trim(element.html());
        },

        descriptionRollUp: function() {
            var $parent = null,
                $element = null,
                $child = null,
                i = 0,
                a = 0,
                items_in_row = 3,
                total_items = $('div.item').length,
                arrRemove = [];

            $('div.product-desc > div.description').each(function(index, element) {
                i = index + 1;
                $parent = $(element).parent();
                $element = $(element);
                $child = $(element).children('div');

                if (productPages.isEmpty($child)) {
                    $element.addClass('empty');
                    $element.next('a').hide();
                    arrRemove.push($parent);
                }

                if (i % items_in_row === 0) {
                    if (arrRemove.length === 3) {
                        for (a = 0; a < arrRemove.length; a++) {
                            arrRemove[a].hide();
                        }
                    }

                    arrRemove = [];
                } else if (i === total_items && i % items_in_row === arrRemove.length) {
                    for (a = 0; a < arrRemove.length; a++) {
                        arrRemove[a].hide();
                    }
                }
            });
        },

        sublinkRollUp: function() {
            var $parent = null,
                $element = null,
                $ul = null,
                i = 0,
                a = 0,
                items_in_row = 3,
                total_items = $('div.item').length,
                arrRemove = [];

            $('div.product-sublink > div.sublink').each(function(index, element) {
                i = index + 1;
                $parent = $(element).parent();
                $element = $(element);
                $ul = $(element).find('ul');

                if (productPages.isEmpty($ul)) {
                    $element.addClass('empty');
                    $element.next('a').hide();
                    arrRemove.push($parent);
                }

                if (i % items_in_row === 0) {
                    if (arrRemove.length === 3) {
                        for (a = 0; a < arrRemove.length; a++) {
                            arrRemove[a].addClass('hide');
                        }
                    }

                    arrRemove = [];
                } else if (i === total_items && i % items_in_row === arrRemove.length) {
                    for (a = 0; a < arrRemove.length; a++) {
                        arrRemove[a].addClass('hide');
                    }
                }
            });
        },

        buttonRollUp: function() {
            var $element = null,
                i = 0,
                a = 0,
                items_in_row = 3,
                total_items = $('div.item').length,
                arrRemove = [];

            $('div.product-help-choose').each(function(index, element) {
                i = index + 1;
                $element = $(element);

                if (productPages.isEmpty($element)) {
                    $element.addClass('empty');
                    arrRemove.push($element);
                }

                if (i % items_in_row === 0) {
                    if (arrRemove.length === 3) {
                        for (a = 0; a < arrRemove.length; a++) {
                            arrRemove[a].addClass('hide');
                        }
                    }

                    arrRemove = [];
                } else if (i === total_items && i % items_in_row === arrRemove.length) {
                    for (a = 0; a < arrRemove.length; a++) {
                        arrRemove[a].addClass('hide');
                    }
                }
            });
        },

        contentRollUp: function() {
            if ($('div#product-grid').length === 0) return;

            //if(apcCommon.isIE() !== 8) {
            productPages.descriptionRollUp();
            productPages.sublinkRollUp();
            productPages.buttonRollUp();
            //}
        },
    };

    apcCommon.modules.push(productPages.init);
})(jQuery);
(function($) {
    'use strict';

    var showMore = {
        defaults: {
            name: 'showmore',
            heightMargin: 10,
            speed: 100,
            collapsedHeight: 200,
        },

        uniqueIdCounter: 0,

        options: {},

        uniqueId: function(prefix) {
            var id = ++this.uniqueIdCounter;
            return String(prefix == null ? 'smjs-' : prefix) + id;
        },

        toggleDisplay: function(event, link, element, options) {
            event.preventDefault();

            var $element = $(element),
                newHeight = '',
                expanded = false,
                collapsedHeight = $element.data('collapsedHeight');

            if ($(link).hasClass('readmore')) {
                $(link)
                    .removeClass('readmore')
                    .addClass('readless')
                    .html(options.lessText);
                newHeight = $element.data('expandedHeight') + 'px';
                expanded = true;
            } else {
                $(link)
                    .removeClass('readless')
                    .addClass('readmore')
                    .html(options.moreText);
                newHeight = collapsedHeight;
            }

            $element.css({ height: newHeight });
            $element.attr({ 'data-link': expanded ? 'readless' : 'readmore' });

            $element.on('transitionend', function() {
                $(this)
                    .attr({
                        'data-showmore': expanded,
                        'aria-expanded': expanded,
                    })
                    .off('transitionend');

                // customization for sticky box in family page :: need to re-look into this
                if ($('div#model-filter-facets').length > 0) {
                    $('div#model-filter-facets').trigger('stickybox:recalc');
                }
                // customization for sticky box in family page :: need to re-look into this
                if ($('div.sticky-right-nav').length > 0) {
                    $('div.sticky-right-nav').trigger('stickybox:recalc');
                }
            });
        },

        /*
         * Expand the box to original height
         * Store the expanded height as data attribute
         */
        setExpandedHeight: function(element) {
            element.css({ height: 'auto' });

            var expandedHeight = element.outerHeight();

            element
                .data({
                    expandedHeight: expandedHeight,
                })
                .css({
                    maxHeight: 'none',
                });
        },

        /*
         * reset on window resize
         */
        reset: function(current) {
            var $link = current.next('a'),
                linkText = $link.html();

            $link
                .removeClass('readless')
                .addClass('readmore')
                .html(linkText.replace(/less/i, 'more'));

            current.attr({
                'data-showmore': false,
                'aria-expanded': false,
            });

            this.setExpandedHeight(current);

            var collapsedHeight = current.data('collapsedHeight');
            var heightMargin = current.data('heightMargin');

            if (current.outerHeight(true) <= collapsedHeight + heightMargin) {
                $link.hide();
                current.removeAttr('data-link');
                return true;
            } else {
                $link.show();
                current.css({ height: collapsedHeight });
                current.attr({ 'data-link': 'readmore' });
            }
        },

        showMore: function(element, options) {
            var current = $(element),
                collapsedHeight = null,
                heightMargin = null,
                id = current.attr('id') || this.uniqueId(),
                $link = current.next('a');

            current
                .data({
                    collapsedHeight: options.collapsedHeight,
                    heightMargin: options.heightMargin,
                })
                .attr({
                    'data-showmore': false,
                    'aria-expanded': false,
                    id: id,
                });

            $link.attr({ 'data-showmore-toggle': id, 'aria-controls': id });

            this.setExpandedHeight(current);

            collapsedHeight = current.data('collapsedHeight');
            heightMargin = current.data('heightMargin');

            if (current.outerHeight(true) <= collapsedHeight + heightMargin) {
                $link.hide();
                return true;
            } else {
                $link.show();
                current.css({ height: collapsedHeight });
                current.attr({ 'data-link': 'readmore' });
            }
        },

        /*
         * Truncation for Description Box
         */
        showMoreDescription: function(contentbox) {
            var options = {
                collapsedHeight: parseInt($(contentbox).css('line-height'), 10) * 3,
                heightMargin: 5,
                moreText: 'Read More',
                lessText: 'Read Less',
            };

            var $description = $(contentbox),
                $link = null;

            $description.each(function(index, element) {
                if (!$.data(this, 'plugin_' + showMore.defaults.name)) {
                    $link = $(this).next('a.readmore');

                    if ($link.data('readmore')) {
                        options.moreText = $link.data('readmore');
                        options.lessText = $link.data('readless');
                    }

                    showMore.showMore(this, options);
                    $.data(this, 'plugin_' + showMore.defaults.name, showMore.defaults.name);

                    $link.on('click', function(event) {
                        showMore.toggleDisplay(event, this, element, options);
                    });
                }
            });
        },

        /*
         * Truncation for Sublink Box
         */
        showMoreSublink: function(contentbox) {
            var options = {
                collapsedHeight: parseInt($(contentbox).css('line-height'), 10) * 3,
                heightMargin: 5,
                moreText: 'View More',
                lessText: 'View Less',
            };

            var $sublink = $(contentbox),
                $link = null;

            $sublink.each(function(index, element) {
                if (!$.data(this, 'plugin_' + showMore.defaults.name)) {
                    $link = $(this).next('a.readmore');

                    if ($link.data('readmore')) {
                        options.moreText = $link.data('readmore');
                        options.lessText = $link.data('readless');
                    }

                    showMore.showMore(this, options);
                    $.data(this, 'plugin_' + showMore.defaults.name, showMore.defaults.name);

                    $link.on('click', function(event) {
                        showMore.toggleDisplay(event, this, element, options);
                    });
                }
            });
        },

        resizeBoxes: function() {
            $('[data-showmore]').each(function() {
                var current = $(this),
                    isExpanded = current.attr('aria-expanded') === 'true';

                showMore.reset(current);
            });
        },

        init: function() {
            var contentbox = null;

            /* product grid -> product description -> non-empty */
            if ($('div#product-grid div.description:not(.empty)').length > 0) {
                contentbox = 'div#product-grid div.description:not(.empty)';
                showMore.showMoreDescription(contentbox);
            }

            /* product grid -> product sublinks -> non-empty */
            if ($('div#product-grid div.sublink:not(.empty)').length > 0) {
                contentbox = 'div#product-grid div.sublink:not(.empty)';
                showMore.showMoreSublink(contentbox);
            }

            /* family page -> family description */
            if ($('div#family-page div.description').length > 0) {
                contentbox = 'div#family-page div.description';
                showMore.showMoreDescription(contentbox);
            }

            // if (window.addEventListener) {
            //      window.addEventListener('resize', showMore.resizeBoxes);
            // } else {
            //      window.attachEvent('resize', showMore.resizeBoxes);
            // }

            //variables to confirm window height and width
            var lastWindowHeight = $(window).height();
            var lastWindowWidth = $(window).width();

            $(window).on('resize', function() {
                if (
                    $(window).height() != lastWindowHeight ||
                    $(window).width() != lastWindowWidth
                ) {
                    //set this windows size
                    lastWindowHeight = $(window).height();
                    lastWindowWidth = $(window).width();

                    //call my function
                    showMore.resizeBoxes();
                }
            });
        },
    };

    apcCommon.modules.push(showMore.init);
})(jQuery);
(function($) {
    'use strict';

    $.ApcStickyBox = function(box, options) {
        /* config parameters */
        var sticky = $(box),
            sticky_class = options.sticky_class,
            inner_scrolling = options.inner_scrolling,
            recalc_every = options.recalc_every,
            parent_selector = options.parent,
            offset_top = options.offset_top,
            //manual_spacer         = options.spacer,
            enable_bottoming = options.bottoming;

        /* dimensions */
        var parent,
            fixed = false,
            bottomed = false,
            same_height = false,
            hidden = false,
            spacer,
            parent_padding_bottom,
            parent_top,
            parent_height,
            sticky_position = sticky.css('position'),
            parent_position,
            top,
            height,
            width,
            last_pos,
            offset,
            recalc_counter,
            win = $(window);

        /* methods */
        var recalc, tick, recalc_and_tick, enablesticky, disablesticky;

        if (sticky.data('stickybox')) {
            return;
        }

        sticky.data('stickybox', true);

        if (offset_top == null) {
            offset_top = 0;
        }
        if (parent_selector == null) {
            parent_selector = void 0;
        }
        if (inner_scrolling == null) {
            inner_scrolling = true;
        }
        if (sticky_class == null) {
            sticky_class = 'is_stuck';
        }
        if (enable_bottoming == null) {
            enable_bottoming = true;
        }

        parent = sticky.parent();

        if (parent_selector != null) {
            parent = parent.closest(parent_selector);
        }

        try {
            if (!parent.length) {
                throw 'failed to find stick parent';
            }
        } catch (e) {
            return null;
        }

        parent_position = parent.css('position');

        spacer = $('<div />');
        if (spacer) {
            spacer.css('position', sticky_position);
        }

        recalc = function() {
            var parent_border_top, parent_padding_top, restore;

            // pending: is detached check

            if (hidden === true) {
                return;
            }

            /*
             * comparing parent_height (parent content area height) with element outer height, as the element(margin + padding + height) resides within parent content area
             */
            parent_border_top = parseInt(parent.css('border-top-width'), 10);
            parent_padding_top = parseInt(parent.css('padding-top'), 10);
            parent_padding_bottom = parseInt(parent.css('padding-bottom'), 10);
            parent_top = parent.offset().top + parent_border_top + parent_padding_top;
            parent_height = parent.height();

            if (fixed) {
                fixed = false;
                bottomed = false;

                spacer.detach();

                sticky
                    .css({
                        position: '',
                        top: '',
                        width: '',
                        bottom: '',
                    })
                    .removeClass(sticky_class);

                restore = true;
            }

            /* sticky.offset().top includes margin with it
             * hence it starts sticky from padding
             * hence subtracting margin from 'top', so that sticking starts from margin point
             */
            top = sticky.offset().top - parseInt(sticky.css('margin-top'), 10) - offset_top;

            /* height and width parameters are for spacer
             * since spacer is an empty div without any padding or margin
             * we have to calculate outerheight and outerwidth along with margin
             */
            height = sticky.outerHeight(true);
            width = sticky.outerWidth(true);

            if (spacer) {
                spacer.css({
                    width: width,
                    height: height,
                    display: sticky.css('display'),
                    'vertical-align': sticky.css('vertical-align'),
                });
            }

            same_height = false;
            if (height === parent_height) {
                same_height = true;
            }

            if (restore) {
                return tick();
            }
        };

        recalc();

        last_pos = void 0;
        offset = offset_top;
        recalc_counter = recalc_every;

        tick = function() {
            var css, delta, scroll, will_bottom, win_height;

            // pending: is detached check

            /* don't stick in case of sticky and parent are of same height */
            if (same_height || hidden === true) {
                return;
            }

            if (recalc_counter != null) {
                recalc_counter -= 1;

                if (recalc_counter <= 0) {
                    recalc_counter = recalc_every;
                    recalc();
                }
            }

            scroll = win.scrollTop();

            if (last_pos != null) {
                delta = scroll - last_pos;
            }

            last_pos = scroll;

            if (fixed) {
                if (enable_bottoming) {
                    will_bottom = scroll + height + offset > parent_height + parent_top;

                    if (bottomed && !will_bottom) {
                        bottomed = false;

                        parent.css({
                            position: parent_position,
                        });

                        sticky.css({
                            position: 'fixed',
                            bottom: '',
                            top: offset,
                        });
                    }
                }

                if (scroll < top) {
                    fixed = false;
                    offset = offset_top;

                    spacer.detach();

                    css = {
                        position: '',
                        width: '',
                        top: '',
                    };
                    sticky.css(css).removeClass(sticky_class);
                }

                if (inner_scrolling) {
                    win_height = win.height();

                    if (height + offset_top > win_height) {
                        if (!bottomed) {
                            offset -= delta;
                            offset = Math.max(win_height - height, offset);
                            offset = Math.min(offset_top, offset);

                            if (fixed) {
                                sticky.css({
                                    top: offset + 'px',
                                });
                            }
                        }
                    }
                }
            } else {
                if (scroll > top) {
                    fixed = true;

                    css = {
                        position: 'fixed',
                        top: offset,
                    };

                    css.width =
                        sticky.css('box-sizing') === 'border-box'
                            ? sticky.outerWidth() + 'px'
                            : sticky.width() + 'px';
                    sticky.css(css).addClass(sticky_class);
                    sticky.after(spacer);
                }
            }

            if (fixed && enable_bottoming) {
                if (will_bottom == null) {
                    will_bottom = scroll + height + offset > parent_height + parent_top;
                }

                if (!bottomed && will_bottom) {
                    bottomed = true;

                    if (parent.css('position') === 'static') {
                        parent.css({
                            position: 'relative',
                        });
                    }

                    sticky.css({
                        position: 'absolute',
                        bottom: parent_padding_bottom,
                        top: 'auto',
                    });
                }
            }
        };

        recalc_and_tick = function() {
            recalc();
            return tick();
        };

        enablesticky = function() {
            hidden = false;
        };

        disablesticky = function() {
            hidden = true;
        };

        /* events */
        win.on('scroll', tick);
        win.on('resize', recalc_and_tick);
        sticky.on('stickybox:recalc', recalc_and_tick);
        sticky.on('stickybox:enablesticky', enablesticky);
        sticky.on('stickybox:disablesticky', disablesticky);
        return setTimeout(tick, 0);
    };

    $.ApcStickyBox.defaults = {
        sticky_class: 'is_stuck',
        inner_scrolling: null,
        recalc_every: null,
        parent: null,
        offset_top: null,
        spacer: null,
        bottoming: null,
    };

    $.fn.stickybox = function(options) {
        if (!options) {
            options = {};
        }
        options = $.extend({}, $.ApcStickyBox.defaults, options);

        return this.each(function() {
            new $.ApcStickyBox(this, options);
        });
    };

    var stickyBox = {
        init: function() {
            if ($('div.model-filter-facets').length !== 0) {
                $('div.model-filter-facets').stickybox({
                    inner_scrolling: false,
                });
            }

            if ($('div.sticky-right-nav').length !== 0) {
                $('div.sticky-right-nav').stickybox({
                    recalc_every: 5,
                    parent: '#sticky-container',
                });
            }
        },
    };
    //remove stucky box for mobile view
    if (
        !(
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent,
            ) || $(window).width() <= 767
        )
    ) {
        apcCommon.modules.push(stickyBox.init);
    }
})(jQuery);
(function($) {
    'use strict';
    pdp = {
        init: function() {
            /*The init function will have modulewise function calls.*/
            pdp.functionals();
        },

        functionals: function() {
            /*All methods specific to pdp page will be invoked from here*/
            if ($('#pdp').length > 0) {
                pdp.pdpCarousel();
                pdp.wishListCarousel();
                pdp.gallery();
                pdp.formValidate();
                pdp.addToCart();
                pdp.OptionsTabFunctionalities();
                pdp.QuantityValidation();
                pdp.invokeOptionsTab();
                pdp.certificates();
                pdp.onMainFormSubmit();

                $('#txtComments').on('blur', function() {
                    var value = $(this)
                        .val()
                        .replace(/\n/g, '<br/>');
                    $('#txtCommentsHidden').val(value);
                });
            }
        },

        pdpCarousel: function() {
            /*carousel for related products */
            $('.relatedProdPanel #related-products div.slider').slick({
                dots: false,
                infinite: false,
                speed: 500,
                slidesToShow: 3,
                slidesToScroll: 1,
                appendArrows: $('.relatedProdPanel #related-products'),
                prevArrow: '<a href="#" class="slick-prev">Previous</a>',
                nextArrow: '<a href="#" class="slick-next">Next</a>',
            });
        },

        
        QuantityValidation: function() {
            $('#txtqty').on('change input', function() {
                $(this).valid();
            });
        },

        manageFilterData: function(interfaceType, familyId, pageSize, pageCount) {
            var sku_id = skuId || '';
            var contextPath = $('#contextRoot').val();
            var config = {
                data: {
                    skuId: sku_id,
                    interfaceType: interfaceType,
                    pageSize: pageSize,
                    familyId: familyId,
                    pageCount: pageCount,
                },
                dataType: 'html',
                url: contextPath + '/catalog/includes/productOptionDetailsAjax.jsp',
                method: 'GET',
            };

            var filterData = apcData.get(config, '', true);

            filterData.done(function(data) {
                apcData.hideAjaxLoader();
                $('.filterContent')
                    .empty()
                    .append(data);
                apcCommon.enableButtons();
            });
        },

        OptionsTabFunctionalities: function() {
            $('body').on('click', '.pagination li a', function(e) {
                e.preventDefault();
                var interfaceType = $('#category').val(),
                    familyId = $('#subCategory').val(),
                    pageSize = $('#pageSize').val(),
                    pageCount = $(this).text();
                pdp.manageFilterData(interfaceType, familyId, pageSize, pageCount);
            });
            $('body').on('change', '#pageSize', function() {
                var interfaceType = $('#category').val(),
                    familyId = $('#subCategory').val(),
                    pageSize = $('#pageSize').val(),
                    pageCount = 1;
                pdp.manageFilterData(interfaceType, familyId, pageSize, pageCount);
            });

            $('#category').on('change', function() {
                if (typeof categoryJsonArray !== undefined) {
                    $('#subCategory').empty();
                    $('#subCategory').append('<option value="All">All sub-Categories</option>');
                    var categoryVal = $(this).val();
                    $.each(categoryJsonArray, function(idx, obj) {
                        if (obj.category == categoryVal) {
                            var subcategories = obj.subCategories;
                            $.each(subcategories, function(idx, obj) {
                                $('#subCategory').append(
                                    '<option value="' +
                                        obj.id +
                                        '">' +
                                        obj.displayName +
                                        '</option>',
                                );
                            });
                        }
                    });
                }
            });

            $('#category, #subCategory ').on('change', function() {
                var interfaceType = $('#category').val(),
                    familyId = $('#subCategory').val(),
                    pageSize = $('#pageSize').val(),
                    pageCount = 1;
                pdp.manageFilterData(interfaceType, familyId, pageSize, pageCount);
            });
        },

        onMainFormSubmit: function() {
            if (!('CYS' in window)) {
                return;
            }
            var $form = $('#form-pdp');
            var siteID = $form.find('#siteId').val();
            var addToCart = CYS(siteID);
            $form.on('submit', function(event) {
                if (!$(this).valid()) {
                    return;
                }
                event.preventDefault();
                var $this = $(this),
                    qtyValue = $this.find('#txtqty').val(),
                    productID = $this.find('#productID').val(),
                    skuID = $this.find('#skuID').val();
                addToCart({
                    productID: productID,
                    skuID: skuID,
                    quantity: qtyValue,
                });
            });
        },

        addToCart: function() {
            $('#addtoCart').on('click', function(e) {
                e.preventDefault();
                $(this)
                    .closest('form')
                    .submit();
            });
        },

        wishListCarousel: function() {
            $('#addtowishList').on('hide.bs.modal', function(e) {
                var $relatedproducts = $('#addtowishList #wishlist-related-products');
                $relatedproducts.find('div.slider').slick('unslick');
            });

            $('#addtowishList').on('shown.bs.modal', function(e) {
                var $relatedproducts = $('#addtowishList #wishlist-related-products');
                $relatedproducts.find('div.slider').slick({
                    dots: false,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    appendArrows: $('#addtowishList #wishlist-related-products'),
                    prevArrow: '<a href="#" class="slick-prev">Previous</a>',
                    nextArrow: '<a href="#" class="slick-next">Next</a>',
                });
            });
        },
        invokeOptionsTab: function() {
            $('.viewAllOptional, .js-invoke-tab').on('click', function() {
                var tabId = $(this).attr('href');
                $('.tabContainer a[href=' + tabId + ']').trigger('click');
            });
        },

        getFormattedDate: function() {
            var monthNames = [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ];
            var date = new Date();
            var year = date.getFullYear();
            var month = monthNames[date.getMonth()];
            month = month.length > 1 ? month : '0' + month;
            var day = date.getDate().toString();
            day = day.length > 1 ? day : '0' + day;
            return month + ' ' + day + ', ' + year;
        },

        gallery: function() {
            /*$('.previews a').on('click', function(e){
                Image zoom with thumbnail
                e.preventDefault();
                var largeImage = $(this).attr('data-full');
                console.log(largeImage);
                $('.previews a.selected').removeClass('selected');
                $(this).addClass('selected');
                $('.product img').hide();
                $('.product img').attr('src', largeImage);
                $('.product img').fadeIn();
            }); */
        },

        certificates: function() {
            if ($('div#rewardsMain > div.rewards-wrap').children().length === 0) {
                $('div.main-area').css({
                    width: '100%',
                });
            }
        },

        formValidate: function() {
            $('form').attr('autocomplete', 'off');

            /* form validation for Write a review */
            $('#form-writeReview').validate({
                submitHandler: function() {
                    pdp.setReviewSuccessData();
                },
            });
            $('#form-pdp').validate();
            $('#form-pdp-email').validate();
        },
    };
    if ('div#pdp'.length > 0) {
        apcCommon.modules.push(pdp.init);
    }
})(jQuery);
(function($) {
    'use strict';

    miniCart = {
        container: '#header-cart,#view-cart',

        cart_timer: 5 * 1000,
        cart_timeout: null,

        init: function() {
            miniCart.miniCart();
            miniCart.ajaxMiniCart();
            miniCart.resizeMiniCartOverlay();
            miniCart.promptWindow();
        },

        resizeMiniCartOverlay: function() {
            $(window).on('resize', function() {
                var divBlockPageCart = $('div#block-page-cart'),
                    pageHeight = $(document).height(),
                    pageWidth = $(window).width();

                if (divBlockPageCart.is(':visible')) {
                    divBlockPageCart.css({
                        height: pageHeight,
                        width: pageWidth,
                    });
                }
            });
        },

        promptWindow: function() {
            $('body').on('click', '#header-country a', function(e) {
                var thisEle = $(this).data('message'),
                    getMinicartItems = $('#mini-cart .product-details').length;
                if (getMinicartItems > 0) {
                    if (confirm(thisEle) == false) {
                        e.preventDefault();
                    }
                }
            });
        },

        miniCart: function() {
            var $divBlockPageCart = $('div#block-page-cart'),
                $liViewCart = $(miniCart.container),
                $miniCart = $('div#mini-cart');

            $liViewCart.on(
                'hover',
                function() {
                    var pageHeight = $(document).height(),
                        pageWidth = $(window).width();

                    clearTimeout(miniCart.cart_timeout);

                    $divBlockPageCart.css({
                        display: 'block',
                        height: pageHeight,
                        width: pageWidth,
                    });

                    $(this).addClass('open');
                    $miniCart.fadeIn('fast');
                },
                function() {
                    miniCart.cart_timeout = setTimeout(function() {
                        $miniCart.fadeOut('fast', function() {
                            $liViewCart.removeClass('open');
                            $divBlockPageCart.hide();
                        });
                    }, miniCart.cart_timer);
                },
            );

            $miniCart.on(
                'hover',
                function() {
                    clearTimeout(miniCart.cart_timeout);
                },
                function() {
                    miniCart.cart_timeout = setTimeout(function() {
                        $miniCart.fadeOut('fast', function() {
                            $liViewCart.removeClass('open');
                            $divBlockPageCart.hide();
                        });
                    }, miniCart.cart_timer);
                },
            );

            $divBlockPageCart.on('click', function() {
                clearTimeout(miniCart.cart_timeout);

                $miniCart.fadeOut('fast', function() {
                    $liViewCart.removeClass('open');
                    $divBlockPageCart.hide();
                });
            });
        },

        showCart: function() {
            clearTimeout(miniCart.cart_timeout);

            var $divBlockPageCart = $('div#block-page-cart'),
                $liViewCart = $(miniCart.container),
                $miniCart = $('div#mini-cart'),
                pageHeight = $(document).height(),
                pageWidth = $(window).width();

            $divBlockPageCart.css({
                display: 'block',
                height: pageHeight,
                width: pageWidth,
            });

            $liViewCart.addClass('open');
            $miniCart.fadeIn('fast');

            miniCart.cart_timeout = setTimeout(function() {
                $liViewCart.removeClass('open');
                $miniCart.fadeOut('fast');
                $divBlockPageCart.hide();
            }, miniCart.cart_timer);
        },

        ajaxMiniCart: function() {
            $('body').on('submit', '.ajax-form', function(e) {
                e.preventDefault();

                var formData = $(this).serialize(),
                    _formUrl = $(this).attr('action'),
                    config = {
                        url: _formUrl,
                        dataType: 'html',
                        data: formData,
                    };

                var promiseAddToCart = apcData.get(config, '', true);

                promiseAddToCart.done(function(data, textStatus, jqXHR) {
                    miniCart.updateMiniCart(data);
                });

                promiseAddToCart.fail(function(jqXHR, textStatus, errorThrown) {
                    apcCommon.createMessageBarWithClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                });
            });

            /*
             * Quantity validation
             */
            $('#txtqty').on('change', function() {
                $('.tradeups-addtocart-form').valid();
            });

            /*
             * Mini cart and slider update for Trade UPS
             */
            $('body').on('submit', '.tradeups-addtocart-form', function(e) {
                e.preventDefault();

                // Changing addItemToOrderSuccessURL to the action URL of the form
                // to avoid redirect in ajax request
                var form = $(this);
                form.find('[name$="addItemToOrderSuccessURL"]').each(function(i, el) {
                    // if not special ATG field
                    if ($(el).attr('name')[0] !== '_') {
                        $(el).val(form.attr('action').split('?', 2)[0]);
                        return false;
                    }
                });

                var cartdata = $(this).serialize(),
                    currentQuantity = $('#txtqty').val(),
                    carturl = $(this).attr('action'),
                    tradeinvadata = $(this)
                        .find('input.btn-tradeups-addcart')
                        .data(),
                    skuid = $(this)
                        .find('input.btn-tradeups-addcart')
                        .data('sku'),
                    productid = $(this)
                        .find('input.btn-tradeups-addcart')
                        .data('product'),
                    tradeinvaurl = $(this)
                        .find('input.btn-tradeups-addcart')
                        .data('tradeinva-url'),
                    cartconfig = {
                        url: carturl,
                        dataType: 'html',
                        data: cartdata,
                    },
                    vaconfig = {
                        url: tradeinvaurl,
                        dataType: 'json',
                        data: {
                            items: tradeinvadata,
                            skuid: skuid,
                            productid: productid,
                            currentQuantity: currentQuantity,
                        },
                    },
                    tradeInVA = 0,
                    cartresponse = null,
                    tradeinvaresponse = null,
                    allowAdd = true;

                /* check if added VA value would exceed maximum value */
                allowAdd = tradeFilter.allowAddTradeIn(tradeinvadata.value);
                if (!allowAdd) {
                    $('#mdlDisallowAdd').modal('show');
                    return;
                }

                var prmAddToCart = apcData.get(cartconfig, '', true);

                var prmTradeInVA = prmAddToCart.then(
                    function(data) {
                        cartresponse = data;
                        return apcData.get(vaconfig, '', false);
                    },
                    function(jqXHR, textStatus, errorThrown) {
                        return jqXHR;
                    },
                );

                prmTradeInVA
                    .done(function(data) {
                        tradeinvaresponse = data;

                        miniCart.updateMiniCart(cartresponse);

                        tradeInVA = tradeFilter.updateTradeInVA(tradeinvaresponse.value || 0);
                        tradeinvaresponse['value'] = tradeInVA;
                        tradeFilter.updateRangeVal(tradeinvaresponse);
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        //apcCommon.createMessageBarNoClose('error', errorThrown);
                        apcData.hideAjaxLoader();
                        $('html, body').animate({ scrollTop: 0 }, 'slow');
                    });
            });
        },

        updateMiniCart: function() {
            if (window.refreshMiniCartItems) {
                window.refreshMiniCartItems();
            }

            apcData.hideAjaxLoader();
            miniCart.showCart();
            $('html,body').animate({ scrollTop: 0 }, 500);
        },
    };

    if ($(miniCart.container).length > 0) {
        apcCommon.modules.push(miniCart.init);
    }
})(jQuery);
(function($) {
    'use strict';

    checkout = {
        container: '#checkout',

        init: function() {
            checkout.shippingGuestUsers();
            checkout.shippingLoggedUsers();
            checkout.payment();
            checkout.orderReview();
            checkout.orderConfirmation();
            checkout.formValidate();
        },

        /*
         * Update shipping methods
         */
        setShippingMethods: function(details) {
            var config = {
                data: details,
                dataType: 'html',
                url: $('#drpShippingMethod').data('url'),
            };

            return apcData.get(
                config,
                'Please wait, while we are getting shipping methods...',
                true,
            );
        },

        /*
         * fetch order details
         * Update shipping methods
         */
        getOrderDetails: function(_url) {
            var details = {
                city: $('#txtCity').val(),
                state: $('#drpState').val(),
                zip: $('#txtZip').val(),
                countryCode: $('#countryCode').val(),
                shippingmethod: $('#drpShippingMethod').val(),
            };

            var config = {
                data: details,
                dataType: 'html',
                url: _url,
            };

            var prmShippingMethod = checkout.setShippingMethods(details);

            var prmOrderDetails = prmShippingMethod.then(
                function(data, textStatus, jqXHR) {
                    /* update the shipping methods */
                    $('select#drpShippingMethod').html($(data).html());

                    /* Trigger second ajax call to calculate and update order summary panel */
                    details.shippingmethod = $('#drpShippingMethod').val();
                    return apcData.get(
                        config,
                        'Please wait, while we are calculating your order details...',
                        true,
                    );
                },
                function(jqXHR, textStatus, errorThrown) {
                    /* return error object in case of failure */
                    return jqXHR;
                },
            );

            prmOrderDetails.then(
                function(data, textStatus, jqXHR) {
                    /* update order details panel in case of success */
                    $('#order-summary')
                        .empty()
                        .append($(data));

                    /* reinitialize tool tips */
                    $('#order-summary [data-toggle="tooltip"]').tooltip();

                    apcData.hideAjaxLoader();
                    var isSabrixElementEmpty = !$('#repriceExceptionsData').children().length;

                    $('html, body').animate(
                        {
                            scrollTop: !isSabrixElementEmpty
                                ? 0
                                : $('#order-details-panel').offset().top,
                        },
                        'slow',
                    );
                },
                function(jqXHR, textStatus, errorThrown) {
                    /* show error panel in case of failure */
                    apcCommon.createMessageBarNoClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                },
            );
        },

        /*
         * Manage shipping for guest users
         */
        shippingGuestUsers: function() {
            if ($('div.shipping-guest-user').length === 0) return;

            /* form submission of click of 'continue payment' button */
            var $formGuestUser = $('#form-shipping-guest-user');

            if ($('#top-continue-payment').length > 0 && $('#bottom-continue-payment').length > 0) {
                $('#top-continue-payment, #bottom-continue-payment').on('click', function(e) {
                    e.preventDefault();

                    if ($formGuestUser.valid()) {
                        $formGuestUser.submit();
                    } else {
                        $formGuestUser.data('validator').focusInvalid();
                    }
                });
            }

            /* update order details for valid city, state, zipcode and shipping method */
            var emea = $('div.emea'),
                validator = null,
                id = null,
                $city = $('input#txtCity'),
                $state = $('#drpState').length === 0 ? $('#txtState') : $('#drpState'),
                $zip = $('#txtZip'),
                _url = apcConfig.orderdetailsurl;

            $('input#txtCity, select#drpState, input#txtZip, select#drpShippingMethod').on(
                'change',
                function(e) {
                    validator = validator === null ? $formGuestUser.data('validator') : validator;
                    id = $(this).attr('id');

                    /*
                     * For EMEA countries, since there is no state/province
                     * the tax will be calculated based on the site country
                     * hence no AJAX call is required on change of city, zip and state except shipping method
                     */
                    if (emea.length !== 0 && $(e.target).attr('id') !== 'drpShippingMethod') {
                        return;
                    }

                    switch (id) {
                        case 'txtCity':
                            if (validator.element('#' + id)) {
                                if ($state.hasClass('valid') && $zip.hasClass('valid')) {
                                    checkout.getOrderDetails(_url);
                                }
                            }
                            break;

                        case 'drpState':
                            if (validator.element('#' + id)) {
                                if ($city.hasClass('valid') && $zip.hasClass('valid')) {
                                    checkout.getOrderDetails(_url);
                                }
                            }
                            break;

                        case 'txtZip':
                            if (validator.element('#' + id)) {
                                if ($city.hasClass('valid') && $state.hasClass('valid')) {
                                    checkout.getOrderDetails(_url);
                                }
                            }
                            break;

                        case 'drpShippingMethod':
                            if (validator.element('#' + id)) {
                                if (
                                    emea.length !== 0 ||
                                    ($city.hasClass('valid') &&
                                        $state.hasClass('valid') &&
                                        $zip.hasClass('valid'))
                                ) {
                                    checkout.getOrderDetails(_url);
                                }
                            }
                            break;
                    }
                },
            );
        },

        /*
         * Validation:
         * In case of address list, one address should be selected
         * In case of no address, user should save the address
         */
        selectShippingAddress: function() {
            var form = $('#form-select-shipping-address'),
                validator = null,
                formShippingLoggedUser = $('#form-shipping-logged-user');

            $('#top-continue-payment, #bottom-continue-payment').on('click', function() {
                if ($('input[name=rdShipTo]').length > 0) {
                    if ($('input[name=rdShipTo]:checked').length > 0) {
                        $('div.error-panel').addClass('hide');

                        /*
                         * If user has selected the address, then validate the form below
                         */
                        if (formShippingLoggedUser.valid()) {
                            formShippingLoggedUser.submit();
                        }
                    } else {
                        $('div.error-panel').removeClass('hide');
                        $('html, body').animate({ scrollTop: 0 }, 'fast');
                    }
                } else {
                    validator = validator === null ? form.data('validator') : validator;
                    if (validator.checkForm()) {
                        $('div.error-panel').addClass('hide');
                    } else {
                        $('div.error-panel').removeClass('hide');
                        $('html, body').animate({ scrollTop: 0 }, 'fast');
                    }
                }
            });

            /* Hide error panel on selection of radio button */
            $('input[name=rdShipTo]').on('change', function() {
                $('div.error-panel').addClass('hide');
                // Highlight selected shipping address for mobile view
                $('#form-shipping-logged-user div.address').removeClass('highlight');
                $(this)
                    .closest('div.address')
                    .addClass('highlight');
            });
        },

        /*
         * Get order details on selection of address from the saved address list
         */
        getShippingOrderDetails: function() {
            /*
             * For EMEA on entering valid VAT ID
             * the order panel will be updated
             */
            $('body').on('change', '#txtVatId', function() {
                if (!$('#txtVatId').valid()) return;

                var data = {
                    vatid: $('#txtVatId').val(),
                    shippingmethod: $('#drpShippingMethod').val(),
                };

                var vatTypeEl = $('#vat-dropdown');

                if (vatTypeEl) {
                    data.userVatIdType = vatTypeEl.val();
                }

                var config = {
                    data: data,
                    dataType: 'html',
                    url: apcConfig.orderdetailsurl,
                };

                apcCommon.getVatIdServiceStatus(config, data);
            });

            /*
             * For NAM on change of radio button - ajax to trigger setting of shipping method, updation of order panel and tax panel
             * For EMEA no ajax call
             */
            $('body').on('change', 'input[name=rdShipTo]', function(e) {
                if ($('div.emea').length !== 0) return;

                var details = { addresskey: '', shippingmethod: '' },
                    shippingconfing = {},
                    orderconfig = {},
                    taxconfig = {},
                    _shippingurl = $('#drpShippingMethod').data('url'),
                    _orderurl = apcConfig.orderdetailsurl,
                    _taxurl = apcConfig.taxexcemptionurl;

                details['shippingmethod'] = $('#drpShippingMethod').val();
                details['addresskey'] = $('input[name=rdShipTo]:checked').val();

                shippingconfing = {
                    data: details,
                    dataType: 'html',
                    url: _shippingurl,
                };

                orderconfig = {
                    data: details,
                    dataType: 'html',
                    url: _orderurl,
                };

                taxconfig = {
                    data: details,
                    dataType: 'html',
                    url: _taxurl,
                };

                var prmShippingMethod = apcData.get(
                    shippingconfing,
                    'Please wait, while we are getting shipping methods...',
                    true,
                );

                var prmOrderDetails = prmShippingMethod.then(
                    function(shippingmethod) {
                        /* update the shipping methods */
                        $('select#drpShippingMethod').html($(shippingmethod).html());

                        details['shippingmethod'] = $('#drpShippingMethod').val();

                        return apcData.get(
                            orderconfig,
                            'Please wait, while we are calculating your order details...',
                            true,
                        );
                    },
                    function(jqXHR, textStatus, errorThrown) {
                        return jqXHR;
                    },
                );

                var prmTaxDetails = prmOrderDetails.then(
                    function(orderdata) {
                        $('#order-summary')
                            .empty()
                            .append($(orderdata));

                        /* reinitialize tool tips */
                        $('#order-summary [data-toggle="tooltip"]').tooltip();

                        return apcData.get(taxconfig, '', false);
                    },
                    function(jqXHR, textStatus, errorThrown) {
                        return jqXHR;
                    },
                );

                prmTaxDetails
                    .done(function(taxdata) {
                        $('div.order-history-table')
                            .empty()
                            .append($(taxdata));

                        apcData.hideAjaxLoader();

                        $('html, body').animate({ scrollTop: 0 }, 'slow');
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        apcCommon.createMessageBarNoClose('error', errorThrown);
                        apcData.hideAjaxLoader();
                        $('html, body').animate({ scrollTop: 0 }, 'slow');
                    });
            });

            /*
             * For EMEA on change of Shipping Method dropdown, no check for radio button selection is done
             */
            $('body').on('change', '#drpShippingMethod', function(e) {
                var details = { addresskey: '', shippingmethod: '' },
                    config = {},
                    _url = apcConfig.orderdetailsurl;

                if ($('div.emea').length === 0) {
                    if ($('input[name=rdShipTo]:checked').length === 0) return;
                }

                details['shippingmethod'] = $('#drpShippingMethod').val();
                details['addresskey'] =
                    $('input[name=rdShipTo]:checked').length !== 0
                        ? $('input[name=rdShipTo]:checked').val()
                        : '';

                config = {
                    data: details,
                    dataType: 'html',
                    url: _url,
                };

                var prmOrderDetails = apcData.get(
                    config,
                    'Please wait, while we are calculating your order details...',
                    true,
                );

                /* update order details panel in case of success */
                prmOrderDetails.done(function(data) {
                    $('#order-summary')
                        .empty()
                        .append($(data));

                    /* reinitialize tool tips */
                    $('#order-summary [data-toggle="tooltip"]').tooltip();

                    apcData.hideAjaxLoader();

                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                });

                /* show error panel in case of failure */
                prmOrderDetails.fail(function(jqXHR, textStatus, errorThrown) {
                    apcCommon.createMessageBarNoClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                });
            });
        },

        /*
         * Action to save address to user's profile in case of empty address list
         */
        saveNewAddress: function() {
            var form = $('#form-select-shipping-address'),
                data = form.serialize();

            var config = {
                data: data,
                dataType: 'html',
                url: 'stubs/addresslist.html',
            };

            var prmSaveNewAddress = apcData.get(config, 'Please wait...', true);

            /* update address list panel in case of success */
            prmSaveNewAddress.done(function(data) {
                setTimeout(function() {
                    $('#form-select-shipping-address').html(data);
                    apcData.hideAjaxLoader();
                }, 5000);
            });

            /* show error panel in case of failure */
            prmSaveNewAddress.fail(function(jqXHR, textStatus, errorThrown) {
                apcCommon.createMessageBarNoClose('error', errorThrown);
                apcData.hideAjaxLoader();
            });
        },

        /*
         * populate the form in the modal window with address in case if edit address
         */
        addEditAddress: function() {
            if ($('#mdlAddAddress').length === 0 && $('#mdlEditAddress').length === 0) return;

            $('div#mdlAddAddress').on('hide.bs.modal', function() {
                $('form.add-address-modal')
                    .data('validator')
                    .resetForm(); // reset form
            });

            $('div#mdlEditAddress').on('hide.bs.modal', function() {
                $('form.edit-address-modal')
                    .data('validator')
                    .resetForm(); // reset form
            });

            $('div#mdlAddAddress').on('show.bs.modal', function() {
                var form = $('form.add-address-modal'),
                    fldCountry = form.find('input.hdn-country'),
                    state = '';

                /* reset the form */
                form[0].reset();
                form.find('.state-dropdown, .state-textbox').hide();

                /* state list population */
                apcCommon.populateStates(fldCountry.get(0), state);
            });

            $('div#mdlEditAddress').on('show.bs.modal', function(e) {
                var link = $(e.relatedTarget),
                    form = $('form.edit-address-modal'),
                    fldCountry = form.find('input.hdn-country'),
                    address = link.closest('div.address'),
                    country = address.find('input[name="hdnCountry"]').val(),
                    state = address.find('input[name="hdnState"]').val();

                /* reset the form */
                form[0].reset();
                form.find('.state-dropdown, .state-textbox').hide();

                //address.find("input[name='rdShipTo']").prop('checked', true);

                form.find('#txtFirstName').val(address.find('input[name="hdnFirstName"]').val());
                form.find('#txtLastName').val(address.find('input[name="hdnLastName"]').val());
                form.find('#txtCompany').val(address.find('input[name="hdnCompany"]').val());
                form.find('#hdnStaticCountry').val(country);
                form.find('#txtAddress1').val(address.find('input[name="hdnAddress1"]').val());
                form.find('#txtAddress2').val(address.find('input[name="hdnAddress2"]').val());
                form.find('#txtCity').val(address.find('input[name="hdnCity"]').val());
                form.find('#txtZip').val(address.find('input[name="hdnZip"]').val());
                form.find('#txtPhone').val(address.find('input[name="hdnPhone"]').val());
                form.find('#phoneEdit').val(address.find('input[name="hdnPhone"]').val());
                form.find('#postalEdit').val(address.find('input[name="hdnZip"]').val());
                form.find('#txtExtn').val(address.find('input[name="hdnExtn"]').val());
                form.find('#txtEmail').val(address.find('input[name="hdnEmail"]').val());
                form.find('#hdnNickName').val(address.find('input[name="hdnNickName"]').val());
                form.find('#txtState').val(state);
                form.find('#userState').val(state);

                form.find('div.primary-delivery-address').removeClass('hide');
                if (address.find('input[name="hdnPrimaryAddress"]').val() === 'true') {
                    form.find('div.primary-delivery-address').addClass('hide');
                }

                /* state list population */
                apcCommon.populateStates(fldCountry.get(0), state);
            });
        },

        /* Tax ID : start */
        invokeCalendar: function() {
            /* Invoke Calendar for Tax ID  */
            if ($('#datetimepicker').length >= 1) {
                var today = new Date();
                $('#datetimepicker')
                    .datepicker({
                        format: 'mm/dd/yyyy',
                        startDate: today,
                    })
                    .on('change', function() {
                        var dateElement = $(this);
                        dateElement.valid(); // triggers the validation test on change
                        $('#txtdatetimepicker').val(dateElement.val());
                        $('.datepicker').hide();
                    });
                $('#datetimepicker')
                    .datepicker()
                    .on('show', function() {
                        var modal = $(this).closest('.modal');
                        var datePicker = $('body').find('.datepicker');
                        if (!modal.length) {
                            $(datePicker).css('z-index', 'auto');
                            return;
                        }
                        var zIndexModal = $(modal).css('z-index');
                        $(datePicker).css('z-index', zIndexModal + 1);
                    });
            }
        },

        manageTaxExcemption: function() {
            $('#taxType').val($("input[name='radTaxExcem']:checked").val());
            /* Cosmetic functionality for Tax ID  */
            $('#drpCountry').on('change', function(event) {
                var taxExcemption = $('.taxExcemption');
                var currentTargetVal = $(event.target).val();
                // reset form
                $('#form-taxID')
                    .data('validator')
                    .resetForm();
                $('#drpStateExemption')
                    .prop('disabled', true)
                    .val('');
                $('#drpProvinceExemption')
                    .prop('disabled', true)
                    .val('');
                $("input[name='radTaxExcem']")
                    .eq(0)
                    .prop('checked', true);
                $('#taxType').val($("input[name='radTaxExcem']:checked").val());

                if ($.trim(currentTargetVal)) {
                    taxExcemption.show();
                } else {
                    taxExcemption.hide();
                }

                $.ajax({
                    method: 'POST',
                    cache: 'false',
                    dataType: 'json',
                    url: contextPath + '/myaccount/generateStateList.jsp',
                    data: { country: currentTargetVal },
                }).done(function(data) {
                    var setStateorProvince = function(elementId) {
                        $.each(data, function(index, value) {
                            var selected = '';
                            if (value.code == $('#' + elementId).val()) {
                                selected = 'selected';
                            }
                            $('#' + elementId).append(
                                '<option value="' +
                                    value.code +
                                    '" ' +
                                    selected +
                                    '>' +
                                    value.displayName +
                                    '</option>',
                            );
                        });
                    };
                    if (currentTargetVal == 'US') {
                        setStateorProvince('drpStateExemption');
                        $('.stateTaxExcem').show();
                        $('.provinceTaxExcem').hide();
                        $('.TaxExcemption-group').show();
                        //$(".EMEA-group").hide();
                    } else if (currentTargetVal == 'CA') {
                        setStateorProvince('drpProvinceExemption');
                        $('.stateTaxExcem').hide();
                        $('.provinceTaxExcem').show();
                        //$(".EMEA-group").hide();
                        $('.TaxExcemption-group').show();
                    } else {
                        setStateorProvince('drpEMEAExemption');
                        //$(".EMEA-group").show();
                        $('.TaxExcemption-group').hide();
                    }
                });
            });

            $("input[name='radCertiExpiry']").on('click', function() {
                $('#txtdatetimepicker').val('');

                if ($(this).data('function') === 'never') {
                    $('#datetimepicker')
                        .prop('disabled', true)
                        .val('');
                } else {
                    $('#datetimepicker')
                        .prop('disabled', false)
                        .val('');
                }
            });

            $("input[name='radTaxExcem']").on('click', function() {
                $('#taxState').val('');
                $('#txtdatetimepicker').val('');
                var elementSelected = $(this);
                var radiofunction = $(elementSelected).data('function');
                $('#taxType').val(elementSelected.val());
                if (radiofunction === 'stateTaxExcem') {
                    $('#drpStateExemption').prop('disabled', false);
                } else if (radiofunction === 'provinceTaxExcem') {
                    $('#drpProvinceExemption').prop('disabled', false);
                } else {
                    $('#drpStateExemption, #drpProvinceExemption').valid(); // to remove error message for State Excemption dropdown

                    $('#drpStateExemption, #drpProvinceExemption').prop('disabled', true);
                }
            });

            $('.drptaxState').on('change', function() {
                $('#taxState').val($(this).val());
            });

            $('div#mdlTaxExcemption').on('show.bs.modal', function(e) {
                if (e.target.id != 'datetimepicker') {
                    $('.taxExcemption').hide();
                    $('#drpCountry').val(0);
                    $('#mdlTaxExcemption')
                        .find('.errorPanel .error-message')
                        .hide();
                }
            });

            $('body').on('click', '.tax-submit', function(e) {
                e.preventDefault();
                var form = $('#form-taxID'),
                    countryName = form.find('#drpCountry').val(),
                    taxType = form.find('#taxType').val(),
                    txtExemptionID = form.find('#txtExemptionID').val(),
                    taxState = form.find('#taxState').val(),
                    txtdatetimepicker = form.find('#txtdatetimepicker').val(),
                    taxExpiry = form.find('#taxExpiry').val();
                var formUrl = apcConfig.addtaxIdurl;
                if (!form.valid()) return false;
                var config = {
                    data: {
                        countryName: countryName,
                        taxType: taxType,
                        txtExemptionID: txtExemptionID,
                        taxState: taxState,
                        txtdatetimepicker: txtdatetimepicker,
                        taxExpiry: taxExpiry,
                    },
                    dataType: 'html',
                    url: formUrl,
                };
                const customEvent = new CustomEvent('tax-id-submit', {
                    bubbles: true,
                    cancelable: false,
                });
                this.dispatchEvent(customEvent);

                var promisedTaxExcemption = apcData.get(config, '', true);
                promisedTaxExcemption.done(function(data, textStatus, jqXHR) {
                    // TODO figure out if it is possible to use JSON.parse instead of eval
                    var obj = eval('(' + data + ')');

                    var result = obj.success;
                    if (result === 'error') {
                        $('#mdlTaxExcemption')
                            .find('.errorPanel .error-message')
                            .html(obj.errorMessage);
                        $('#mdlTaxExcemption')
                            .find('.errorPanel .error-message')
                            .show();
                        apcData.hideAjaxLoader();
                    } else {
                        checkout.updateTaxPanel();
                    }
                });

                /*var config = {
                        data: data,
                        dataType: "html",
                        url: 'stubs/taxExcemption.php'
                    };

                var promisedTaxExcemption = apcData.get(config, "", true);

                //update Tax Excemption panel on success
                promisedTaxExcemption.done(function (data, textStatus, jqXHR) {
                        if($(data).hasClass("error-message")){
                            $("#mdlTaxExcemption").find(".errorPanel").html(data);
                        }
                        else{
                            $(".tax-excemption-container").html(data);
                            $("#mdlTaxExcemption").modal("hide");

                        }
                    apcData.hideAjaxLoader();
                    $("#form-taxID").data('validator').resetForm(),
                    $("#drpStateExemption").prop("disabled", true).val(""),
                    $("#drpProvinceExemption").prop("disabled", true).val(""),
                    $("input[name='radTaxExcem']").eq(0).prop('checked', true),
                    $("#datetimepicker").val(""),
                    $("#txtExemptionID").val(""),
                    $("#drpCountry").val(0),
                    $(".taxExcemption").hide();
                    //form.submit();
                });*/
            });
        },

        updateTaxPanel: function() {
            var _url = apcConfig.taxexcemptionurl;
            var config = {
                dataType: 'html',
                url: _url,
            };

            var promisedTaxExcemption = apcData.get(config, '', true);

            promisedTaxExcemption.done(function(data, textStatus, jqXHR) {
                $('div.order-history-table').empty();
                $('div.order-history-table').html(data);
                $('#mdlTaxExcemption').modal('hide');
                apcData.hideAjaxLoader();
                $('#form-taxID')
                    .data('validator')
                    .resetForm(),
                    $('#drpStateExemption')
                        .prop('disabled', true)
                        .val(''),
                    $('#drpProvinceExemption')
                        .prop('disabled', true)
                        .val(''),
                    $("input[name='radTaxExcem']")
                        .eq(0)
                        .prop('checked', true),
                    $('#datetimepicker').val(''),
                    $('#txtExemptionID').val(''),
                    $('#drpCountry').val(0),
                    $('.taxExcemption').hide();
                //form.submit();
            });
        },

        /*
         * Set as primary address
         */
        setAsPrimaryAddress: function() {
            var config = {};

            $('body').on('click', 'a.set-primary-address', function(e) {
                e.preventDefault();

                /* v1 : form submit
                var address = $(this).closest('div.address'),
                    form = $("form#form-primary-shipping");

                form.find("input[name='hdnNickName']").val( address.find("input[name='hdnNickName']").val() );
                form[0].submit();
                */

                /* v2 : ajax call */
                var lnkPrimary = $(this),
                    address = lnkPrimary.closest('div.address'),
                    form = lnkPrimary.closest('form'),
                    addresskey = address.find('input[type=radio]').val(),
                    details = { addresskey: addresskey },
                    config = {
                        data: details,
                        dataType: 'html',
                        url: apcConfig.addresssetprimaryurl,
                    };

                var prmSetPrimary = apcData.get(config, 'Please wait...', true);

                /* set primary shipping address for respective panel and show 'Set as primary' for other panels */
                prmSetPrimary.done(function(data, textStatus, jqXHR) {
                    form.find('span.set-primary-address')
                        .removeClass('hide')
                        .show();
                    lnkPrimary.parent().hide();

                    form.find('span.primary-shipping').hide();
                    address
                        .find('span.primary-shipping')
                        .removeClass('hide')
                        .show();

                    apcData.hideAjaxLoader();
                });

                /* show error panel in case of failure */
                prmSetPrimary.fail(function(jqXHR, textStatus, errorThrown) {
                    apcCommon.createMessageBarNoClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                    $('html, body').animate({ scrollTop: 0 }, 'slow');
                });
            });
        },

        /*
         * Manage shipping for Logged users
         */
        shippingLoggedUsers: function() {
            if ($('div.shipping-logged-user').length === 0) return;

            checkout.selectShippingAddress();
            checkout.getShippingOrderDetails();
            checkout.addEditAddress();
            checkout.invokeCalendar();
            checkout.manageTaxExcemption();
            checkout.setAsPrimaryAddress();
        },

        /*
         * hide error message on change of tab
         */
        toggleErrorMessage: function() {
            var $formPurchaseOrder = $('#form-payment-purchaseorder');
            var validatorPurchaseOrder = null;

            $('a[data-toggle="tab"]').on('hide.bs.tab', function(e) {
                if ($(e.target).attr('href') == '#credit-card') {
                    $('div.error-panel').addClass('hide');
                } else if ($(e.target).attr('href') == '#purchase-order') {
                    validatorPurchaseOrder =
                        validatorPurchaseOrder === null
                            ? $formPurchaseOrder.data('validator')
                            : validatorPurchaseOrder;
                    validatorPurchaseOrder.resetForm(); // reset form
                    $formPurchaseOrder[0].reset();
                }
            });
        },

        /*
         * enable / disable of 'Continue to review' button
         * hide 'Continue to review' button for - Guest User/Logged User with no saved credit cards
         */
        toggleButton: function(usertype) {
            $('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
                if ($(e.target).attr('href') == '#credit-card') {
                    if ($('div.select-creditcard').length === 0) {
                        $('#top-continue-review, #bottom-continue-review').addClass('hide');
                    }
                } else {
                    $('#top-continue-review, #bottom-continue-review').removeClass('hide');
                }
            });
        },

        /*
         * Manage payment for guest users
         */
        paymentGuestUsers: function() {
            var validator = null,
                $form = $('#form-payment-addcreditcard'),
                fldCountry = $form.find('select.drp-country'),
                state = '';

            checkout.toggleButton('guest-user');

            /* form validation on click on 'continue to review' button */
            $('#top-continue-review, #bottom-continue-review').on('click', function() {
                var $formCreditCard = $('#form-payment-selectcreditcard'),
                    $formPaymentBankTransfer = $('#form-payment-banktransfer'),
                    $tabCreditCard = $('#credit-card'),
                    $tabBankTransfer = $('#bank-transfer'),
                    $tabPurchaseOrder = $('#purchase-order'),
                    $formPaymentPurchaseOrder = $('#form-payment-purchaseorder');

                if ($tabCreditCard.hasClass('active')) {
                    $formCreditCard[0].submit();
                }

                if ($tabPurchaseOrder.hasClass('active')) {
                    if ($formPaymentPurchaseOrder.valid()) {
                        $formPaymentPurchaseOrder[0].submit();
                    }
                }

                if ($tabBankTransfer.hasClass('active')) {
                    $formPaymentBankTransfer[0].submit();
                }
            });
        },

        /*
         * Validation: To select credit card
         * In case of credit card list, one credit card should be selected
         * In case of no credit card, user should save the credit card
         */
        selectPaymentMethodValidate: function() {
            var $formPaymentSelectCreditCard = $('#form-payment-selectcreditcard'),
                $formPaymentPurchaseOrder = $('#form-payment-purchaseorder'),
                $formPaymentBankTransfer = $('#form-payment-banktransfer'),
                $tabCreditCard = $('#credit-card'),
                $tabPurchaseOrder = $('#purchase-order'),
                $tabBankTransfer = $('#bank-transfer'),
                token = null;

            /* form validation on click on 'continue to review' button */
            $('#top-continue-review, #bottom-continue-review').on('click', function() {
                if ($tabCreditCard.hasClass('active')) {
                    /* credit card list available */
                    if ($("input[name='rdCreditCard']").length > 0) {
                        if ($('input[name=rdCreditCard]:checked').length > 0) {
                            $('div.error-panel').addClass('hide');
                            token = $('input[name=rdCreditCard]:checked').val();

                            $formPaymentSelectCreditCard.find('input[name=hdnToken]').val(token);
                            $formPaymentSelectCreditCard[0].submit();
                        } else {
                            $('div.error-panel').removeClass('hide');
                            $('html, body').animate({ scrollTop: 0 }, 'fast');
                        }
                    } else {
                        /* Not required as 'Continue to Review' button will be disabled
                        if ( validatorPaymentSelectCreditCard.checkForm() ) {
                            $( "div.error-panel" ).addClass( 'hide' );
                        } else {
                            $( "div.error-panel" ).removeClass( 'hide' );
                            $("html, body").animate({ scrollTop: 0 }, "fast");
                        }
                        */
                    }
                } else if ($tabPurchaseOrder.hasClass('active')) {
                    if ($formPaymentPurchaseOrder.valid()) {
                        $formPaymentPurchaseOrder[0].submit();
                    }
                } else if ($tabBankTransfer.hasClass('active')) {
                    $formPaymentBankTransfer[0].submit();
                }
            });

            /* Hide error panel on selection of radio button */
            $('input[name=rdCreditCard]').on('change', function() {
                $('div.error-panel').addClass('hide');
                $('#select-creditcard div.address').removeClass('highlight');
                $(this)
                    .closest('div.address')
                    .addClass('highlight');
            });
        },

        /*
         * populate the form in the modal window with creditcard in case if edit creditcard
         */
        addEditCrediCard: function() {
            if ($('#mdlAddPaymentMethod').length === 0) return;

            $('div#mdlAddPaymentMethod').on('hide.bs.modal', function() {
                $('form#form-payment-addcreditcard')
                    .data('validator')
                    .resetForm(); // reset form
            });

            $('div#mdlAddPaymentMethod').on('show.bs.modal', function(e) {
                var link = $(e.relatedTarget),
                    form = $('form#form-payment-addcreditcard'),
                    creditcard = link.closest('div.address'),
                    country = creditcard.find('input[name="hdnCountry"]').val(),
                    fldCountry = form.find('select.drp-country'),
                    state = creditcard.find('input[name="hdnState"]').val();

                /* reset the form */
                form[0].reset();
                form.find('#billing-address').addClass('hide');
                form.find('#same-as-shipping').removeClass('hide');
                form.find('div.add-payment-method').removeClass('hide');
                form.find('div.edit-payment-method').addClass('hide');

                if (link.hasClass('edit')) {
                    creditcard.find("input[name='rdCreditCard']").prop('checked', true);

                    form.find('div.add-payment-method').addClass('hide');
                    form.find('div.edit-payment-method').removeClass('hide');

                    form.find('#disCardType').text(
                        creditcard.find('input[name="hdnCardType"]').val(),
                    );
                    form.find('#disNameOnCard').text(
                        creditcard.find('input[name="hdnNameOnCard"]').val(),
                    );
                    form.find('#disCreditCardNumber').text(
                        creditcard.find('input[name="hdnCreditCardNumber"]').val(),
                    );
                    form.find('#drpExpMonth').val(
                        creditcard.find('input[name="hdnExpMonth"]').val(),
                    );
                    form.find('#drpExpYear').val(creditcard.find('input[name="hdnExpYear"]').val());
                    form.find('#txtSecurityCode').val(
                        creditcard.find('input[name="hdnSecurityCode"]').val(),
                    );

                    form.find('#billing-address').removeClass('hide');
                    form.find('#same-as-shipping').addClass('hide');

                    form.find('#txtFirstName').val(
                        creditcard.find('input[name="hdnFirstName"]').val(),
                    );
                    form.find('#txtLastName').val(
                        creditcard.find('input[name="hdnLastName"]').val(),
                    );
                    form.find('#txtCompany').val(creditcard.find('input[name="hdnCompany"]').val());
                    form.find('#txtAddress1').val(
                        creditcard.find('input[name="hdnAddress1"]').val(),
                    );
                    form.find('#txtAddress2').val(
                        creditcard.find('input[name="hdnAddress2"]').val(),
                    );
                    form.find('#txtCity').val(creditcard.find('input[name="hdnCity"]').val());
                    form.find('#txtZip').val(creditcard.find('input[name="hdnZip"]').val());
                    form.find('#txtPhone').val(creditcard.find('input[name="hdnPhone"]').val());
                    form.find('#phoneEdit').val(creditcard.find('input[name="hdnPhone"]').val());
                    form.find('#postalEdit').val(creditcard.find('input[name="hdnZip"]').val());
                    form.find('#txtExtn').val(creditcard.find('input[name="hdnExtn"]').val());
                    form.find('#txtEmail').val(creditcard.find('input[name="hdnEmail"]').val());
                    form.find('#drpCountry').val(country);

                    /* states list population */
                    form.find('.state-dropdown, .state-textbox').hide();
                    if ($.trim(fldCountry[0].value)) {
                        apcCommon.populateStates(fldCountry.get(0), state);
                    }
                }
            });
        },

        /*
         * action on click of 'Make Primary' and 'Not my primary'
         */
        primaryDesignation: function() {
            /* make as primary payment method */
            $('a.make-primary').on('click', function(e) {
                e.preventDefault();

                var lnkPrimary = $(this),
                    key = lnkPrimary.data('key'),
                    _url = lnkPrimary.data('url'),
                    payment_wrap = lnkPrimary.closest('div.select-creditcard'),
                    payment_method = lnkPrimary.closest('div.address'),
                    details = { key: key },
                    config = {
                        data: details,
                        dataType: 'html',
                        url: _url,
                    },
                    $message_bar = $('div#notice-panel > div.message-bar-noclose');

                var prmMakePrimary = apcData.get(config, 'Please wait...', true);

                /* set primary payment method for respective panel and show 'Set as primary' for other panels */
                prmMakePrimary.done(function(data, textStatus, jqXHR) {
                    $message_bar.hide();

                    payment_wrap
                        .find('a.make-primary')
                        .removeClass('hide')
                        .show();
                    lnkPrimary.hide();

                    payment_wrap.find('a.not-primary').hide();
                    payment_method
                        .find('a.not-primary')
                        .removeClass('hide')
                        .show();

                    payment_wrap.find('span.primary-payment').hide();
                    payment_method
                        .find('span.primary-payment')
                        .removeClass('hide')
                        .show();

                    apcData.hideAjaxLoader();
                });

                /* show error panel in case of failure */
                prmMakePrimary.fail(function(jqXHR, textStatus, errorThrown) {
                    apcCommon.createMessageBarNoClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                });
            });

            /* make as non-primary payment method */
            $('a.not-primary').on('click', function(e) {
                e.preventDefault();

                var lnkNotPrimary = $(this),
                    key = lnkNotPrimary.data('key'),
                    _url = lnkNotPrimary.data('url'),
                    payment_wrap = lnkNotPrimary.closest('div.select-creditcard'),
                    payment_method = lnkNotPrimary.closest('div.address'),
                    details = { key: key },
                    config = {
                        data: details,
                        dataType: 'html',
                        url: _url,
                    },
                    $message_bar = $('div#notice-panel > div.message-bar-noclose');

                var prmMakePrimary = apcData.get(config, 'Please wait...', true);

                /* set primary payment method for respective panel and show 'Set as primary' for other panels */
                prmMakePrimary.done(function(data, textStatus, jqXHR) {
                    $message_bar.hide();

                    lnkNotPrimary.hide();
                    payment_method.find('span.primary-payment').hide();
                    payment_method
                        .find('a.make-primary')
                        .removeClass('hide')
                        .show();

                    apcData.hideAjaxLoader();
                });

                /* show error panel in case of failure */
                prmMakePrimary.fail(function(jqXHR, textStatus, errorThrown) {
                    apcCommon.createMessageBarWithClose('error', errorThrown);
                    apcData.hideAjaxLoader();
                });
            });
        },

        /*
         * Manage payment for logged users
         */
        paymentLoggedUsers: function() {
            checkout.toggleButton('payment-user');
            checkout.selectPaymentMethodValidate();
            checkout.addEditCrediCard();
            checkout.primaryDesignation();
        },

        copyAddress: function() {
            $('#btn-submit-csrequest').on('click', function() {
                var $formCreditCard_copyAddress = $('#copyaddress-form-payment-cybersource'),
                    $formCreditCard = $('#form-payment-cybersource'),
                    flag = $('input#cc-copyShippingAddr').is(':checked');
                if (flag) {
                    $formCreditCard_copyAddress[0].submit();
                } else {
                    $formCreditCard[0].submit();
                }
            });

            $('input[name=po_copyShippingAddr]').on('click', function(e) {
                var formFrom = $('form#po-shipping-addr-form'),
                    formTo = $('form#form-payment-purchaseorder'),
                    flag = $('input#po_copyShippingAddr').is(':checked');
                if (flag) {
                    formTo.find('#txtFirstName').val(formFrom.find('#s_firstName').val());
                    formTo.find('#txtLastName').val(formFrom.find('#s_lastName').val());
                    formTo.find('#txtCompany').val(formFrom.find('#s_company_org').val());
                    formTo.find('#txtAddress1').val(formFrom.find('#s_address1').val());
                    formTo.find('#txtAddress2').val(formFrom.find('#s_address2').val());
                    formTo.find('#txtCity').val(formFrom.find('#s_city').val());
                    formTo.find('#drpState').val(formFrom.find('#s_state').val());
                    formTo.find('#txtZip').val(formFrom.find('#s_zip').val());
                    formTo.find('#txtPhone').val(formFrom.find('#s_phone').val());
                    formTo.find('#phone').val(formFrom.find('#s_phone').val());
                    formTo.find('#txtExtn').val(formFrom.find('#s_ext').val());
                    formTo.find('#txtEmail').val(formFrom.find('#s_email').val());
                } else {
                    formTo.find('#txtFirstName').val('');
                    formTo.find('#txtLastName').val('');
                    formTo.find('#txtCompany').val('');
                    formTo.find('#txtAddress1').val('');
                    formTo.find('#txtAddress2').val('');
                    formTo.find('#txtCity').val('');
                    formTo.find('#drpState').val('');
                    formTo.find('#txtZip').val('');
                    formTo.find('#txtPhone').val('');
                    formTo.find('#phone').val('');
                    formTo.find('#txtExtn').val('');
                    formTo.find('#txtEmail').val('');
                }
            });
        },

        /*
         * Manage payment
         */
        payment: function() {
            if ($('div.payment').length === 0) return;

            /* credit card tab to be shown by default */
            // $('#tab-payment-method a[href="#credit-card"]').tab('show');

            checkout.toggleErrorMessage();
            checkout.copyAddress();

            if ($('div.guest-user').length !== 0) {
                checkout.paymentGuestUsers();
            } else if ($('div.logged-user').length !== 0) {
                checkout.paymentLoggedUsers();
            }
        },

        /*
         * Manage checkout order review
         */
        orderReview: function() {
            if ($('div.order-review').length === 0) return;

            var $formOrderReview = $('#form-co-order-review'),
                validator = null;

            /* form submission of click of top 'place order' button */
            $('#top-place-order, #bottom-place-order').on('click', function() {
                validator = validator === null ? $formOrderReview.data('validator') : validator;

                if ($formOrderReview.valid()) {
                    const customEvent = new CustomEvent('place-order', {
                        bubbles: true,
                        cancelable: false,
                    });
                    this.dispatchEvent(customEvent);
                    $formOrderReview.submit();
                } else {
                    validator.focusInvalid();
                    $('html, body').animate(
                        { scrollTop: $('div.link-section:eq(1)').offset().top },
                        'slow',
                    );
                }
            });
        },

        /*
         * Manage checkout order confirmation
         */
        orderConfirmation: function() {
            if ($('div.order-confirmation').length === 0) return;

            /*
             * Reset the email modal window on close
             */
            $('#mdlEmail').on('hide.bs.modal', function() {
                $('#form-order-confirmation-email')
                    .data('validator')
                    .resetForm(); // reset form
                $('#form-order-confirmation-email')[0].reset();
            });
        },

        /*
         * clubs all the form valiations hete
         */
        formValidate: function() {
            $('form').attr('autocomplete', 'off');

            /* form validation for sign-in panel in checkout page (guest user) */
            $('#form-co-sign-in').validate();

            /* form validation for guest user form */
            $('#form-shipping-guest-user').validate();

            /* form validation for order review form */
            $('#form-co-order-review').validate();

            /* form validation for shipping - logged user */
            $('#form-shipping-logged-user').validate();

            /* form validation for shipping - select address */
            $('#form-select-shipping-address').validate({
                submitHandler: function(form) {
                    /* For new address - the shipping method is passed as hidden value along with the address form */
                    if ($('div.new-address').length !== 0 && $('#drpShippingMethod').length !== 0) {
                        $(form)
                            .find('input[name=hdnShippingMethod]')
                            .val($('#drpShippingMethod').val());
                    }

                    form.submit();
                },
            });

            /* form validation for add/edit shipping address */
            $('#form-shipping-add-address').validate({
                submitHandler: function(form) {
                    const customEvent = new CustomEvent('shipping-add-address', {
                        bubbles: true,
                        cancelable: false,
                    });
                    form.dispatchEvent(customEvent);
                    form.submit();
                },
            });
            $('#form-shipping-edit-address').validate({
                submitHandler: function(form) {
                    const customEvent = new CustomEvent('shipping-edit-address', {
                        bubbles: true,
                        cancelable: false,
                    });
                    form.dispatchEvent(customEvent);
                    form.submit();
                },
            });

            /* form validation for payment method - add credit card */
            $('#form-payment-addcreditcard').validate();

            /* form validation for payment method - purchase order */
            $('#form-payment-purchaseorder').validate();

            /* form validation for order confirmation - email modal window */
            $('#form-order-confirmation-email').validate({
                submitHandler: function(form) {
                    var $form = $(form),
                        $txtSenderName = $form.find('#txtSenderName'),
                        $txtSenderEmail = $form.find('#txtSenderEmail'),
                        $txtReceiverName = $form.find('#txtReceiverName'),
                        $txtReceiverEmail = $form.find('#txtReceiverEmail'),
                        $txtComments = $form.find('#txtComments'),
                        $senderName = $form.find('#senderName'),
                        $senderEmailAddresses = $form.find('#senderEmailAddresses'),
                        $recieverName = $form.find('#recieverName'),
                        $recieverEmailAddresses = $form.find('#recieverEmailAddresses'),
                        $senderComments = $form.find('#senderComments');

                    $senderName.val($txtSenderName.val());
                    $senderEmailAddresses.val($txtSenderEmail.val());
                    $recieverName.val($txtReceiverName.val());
                    $recieverEmailAddresses.val($txtReceiverEmail.val());
                    $senderComments.val($txtComments.val());

                    form.submit();
                },
            });

            /*$("#form-taxID").validate({

            submitHandler: function (form) {
            var config = {
                        data: data,
                        dataType: "html",
                        url: 'stubs/taxExcemption.php'
                    };

                var promisedTaxExcemption = apcData.get(config, "", true);

                 //update Tax Excemption panel on success
                promisedTaxExcemption.done(function (data, textStatus, jqXHR) {
                        if($(data).hasClass("error-message")){
                            $("#mdlTaxExcemption").find(".errorPanel").html(data);
                        }
                        else{
                            $(".tax-excemption-container").html(data);
                            $("#mdlTaxExcemption").modal("hide");

                        }
                    apcData.hideAjaxLoader();
                    $("#form-taxID").data('validator').resetForm(),
                    $("#drpStateExemption").prop("disabled", true).val(""),
                    $("#drpProvinceExemption").prop("disabled", true).val(""),
                    $("input[name='radTaxExcem']").eq(0).prop('checked', true),
                    $("#datetimepicker").val(""),
                    $("#txtExemptionID").val(""),
                    $("#drpCountry").val(0),
                    $(".taxExcemption").hide();
                    //form.submit();
                });
            }
            });*/
        },
    };

    if ($(checkout.container).length > 0) {
        apcCommon.modules.push(checkout.init);
    }
})(jQuery);
(function($) {
    'use strict';

    var sessionExpiryFlag = true;

    sessionExpiryFlag = typeof v_SessionTimeout == 'undefined' ? false : true;

    sessionExpiry = {
        interval: 1, // call the timer every minute
        idleTime: 0, // timer to detect idle time
        idleInterval: null,
        sessionTimeout: typeof v_SessionTimeout == 'undefined' ? null : v_SessionTimeout, // time of session expiry
        sessionTimeoutWarning: typeof v_SessionPopupTime == 'undefined' ? null : v_SessionPopupTime, // time to show the warning modal issue
        $modalSessionExpiry: $('#mdlSessionExpiry'),
        $btnSessionCancel: null,
        $btnSessionContinue: null,
        activeUrl: '',
        redirectUrl: '',
        loginCheckUrl: '',
        setSessionURL: '',

        /*
         * redirect to login page
         */
        redirectPage: function() {
            window.location = sessionExpiry.redirectUrl;
        },

        /*
         * Send request to the server to keep the session alive
         */
        pingServer: function() {
            $.get(sessionExpiry.activeUrl, function() {
                //console.log( "Session reactivated..." );
            });
        },

        /*
         * Send session variable to the backend
         */
        setSessionValue: function() {
            $.get(sessionExpiry.setSessionURL, function() {
                //console.log( "Session reactivated..." );
            });
        },

        /*
         * Login Check
         */
        loginCheck: function() {
            return $.ajax({
                type: 'POST',
                url: sessionExpiry.loginCheckUrl,
            });
        },

        /*
         * extend the session on click on continue button
         * if the user has already logged out, then redirect the user to login page
         * if the user session is active, then reactivate the session
         */
        sessionExtend: function() {
            var prmLoginCheck = sessionExpiry.loginCheck();

            prmLoginCheck.done(function(profileStatus) {
                if (profileStatus === true) {
                    sessionExpiry.redirectPage();
                } else {
                    sessionExpiry.idleTime = 0;
                    //console.log( "Session extended..." + sessionExpiry.idleTime);
                    sessionExpiry.$modalSessionExpiry.modal('hide');
                    sessionExpiry.pingServer();
                }
            });

            prmLoginCheck.fail(function() {
                sessionExpiry.idleTime = 0;
                //console.log( "Session extended..." + sessionExpiry.idleTime);
                sessionExpiry.$modalSessionExpiry.modal('hide');
                sessionExpiry.pingServer();
            });
        },

        /*
         * show session expiry warning modal window
         */
        sessionWarning: function() {
            /*
            var minutesForExpiry = parseInt(sessionExpiry.sessionTimeout) - parseInt(sessionExpiry.sessionTimeoutWarning),
                message = "Your session will expire in another " + minutesForExpiry + " mins. Do you want to extend the session?";

            if (sessionExpiry.$modalSessionExpiry.length > 0) {
                sessionExpiry.$modalSessionExpiry
                    .find("p.message")
                    .html(message);
            }
            */

            sessionExpiry.$modalSessionExpiry.modal({
                backdrop: 'static',
                show: true,
            });
        },

        /*
         * cancel check
         */
        sessionCancel: function() {
            //console.log("page redirect");
            var prmLoginCheck = sessionExpiry.loginCheck();
            prmLoginCheck.done(function(profileStatus) {
                if (profileStatus === true) {
                    sessionExpiry.redirectPage();
                } else {
                    //sessionExpiry.$btnSessionCancel.click();
                    $('#form-session-expiry')[0].submit();
                }
            });

            prmLoginCheck.fail(function() {
                //sessionExpiry.$btnSessionCancel.click();
                $('#form-session-expiry')[0].submit();
            });
        },

        /*
         * increment the timer
         * show the modal window when 'sessionTimeoutWarning' is reached
         */
        timerIncrement: function() {
            sessionExpiry.idleTime++;
            //console.log(sessionExpiry.idleTime);

            var sessionTimeoutWarning = parseInt(sessionExpiry.sessionTimeoutWarning, 10),
                sessionTimeout = parseInt(sessionExpiry.sessionTimeout, 10);

            if (sessionExpiry.idleTime === sessionTimeoutWarning) {
                //console.log("Modal window shown");
                sessionExpiry.sessionWarning();
            } else if (sessionExpiry.idleTime >= sessionTimeout) {
                //This is to set the session value so that the same can be used after UIMS logout
                sessionExpiry.setSessionValue();
                sessionExpiry.sessionCancel();
            }
        },

        init: function() {
            sessionExpiry.activeUrl = sessionExpiry.$modalSessionExpiry.data('active-url');
            sessionExpiry.redirectUrl = sessionExpiry.$modalSessionExpiry.data('redirect-url');
            sessionExpiry.loginCheckUrl = sessionExpiry.$modalSessionExpiry.data('logincheck-url');
            sessionExpiry.setSessionURL = sessionExpiry.$modalSessionExpiry.data('set-session');

            sessionExpiry.$btnSessionCancel = sessionExpiry.$modalSessionExpiry.find(
                '#btnSessionCancel',
            );
            sessionExpiry.$btnSessionContinue = sessionExpiry.$modalSessionExpiry.find(
                '#btnSessionContinue',
            );

            sessionExpiry.$btnSessionContinue.on('click', sessionExpiry.sessionExtend);
            sessionExpiry.$btnSessionCancel.on('click', sessionExpiry.sessionCancel);

            sessionExpiry.idleInterval = setInterval(
                sessionExpiry.timerIncrement,
                parseInt(sessionExpiry.interval, 10) * 60 * 1000,
            );

            //$(document).bind('click mouseup mousedown keydown keypress keyup submit change mouseenter scroll resize dblclick', function (event) {
            $(document).bind(
                'click  keydown keypress keyup submit change resize dblclick',
                function() {
                    sessionExpiry.idleTime = 0;
                    //console.log( "Event observed..." + sessionExpiry.idleTime);
                },
            );
        },
    };

    if (sessionExpiry.$modalSessionExpiry.length > 0 && sessionExpiryFlag === true) {
        apcCommon.modules.push(sessionExpiry.init);
    }
})(jQuery);
(function($) {
    'use strict';

    tradeFilter = {
        rangeSelector: '.range-selector',

        init: function() {
            var options = {
                add: '.add-btn',
                remove: '.remove-btn',
                cancel: '.reset',
                addAnother: '.add-another-btn',
            };
        },

        /*
         * set values on page load
         * set 'Number of TradeIns', 'Total VA', 'Min' and 'Max' slider values
         */
        setRange: function() {
            var getItem = $('input#tradeUps').val() || null,
                tradeInVA = $('input#tradeInVA').val() || null,
                data = JSON.parse(getItem) || [],
                minVal = 0,
                maxVal = 0;

            if (!tradeInVA && getItem) {
                $('input#tradeInVA').val(0);
                tradeInVA = 0;
            }

            tradeInVA = parseInt(tradeInVA, 10);

            $.each(data, function(index, value) {
                minVal += parseInt(value[3], 10);
            });

            maxVal = minVal * 4;

            $('span#num-tradeins').html(data.length);
            $('span#va-total').html(minVal + ' VA');
            $('span.min-val').html(minVal + ' VA');
            $('span.max-val').html(maxVal + ' VA');

            $('.range-bar').data('min', minVal);
            $('.range-bar').data('max', maxVal);
            $('.range-bar').data('value', tradeInVA);
        },

        /*
         * Set the button state if its VA value would exceed the max value upon adding
         */
        setButtonState: function() {
            var va_value;

            if ($('div#pdp').length !== 0) {
                va_value = $('form.tradeups-addtocart-form')
                    .find('input[type=submit]')
                    .data('value');

                if (!tradeFilter.allowAddTradeIn(va_value)) {
                    $('form.tradeups-addtocart-form')
                        .find('input[type=submit]')
                        .prop('disabled', true);
                }
            }
        },

        /*
         *   filter range init
         */
        rangeInit: function(value) {
            var rangeData = {};

            tradeFilter.setRange();
            tradeFilter.setButtonState();

            rangeData = $('.range-bar').data();
            tradeFilter.updateRangeVal(rangeData);

            tradeFilter.cartEvent();
        },

        /*
         *   filter range: show Message
         */
        showMessage: function(scope) {
            $('.mod-trade-ups')
                .find('.alert')
                .addClass('hide');
            $('.mod-trade-ups')
                .find(scope)
                .removeClass('hide');
        },

        /*
         *   filter range events
         */
        cartEvent: function() {
            $('body').on('click', '.btn-add-cart', function(e) {
                var _thisData = $(this).data();
                tradeFilter.addToCart(_thisData);
                e.preventDefault();
            });
        },

        /*
         * update trade-in VA
         */
        updateTradeInVA: function(value) {
            var tradeInVA = parseInt($('input#tradeInVA').val(), 10);

            tradeInVA += parseInt(value, 10);
            $('input#tradeInVA').val(tradeInVA);
            $('.range-bar').data('value', tradeInVA);

            return tradeInVA;
        },

        /*
         *   filter range event add to cart button ajax call and loader show hide.
         */
        addToCart: function(data) {
            var minicartConfig = {
                data: {
                    items: data,
                },
                type: 'POST',
                url: 'stubs/addCart.php',
            };

            var config = {
                    data: {
                        items: data,
                    },
                    type: 'POST',
                    url: 'stubs/addCart.php',
                },
                tradeInVA = 0;

            var sendItem = apcData.get(config, '', true);
            sendItem.done(function(data) {
                apcData.hideAjaxLoader();
                tradeInVA = tradeFilter.updateTradeInVA(data.value);
                data['value'] = tradeInVA;
                tradeFilter.updateRangeVal(data);
            });
        },

        /*
         *   Update range based on return value from json
         */
        updateRange: function(value, type) {
            var rangeEle = $('.range-bar'),
                minValue = rangeEle.data('min'),
                maxValue = rangeEle.data('max'),
                tradeInVA = value || 0,
                percent = 0,
                range = maxValue - minValue,
                addToCartButtonSelector = '#addtoCart';
            // newval = (tradeInVA/maxValue)*100;

            if (tradeInVA === 0 && minValue === 0 && maxValue === 0) {
                $('.btn-step').addClass('disabled');
                $(tradeFilter.rangeSelector).removeClass('max min');
            } else {
                if (tradeInVA >= minValue && tradeInVA < maxValue) {
                    percent = ((tradeInVA - minValue) * 100) / range;
                    $(tradeFilter.rangeSelector)
                        .removeClass('max')
                        .addClass('min');
                    tradeFilter.showMessage('.alert-success');
                    $('.btn-step').removeClass('disabled');
                    if ($(addToCartButtonSelector).length) {
                        const itemValue = +$(addToCartButtonSelector).data('value');
                        if (tradeInVA + itemValue >= maxValue) {
                            $(addToCartButtonSelector).addClass('disabled');
                        }
                    }
                } else if (tradeInVA >= maxValue) {
                    percent = 100;
                    tradeFilter.showMessage('.alert-warning.max');
                    $('.btn-step').removeClass('disabled');
                    $(tradeFilter.rangeSelector)
                        .removeClass('min')
                        .addClass('max');

                    /* disable the add to cart button when max has reached */
                    $(addToCartButtonSelector).addClass('disabled');
                } else {
                    // tradeFilter.showMessage('.alert-warning');
                    $('.btn-step').addClass('disabled');
                    $(tradeFilter.rangeSelector).removeClass('max min');
                }
            }

            $('.handle').css({
                // 'left': (percent - (percent * 0.2)) + '%'
                left: percent + '%',
            });
        },

        /*
         *   Update range value for texts and scroll animate after add to cart are here
         */
        updateRangeVal: function(data) {
            $('body').animate(
                {
                    scrollTop: 0,
                },
                500,
                function() {
                    tradeFilter.updateRange(data.value);
                    if (data.value) {
                        $('.info-panel .total-val').text(data.value);
                    }
                    if (data.totalItems) {
                        $('.info-panel .total-items').html(data.totalItems);
                    }
                },
            );
        },

        /*
         * check if added VA value would exceed maximum value
         */
        allowAddTradeIn: function(value) {
            var maxValue = $('.range-bar').data('max'),
                currValue = parseInt($('input#tradeInVA').val(), 10);

            if (currValue + value > maxValue) return false;
            return true;
        },
    };
    if ($(tradeFilter.rangeSelector).length > 0) {
        apcCommon.modules.push(tradeFilter.rangeInit);
    }
})(jQuery);
(function($) {
    'use strict';

    /**
     * [toggleSlider description]
     * @type {Object}
     * Auto slider with custom options. Slider speec is controlled by data-speed attribute defined in the container element.
     */
    toggleSlider = {
        container: '.promo.slide',
        item: '.item',
        play: true,
        className: 'current',
        active: 'active',
        speed: 15,
        init: function() {
            toggleSlider.speed =
                (parseInt($(toggleSlider.container).data('speed'), 10) ||
                    parseInt(toggleSlider.speed, 10)) * 1000;
            toggleSlider.firstInit();
            toggleSlider.startSlide();
            toggleSlider.events();
        },
        startSlide: function() {
            toggleSlider.play = setInterval(toggleSlider.slide, toggleSlider.speed);
        },
        stopSlide: function() {
            clearInterval(toggleSlider.play);
        },
        firstInit: function() {
            $(toggleSlider.container + ' ' + toggleSlider.item)
                .removeClass(toggleSlider.active)
                .fadeOut(0);

            $(toggleSlider.container + ' ' + toggleSlider.item)
                .eq(0)
                .fadeIn(0)
                .addClass(toggleSlider.active);
        },
        slide: function() {
            var active = $(
                    toggleSlider.container + ' ' + toggleSlider.item + '.' + toggleSlider.active,
                ),
                next = active.next();

            if (next.length === 0) {
                next = $(toggleSlider.container + ' ' + toggleSlider.item).eq(0);
            }

            active.fadeOut('slow', function() {
                $(this).removeClass(toggleSlider.active);

                next.fadeIn('slow', function() {
                    $(this).addClass(toggleSlider.active);
                });
            });
        },
        events: function() {
            $(toggleSlider.container).on({
                mouseenter: toggleSlider.stopSlide,
                mouseleave: toggleSlider.startSlide,
            });

            $('#mdlPromo').on('show.bs.modal', function(e) {
                var $lnkSeeDetails = $(e.relatedTarget),
                    $objPromoDetails = $lnkSeeDetails.closest('div.item').find('div.promo-details');

                $(this)
                    .find('div.modal-body')
                    .html($objPromoDetails.html());
            });
        },
    };

    if ($(toggleSlider.container).length > 0) {
        apcCommon.modules.push(toggleSlider.init);
    }
})(jQuery);
(function($) {
    'use strict';
    search = {
        init: function() {
            /* initialize product search */
            $('select#txtProductSearch').on('change', function() {
                var value = this.value;
                $('div.search-box > div').hide();
                $('div#search-' + value).show();
                search.setSearchValidation();
            });
            search.formValidate();
        },

        /*
         * Set Rules for search field on the fly depending on the type of search
         */
        setSearchValidation: function() {
            var SearchType = $('#txtProductSearch').val();
            $('#form-prduct-search')
                .data('validator')
                .resetForm();
            $('#search-' + SearchType)
                .find('input[type=text]:visible')
                .attr('data-rule-required', 'true')
                .attr('data-msg-required', 'Enter Value');
        },
        getUrlVar: function(key) {
            var result = new RegExp(key + '=([^&]*)', 'i').exec(window.location.search);
            return (result && unescape(result[1])) || '';
        },
        /*
         * Form validation
         */
        formValidate: function() {
            $('form').attr('autocomplete', 'off');

            $('#form-prduct-search').validate();
            $('#searchForm').validate({
                submitHandler: function(form) {
                    var $form = $(form),
                        $searchBox = $form.find('#searchText');

                    //$searchBox.val( $searchBox.val() + "*");

                    form.submit();
                },
            });
            var $searchBox = $('#searchForm').find('#searchText');
            var ntkVal = search.getUrlVar('searchTerm');
            var nttVal = search.getUrlVar('Ntt');
            if (ntkVal == undefined || ntkVal == '') {
                $searchBox.val(nttVal);
            }
        },
    };

    apcCommon.modules.push(search.init);
})(jQuery);
(function($) {
    'use strict';

    changeSite = {
        container: '#change-site',

        init: function() {
            $('#select-country').change(function() {
                if (this.value) {
                    $('#frmChangeSite')[0].submit();
                }
            });

            changeSite.loadMap();
            changeSite.formValidate();
        },

        loadMap: function() {
            $('body').on('click', 'div.map-selection  map area', function(e) {
                e.preventDefault();

                var _url = $(this)
                        .closest('map')
                        .data('url'),
                    country = $(this).data('country'),
                    config = {
                        data: { map: $(this).data('map') },
                        dataType: 'html',
                        url: _url,
                    };

                if (country) {
                    $('select#select-country').val(country);
                    $('#frmChangeSite')[0].submit();
                } else {
                    var prmMapDetails = apcData.get(config, '', true);

                    /* update map details success */
                    prmMapDetails.done(function(data, textStatus, jqXHR) {
                        window.setTimeout(function() {
                            $('div.map-selection')
                                .empty()
                                .append(data);

                            apcData.hideAjaxLoader();
                        }, 2000);
                    });
                }
            });
        },

        formValidate: function() {
            $('form').attr('autocomplete', 'off');

            /* form validation for change site */
            $('#frmChangeSite').validate();
        },
    };

    if ($(changeSite.container).length !== 0) {
        apcCommon.modules.push(changeSite.init);
    }
})(jQuery);

jQuery(function() {
    var lastTab = jQuery('li.lastTab');
    jQuery('ul.ui-tabs-nav li div.roundedBackground').hoverIntent({
        over: function() {
            //hide the tab content that was hightlighted
            jQuery('div.active-tab')
                .hide()
                .removeClass('active-tab');
            //remove highlight and set highlights
            jQuery('li.ui-tabs-selected').removeClass('ui-tabs-selected ui-state-active');
            if (lastTab.is('.active')) {
                lastTab.css('margin', '5px 0 0 0');
            } else {
                lastTab.css('margin', '10px 0 0 0');
            }

            jQuery(this)
                .parent()
                .addClass('ui-tabs-selected ui-state-active');

            if (
                jQuery(this)
                    .parent()
                    .is('.lastTab.ui-state-active')
            ) {
                jQuery(this)
                    .parent()
                    .css('margin', '5px 0 0 0');
            }

            var divName = jQuery(this)
                .parent()
                .find('a')
                .attr('title');
            var tabId = divName.replace(/\s/g, '_');
            divName = '#' + tabId;
            jQuery(divName).addClass('active-tab');
            jQuery(divName).show();
            jQuery('#menu_panel').show();
            switch (
                jQuery(this)
                    .parent()
                    .index()
            ) {
                case 0:
                    jQuery('#menu_panel_content').css({ width: '86%', float: 'left' });
                    break;
                case 1:
                    jQuery('#menu_panel_content').css({ width: '100%', float: 'right' });
                    break;
                case 2:
                    jQuery('#menu_panel_content').css({ width: '100%', float: 'right' });
                    break;
                case 3:
                    jQuery('#menu_panel_content').css({ width: '60%', float: 'right' });
                    break;
                case 4:
                    jQuery('#menu_panel_content').css({ width: '30%', float: 'right' });
                    break;
            }
        },
        out: function() {},
        timeout: 100,
    });
    jQuery('#tabs').on('mouseleave', function() {
        if (lastTab.is('.active')) {
            lastTab.css('margin', '5px 0 0 0');
        } else {
            lastTab.css('margin', '10px 0 0 0');
        }
        jQuery('li.ui-tabs-selected').removeClass('ui-tabs-selected ui-state-active');
        jQuery('#menu_panel').hide();
    });
    jQuery('ul.ui-tabs-nav li div a').on('focusout', function() {
        jQuery(this).mouseleave(); // do same thing as mouseleave()
    });
});

$(function() {
    function setQTY(calculateQTY) {
        return function() {
            var $input = $(this)
                .closest('form')
                .find('.qty');
            $input.val(calculateQTY(+$input.val()) || 1);
            $(this)
                .closest('form')
                .valid();
        };
    }

    $('.js-quantity-controller-plus').on(
        'click',
        setQTY(function(qtyValue) {
            if (qtyValue > 0) return qtyValue + 1;
        }),
    );
    $('.js-quantity-controller-minus').on(
        'click',
        setQTY(function(qtyValue) {
            if (qtyValue > 1) return qtyValue - 1;
        }),
    );
    $('.wrapper').each(function(index) {
        $(this)
            .find('.myList li:lt(' + $(this).attr('viewChild') + ')')
            .show();
        var liSize = $(this).find('.myList li').length;
        if (liSize > 5) {
            $(this)
                .find('.loadMore')
                .show();
        } else {
            $(this)
                .find('.loadMore')
                .hide();
        }
    });
    $('.loadMore').on('click', function() {
        var $myWrapper = $(this).closest('.wrapper');
        var x = parseInt($myWrapper.attr('viewChild'), 10);
        var liSize = $myWrapper.find('.myList li').size();
        x = x <= liSize ? liSize : x;
        $myWrapper.attr('viewChild', x);
        $myWrapper.find('.myList li:lt(' + x + ')').show();
        if (x == liSize) {
            $myWrapper.find('.loadMore').hide();
            $myWrapper.find('.showLess').show();
        } else if (x >= liSize) {
            $myWrapper.find('.loadMore').hide();
        }
    });
    $('.showLess').on('click', function() {
        var $myWrapper = $(this).closest('.wrapper');
        var x = $(this).attr('id');
        $myWrapper.attr('viewChild', x);
        $myWrapper
            .find('.myList li')
            .not(':lt(' + x + ')')
            .hide();
        $myWrapper.find('.showLess').hide();
        $myWrapper.find('.loadMore').show();
    });
});
(function($) {
    $('#submitEditPaymentMethod').on('click', function() {
        $('#payment-information').submit();
    });

    $.fn.sliderWithCounter = function(settings) {
        var config = {
            itemContainerName: '.slider',
            leftButtonHolder: '.prev',
            rightButtonHolder: '.next',
            itemPerRow: 1,
            counterEnabled: true,
            wipeEnabled: true,
            disableInactiveButtons: true,
            videoCounterHolder: '.video-count',
            currentNumberHolder: '.current-number',
            totalNumberHolder: '.total-number',
        };

        if (settings) $.extend(config, settings);

        var map = this.map(function() {
            var container = $(this);
            var itemContainer = container.find(config.itemContainerName);
            var leftButton = container.find(config.leftButtonHolder);
            var rightButton = container.find(config.rightButtonHolder);
            var videoCounter = container.find(config.videoCounterHolder);
            var currentNumber = videoCounter.find(config.currentNumberHolder);
            var itemCount,
                currentItem = 0,
                newItem,
                partialSize,
                enabled = true;

            function init() {
                // Setup
                updateSize();

                if (config.wipeEnabled)
                    container.touchwipe({
                        wipeLeft: next,
                        wipeRight: prev,
                        preventDefaultEvents: false,
                    });

                leftButton.on('click', prev);
                rightButton.on('click', next);
            }

            function goTo(newItem) {
                if (!enabled) return;

                if (newItem > itemCount - config.itemPerRow || newItem < 0) return;
                currentItem = newItem;

                itemContainer.animate(
                    { 'margin-left': '-' + currentItem * partialSize + '%' },
                    'slow',
                );

                if (config.counterEnabled) currentNumber.html(currentItem + 1);

                // Deactivating navigation button on first and last elements
                if (config.disableInactiveButtons) {
                    if (currentItem == itemCount - config.itemPerRow)
                        rightButton.addClass('disabled');
                    else rightButton.removeClass('disabled');
                    if (currentItem == 0) leftButton.addClass('disabled');
                    else leftButton.removeClass('disabled');
                }
            }

            function updateSize() {
                itemCount = itemContainer.children().length;
                if (config.counterEnabled) $(config.totalNumberHolder).html(itemCount);
                // Scaling (in %) the itemContainer and individual items as to take the size of the container
                partialSize = (100 / config.itemPerRow).toFixed(8);
                itemContainer.children().css({ width: (100 / itemCount).toFixed(8) + '%' });

                goTo(currentItem);
            }

            function prev() {
                goTo(currentItem - 1);
            }

            function next() {
                goTo(currentItem + 1);
            }

            function enable() {
                enabled = true;
                updateSize();
                goTo(0);
            }

            function disable() {
                enabled = false;
                itemContainer.removeAttr('style');
                itemContainer.children().removeAttr('style');
            }

            init();

            // Methods export
            return {
                goTo: goTo,
                prev: prev,
                next: next,
                updateSize: updateSize,
                enable: enable,
                disable: disable,
                config: config,
            };
        });

        if (map.length == 0) return undefined;
        if (map.length == 1) return map[0];
        return map;
    };
})(jQuery);

(function($) {
    $(function() {
        // Fix the bug of inactive close button of thank-you popup message in footer email-subscription form
        $('body').on('click', '.js-close-popup', function() {
            if ($.colorbox) {
                $.colorbox.close();
            }
        });
    });
})(jQuery);

(function($) {
    'use strict';
    var shoppingCart_2018 = {
        container: '#shopping-cart',

        promoCodeFormSelector: '#form-promo-code',
        promoCodeTextInputSelector: '#txtPromoCode',
        promoCodeCollapseImgSelector: '.promo-code__img',

        estimatedDeliveryCollapseImgSelector: '.estimated-delivery-tax__img',

        init: function() {
            shoppingCart_2018.promoCodeCollapse();
            shoppingCart_2018.estimatedDeliveryCollapse();
        },

        promoCodeCollapse: function() {
            var $promoCodeCollapseImg = $(shoppingCart_2018.promoCodeCollapseImgSelector);
            $(shoppingCart_2018.promoCodeFormSelector)
                .on('shown.bs.collapse', function(ev) {
                    $(shoppingCart_2018.promoCodeTextInputSelector).focus();
                })
                .on('show.bs.collapse', function(ev) {
                    $promoCodeCollapseImg.removeClass('promo-code__img_open');
                    $promoCodeCollapseImg.addClass('promo-code__img_close');
                })
                .on('hide.bs.collapse', function(ev) {
                    $promoCodeCollapseImg.removeClass('promo-code__img_close');
                    $promoCodeCollapseImg.addClass('promo-code__img_open');
                });
        },

        estimatedDeliveryCollapse: function() {
            var $estimatedDeliveryCollapseImg = $(
                shoppingCart_2018.estimatedDeliveryCollapseImgSelector,
            );

            $('#collapseEDT')
                .on('show.bs.collapse', function() {
                    $estimatedDeliveryCollapseImg.removeClass('estimated-delivery-tax__img_open');
                    $estimatedDeliveryCollapseImg.addClass('estimated-delivery-tax__img_close');
                })
                .on('hide.bs.collapse', function() {
                    $estimatedDeliveryCollapseImg.removeClass('estimated-delivery-tax__img_close');
                    $estimatedDeliveryCollapseImg.addClass('estimated-delivery-tax__img_open');
                });
        },
    };

    apcCommon.modules.push(shoppingCart_2018.init);
})(jQuery);

// Common utils

/**
 * Set scroll event listener using passive listener, for browsers
 * that do not support passive event fallback on default listener
 *
 * @param {function} cb
 * @param {HTMLElement} target
 * @returns {function} - remove event listener
 */
var onScroll = (function() {
    /**
     * The code is copied from ui-prototypes/pdp_redesign/src/utils/on-scroll.js
     * when the apc.js will be build in automated way remove this code and refer to original file.
     * Until that moment, please reflect all changed made for this file in original file too.
     */

    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function() {
                supportsPassive = true;
            },
        });
        window.addEventListener('testPassive', null, opts);
        window.removeEventListener('testPassive', null, opts);
    } catch (e) {
        supportsPassive = false;
    }
    return function onScroll(cb, target) {
        var actualTarget = target || window;
        actualTarget.addEventListener('scroll', cb, supportsPassive ? { passive: true } : false);
        return function removeOnScroll() {
            actualTarget.removeEventListener(
                'scroll',
                cb,
                supportsPassive ? { passive: true } : false,
            );
        };
    };
})();

/**
 * The Source code is taken from ui-prototypes/pdp_redesign/src/pdp/....../sticky.js
 * with manual transpilation with babel for IE11 browser.
 * The only change is prepending 'shpcart-' for sticky classes,
 * in order to avoid collision. Please remove that class when an automated process
 * for building static files will be implemented.
 *
 * @type {Sticky}
 */
var StickyScroller = (function() {
    var _extends =
        Object.assign ||
        function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        };

    var _createClass = (function() {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ('value' in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function(Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    })();

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError('Cannot call a class as a function');
        }
    }

    var Sticky = (function() {
        function Sticky(element) {
            var _this = this;

            var options =
                arguments.length > 1 && arguments[1] !== undefined
                    ? arguments[1]
                    : {
                          stickTo: 'top',
                          stickyCondition: function stickyCondition() {
                              return false;
                          },
                      };

            _classCallCheck(this, Sticky);

            this.init = function() {
                _this.findCoordinates();
                _this.scrollUnsubscribe = onScroll(_this.findCoordinates);
                window.addEventListener('resize', _this.findCoordinates);
            };

            this.findCoordinates = function() {
                var windowParams = {
                    offsetTop: window.pageYOffset,
                    offsetBottom: window.pageYOffset + document.documentElement.clientHeight,
                    innerHeight: window.innerHeight,
                    innerWidth: window.innerWidth,
                };

                if (!_this.element) {
                    return;
                }

                var _element$parentElemen = _this.element.parentElement.getBoundingClientRect(),
                    top = _element$parentElemen.top,
                    bottom = _element$parentElemen.bottom;

                height1 = _this.element.parentElement.style.height;

                if (
                    _this.options.stickyCondition(
                        _extends(
                            {
                                top: top,
                                bottom: bottom,
                                height1: height1,
                            },
                            windowParams,
                        ),
                    )
                ) {
                    _this.showSticky(_this.element);
                } else {
                    _this.hideSticky(_this.element);
                }
            };

            this.destroy = function() {
                if (_this.element) {
                    _this.hideSticky(_this.element);
                }

                if (typeof _this.scrollUnsubscribe === 'function') {
                    _this.scrollUnsubscribe();
                }
            };

            if (!element) {
                return;
            }
            this.options = options;
            this.element = element;
        }

        _createClass(Sticky, [
            {
                key: 'showSticky',
                value: function showSticky(element) {
                    var parentElement = element.parentElement;

                    element.classList.add('shpcart-sticky');
                    parentElement.classList.remove('fixedHeightMarker');

                    if (this.options.stickyAdditionalClass) {
                        element.classList.add(this.options.stickyAdditionalClass);
                    }
                    element.classList.add(
                        this.options.stickTo === 'bottom'
                            ? 'shpcart-sticky__bottom'
                            : 'shpcart-sticky__top',
                    );
                    parentElement.style.height = element.getBoundingClientRect().height - 40 + 'px';
                },
            },
            {
                key: 'hideSticky',
                value: function hideSticky(element) {
                    if (!element || !element.parentElement) {
                        return;
                    }

                    var parentElement = element.parentElement;

                    parentElement.classList.add('fixedHeightMarker');

                    element.classList.remove('shpcart-sticky');
                    element.classList.remove('shpcart-sticky__bottom');
                    element.classList.remove('shpcart-sticky__top');
                    if (this.options.stickyAdditionalClass) {
                        element.classList.remove(this.options.stickyAdditionalClass);
                    }
                },
            },
        ]);
        return Sticky;
    })();
    return Sticky;
})();

/**
 * Creates syntatic sugar object to handle swtiching between media query states
 *   Usage example:
 *   var mediaDesktop = createMediaListener('(min-width: 961px)');
 *   mediaDesktop({
 *     // Desktop
 *     mount() {
 *       ... swtiching to desktop
 *     },
 *     willUnmount() {
 *       ... cleanup desktop before swtiching to mobile state
 *     }
 *   }, {
 *     // Mobile
 *     mount() {
 *       ... swtiching to mobile
 *     },
 *     willUnmount() {
 *       ... cleanup mobile before swtiching to desktop state
 *     }
 *   })
 *
 * @param mediaQuery {String} - mediaQuery CSS Media Query string
 */
function createMediaListener(mediaQuery) {
    var matchFunctions;
    var unmatchFunctions;
    var currentState = '';

    function mqlistener(mediaObject) {
        var isMatches = mediaObject.matches;

        if (isMatches) {
            // unmounting current state
            if (currentState && currentState === 'unmatch' && unmatchFunctions.willUnmount) {
                unmatchFunctions.willUnmount();
            }
            // mounting new state
            if (matchFunctions.mount) {
                matchFunctions.mount();
            }
            currentState = 'match';
        } else {
            // unmounting current state
            if (currentState && currentState === 'match' && matchFunctions.willUnmount) {
                matchFunctions.willUnmount();
            }
            // mounting new state
            if (unmatchFunctions.mount) {
                unmatchFunctions.mount();
            }
            currentState = 'unmatch';
        }
    }

    var mediaQueryObject = window.matchMedia(mediaQuery);
    mediaQueryObject.addListener(mqlistener);

    return function(matchFunctionsObj, unmatchFunctionsObj) {
        matchFunctions = matchFunctionsObj;
        unmatchFunctions = unmatchFunctionsObj;

        // first execution of listener
        mqlistener(mediaQueryObject);
    };
}

// Shopping Cart Module
$(function() {
    var $shoppingCartContainer = $('#shopping-cart');
    if ($shoppingCartContainer.length === 0) return;

    function initializeStickyButton() {
        const element = document.getElementById('sticky-checkout-cart');
        const checkoutBtn = document.querySelector('input[name*="moveToPurchaseInfoByRelId"]');

        if (checkoutBtn && element) {
            // We are using the orignal condition function from the USC,
            // but passing arbitrary element to be used in calculations

            var mediaDesktop = createMediaListener('(min-width: 961px)');
            var paypalBtnClass = '.apc-paypal-button';
            
            //Prepending image for resolving paypal button overlapping issue on the print window in shopping cart page
            const payPalBtn = document.querySelector('.apc-paypal-button');
            if (payPalBtn) {
                $('.sticky-checkout-wrapper').prepend('<img class="paypal-img-btn" src="/static/images/paypalImg.png" />');
            }
            
            mediaDesktop(
                {
                    // Desktop
                    mount: function() {
                        element.classList.remove('shopping-cart-sticky-area');
                        var btn = $(paypalBtnClass, element)[0];
                        if (window.APC_PAYPAL && btn) {
                            initPaypalButton(btn);
                        }
                    },
                    willUnmount: function() {},
                },
                {
                    // Mobile
                    mount: function() {
                        // this class is used in CSS, so it must be included
                        element.classList.add('shopping-cart-sticky-area');

                        var currentShowSticked = null;

                        window.APC_USC_READY = window.APC_USC_READY || [];
                        window.APC_USC_READY.push(function() {
                            var conditionFunction = function(el, clonedEl) {
                                var showSticked = APC_USC.CONDITION_FUNC_STICK_IF_NOT_IN_VIEWPORT(
                                    el,
                                );
                                if (currentShowSticked === showSticked) {
                                    return showSticked;
                                }
                                if (window.APC_PAYPAL) {
                                    var btnPlaceholder = showSticked
                                        ? $(paypalBtnClass, clonedEl)[0]
                                        : $(paypalBtnClass, el)[0];
                                    if (initPPbtnTimeout) {
                                        clearTimeout(initPPbtnTimeout);
                                    }
                                    initPPbtnTimeout = setTimeout(function() {
                                        initPaypalButton(btnPlaceholder);
                                    }, 500);
                                }
                                currentShowSticked = showSticked;
                                return showSticked;
                            };
                            APC_USC.makeSticky(element, conditionFunction, { useOriginal: true });
                        });
                    },
                    willUnmount: function() {
                        APC_USC.unstickElement(element);
                    },
                },
            );

            var initPPbtnTimeout;
        } else {
            console.warn('Checkout or sticky-checkout-cart button is not found');
        }
    }

    initializeStickyButton();

    // PayPal

    function showError(errorDescription) {
        var isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent,
            ) || $(window).width() <= 767;

        $('#notice-panel').each(function() {
            $(this).hide();
        });

        $('#notice-panel').html(
            '<div class="server-error-panel"><span aria-hidden="true" class="glyphicon glyphicon-exclamation-sign"></span><p>' +
                errorDescription +
                '<br><span class="message"> </span></p></div>',
        );
        $('#notice-panel').show();

        $('html, body').animate(
            {
                scrollTop: isMobile
                    ? $('#notice-panel').offset().top - $('#notice-panel').height()
                    : 0,
            },
            0,
        );
    }

    function initPaypalButton(buttonSelectorOrEl) {
        if (!window.APC_PAYPAL) {
            return;
        }

        var btnEl;

        if (typeof buttonSelectorOrEl === 'string') {
            btnEl = document.querySelectorAll(buttonSelectorOrEl)[0];
        } else {
            btnEl = buttonSelectorOrEl;
        }

        if (!btnEl) {
            console.error('Paypal button element is not found', btnEl);
            return;
        }

        var errorMessage;

        btnEl.innerHTML = ''; // clear content of the element to re-initialize the button

        paypal.Button.render(
            {
                env: window.APC_PAYPAL.env, // Or 'production'
                // Set up the payment:
                // Customize button (optional)
                locale: window.APC_PAYPAL.locale,
                style: {
                    label: 'checkout',
                    size: 'responsive',
                    shape: 'rect',
                    color: 'white',
                    tagline: false,
                },
                // 1. Add a payment callback
                payment: function(data, actions) {
                    // 2. Make a request to your server
                    return actions.request
                        .post('/rest/model/schneider/paypal/PaypalPaymentService/createPayment', {
                            pushSite: window.APC_PAYPAL.pushSite,
                        })
                        .then(function(res) {
                            if (res.isNeededRedirectToShoppingCart) {
                                window.location = window.APC_PAYPAL.shoppingCartURL;
                            }
                            errorMessage = res.errorDescription;
                            if (errorMessage) {
                                showError(errorMessage);
                            }
                            // 3. Return res.id from the response
                            return res.payId;
                        });
                },
                // Execute the payment:
                // 1. Add an onAuthorize callback
                onAuthorize: function(data, actions) {
                    // 2. Make a request to your server
                    return actions.request
                        .post('/rest/model/schneider/paypal/PaypalPaymentService/savePayment', {
                            paymentID: data.paymentID,
                            payerID: data.payerID,
                            pushSite: window.APC_PAYPAL.pushSite,
                        })
                        .then(function(res) {
                            // 3. Show the buyer a confirmation message.
                            if (res.success) {
                                window.location = window.APC_PAYPAL.checkoutOrderReviewURL;
                            } else {
                                //display error
                                showError(res.errorDescription);
                            }
                        });
                },
                onError: function(err) {
                    if (errorMessage) {
                        showError(errorMessage);
                    }
                },
            },
            btnEl,
        );
    }

    initPaypalButton('.apc-paypal-button');
});

/**
 * @typedef {Object} PopupConfig
 * @property {string} targetElement
 * @property {string} closeElement
 * @property {function} onInit
 * @property {function} onDestroy
 */

/**
 * @param {PopupConfig} config
 */
function PopupFactory(config) {
    const ESC_KEY_CODE = 27;
    if (config.targetElement === undefined) {
        throw new Error('Provide target element for popup initialize function');
    }

    const popupElement /* HTMLElement */ = document.querySelector(config.targetElement);

    if (!popupElement) {
        return;
    }

    const cancelBtn = document.querySelector('#popupCancelBtn');
    const submitBtn = document.querySelector('#popupSubmitBtn');

    function stopPropagationToFixMenu(event) {
        event.stopPropagation();
    }

    /**
     * Close popup on escape key
     */
    function closeOnEscape(event) {
        if (event.keyCode === ESC_KEY_CODE) {
            // eslint-disable-next-line
            hide();
        }
    }

    function closeOnCancel() {
        hide();
    }

    function submitPopupForm() {
        const submitformEl = $(config.formId);

        if (config.onSubmit && submitformEl) {
            config.onSubmit(submitformEl);
        }
    }

    /**
     * Adds or removes modal-open class for body, depending on it's state
     * @param isModalOpen {Boolean} - Flag which display if modal has been opened
     */
    function handleBodyModalOpenState(isModalOpen) {
        const modalOpenClassName = 'modal-open';
        const bodyClassList = document.body && document.body.classList;
        if (!bodyClassList || !bodyClassList.toggle || !bodyClassList.contains) {
            console.warn('body classList was not found');
            return;
        }
        if (isModalOpen !== bodyClassList.contains(modalOpenClassName)) {
            bodyClassList.toggle(modalOpenClassName);
        }
    }

    /**
     * Close a complete your solution popup
     */
    function hide() {
        popupElement.style.display = 'none';
        popupElement.removeEventListener('click', stopPropagationToFixMenu);
        window.removeEventListener('keydown', closeOnEscape);
        handleBodyModalOpenState(false);
        if (config.onDestroy !== undefined) {
            config.onDestroy();
        }

        Array.prototype.slice
            .apply(document.querySelectorAll(config.closeElement))
            .forEach(function(nodeElement) {
                nodeElement.removeEventListener('click', hide);
            });
    }

    /**
     * Show a complete your solution popup
     */
    function show() {
        popupElement.style.display = '';
        popupElement.addEventListener('click', stopPropagationToFixMenu);
        handleBodyModalOpenState(true);
        window.addEventListener('keydown', closeOnEscape);
        cancelBtn.addEventListener('click', closeOnCancel);
        submitBtn.addEventListener('click', submitPopupForm);

        if (config.onInit !== undefined) {
            config.onInit();
        }

        Array.prototype.slice
            .apply(document.querySelectorAll(config.closeElement))
            .forEach(function(nodeElement) {
                nodeElement.addEventListener('click', hide);
            });
    }

    function isExist() {
        return Boolean(popupElement);
    }

    return {
        hide: hide,
        show: show,
        isExist: isExist,
    };
}

$(function() {
    /**
     * @param {HTMLInputElement} element
     * @returns boolean
     */
    function isCheckboxChecked(element) {
        return element.checked;
    }

    function sendDoNotShowMessage() {
        const doNotShowFrom = $('#form-dontShowReminder');

        if (doNotShowFrom) {
            doNotShowFrom.find('input[type=submit]').click();
        }
    }

    const taxPopup = PopupFactory({
        targetElement: '.js-tax-id-popup',
        closeElement: '.popup__shadow, .popup__close',
        formId: '#form-taxID',
        onInit: function() {
            myAccount.manageTaxExcemption();
            myAccount.invokeCalendar();
        },
        onDestroy: function() {
            const doNotShowAgainCheckbox = document.getElementById('do_not_show_message');

            if (isCheckboxChecked(doNotShowAgainCheckbox)) {
                sendDoNotShowMessage();
            }
        },
        onSubmit: function(el) {
            const doNotShowAgainCheckbox = document.getElementById('do_not_show_message');

            if (isCheckboxChecked(doNotShowAgainCheckbox)) {
                sendDoNotShowMessage();
            } else {
                $(el)
                    .find('input[type=submit]')
                    .click();
            }
        },
    });

    const vatPopup = PopupFactory({
        targetElement: '.js-vat-id-popup',
        closeElement: '.popup__shadow, .popup__close',
        formId: '#form-vatID',
        onDestroy: function() {
            const doNotShowAgainCheckbox = document.getElementById('do_not_show_message');

            if (isCheckboxChecked(doNotShowAgainCheckbox)) {
                sendDoNotShowMessage();
            }
        },
        onSubmit: function(el) {
            const doNotShowAgainCheckbox = document.getElementById('do_not_show_message');

            if (isCheckboxChecked(doNotShowAgainCheckbox)) {
                sendDoNotShowMessage();
            } else {
                $(el)
                    .find('input[type=submit]')
                    .click();
            }
        },
    });

    const remindEnterTaxId = document.getElementById('remindEnterTaxId');
    const reminderVatEl = document.getElementById('remindEnterVatId');

    if (remindEnterTaxId) {
        taxPopup.show();
    }

    if (reminderVatEl) {
        vatPopup.show();
    }

    const popupCloseIcon = document.querySelector('.vat-tax-popup__success-msg-close');
    const popupMsgWrapper = document.querySelector('.vat-tax-popup__msg-wrapper');

    if (popupMsgWrapper) {
        popupCloseIcon.addEventListener('click', function() {
            popupMsgWrapper.classList.add('hidden');
        });
    }
});
(function() {
    document.addEventListener('DOMContentLoaded', function(e) {
        const setPreloader = dom => {
            const preloader = document.createElement('div');
            preloader.className = 'spinner-loader';
            preloader.innerHTML = '<div></div>';
            dom.appendChild(preloader);
            return {
                destroy: () => {
                    dom.removeChild(preloader);
                },
            };
        };

        const sizeColumnRender = (hasSizeColumn, filesize) => {
            if (hasSizeColumn) {
                return `<span class="popup-table-column">${
                    parseFloat(filesize) === 0 ? '' : filesize
                }</span>`;
            }

            return '';
        };

        const renderItem = (
            { fileName, linkDisplayName, fileType, filesize, updatedOn, link },
            translations,
            hasSizeColumn,
        ) => {
            return `
                <div class="popup-table-row ">
                    <div class="popup-table-column">
                        <div class="wrapper-file-icon">
                        <svg class="icon" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g fill-rule="nonzero" fill="none"><path fill="#1B3963" d="M7 0h23l13 13v37H7z"/><path fill="#0E1929" d="M30 0l13 13H30z"/><path d="M22.738 37.561l1.03.19a.49.49 0 0 0 .561-.615l-.268-.94a1.726 1.726 0 0 1 .703-1.91l.867-.578a.463.463 0 0 0-.037-.793l-.857-.46a1.726 1.726 0 0 1-.872-1.871l.197-.952a.463.463 0 0 0-.583-.539l-1 .293a1.726 1.726 0 0 1-1.914-.689l-.548-.81a.49.49 0 0 0-.833.034l-.516.912c-.363.64-1.092.98-1.816.846l-1.03-.19a.49.49 0 0 0-.56.616l.267.94a1.726 1.726 0 0 1-.702 1.909l-.867.578a.463.463 0 0 0 .037.793l.857.46a1.726 1.726 0 0 1 .872 1.872l-.198.952a.463.463 0 0 0 .584.538l1-.292c.72-.21 1.493.068 1.914.689l.548.81a.49.49 0 0 0 .832-.034l.516-.912a1.726 1.726 0 0 1 1.816-.847zm-1.257 2.367a1.725 1.725 0 0 1-2.93.117l-.548-.81a.49.49 0 0 0-.544-.195l-1 .293a1.698 1.698 0 0 1-2.14-1.975l.198-.952a.49.49 0 0 0-.248-.532l-.857-.46a1.698 1.698 0 0 1-.138-2.91l.868-.578a.49.49 0 0 0 .2-.542l-.268-.94a1.725 1.725 0 0 1 1.973-2.17l1.03.191a.49.49 0 0 0 .516-.24l.517-.913a1.725 1.725 0 0 1 2.93-.117l.548.81a.49.49 0 0 0 .544.196l1-.293a1.698 1.698 0 0 1 2.14 1.975l-.198.952a.49.49 0 0 0 .248.532l.857.46a1.698 1.698 0 0 1 .137 2.909l-.867.578a.49.49 0 0 0-.2.543l.268.94a1.725 1.725 0 0 1-1.973 2.17l-1.03-.191a.49.49 0 0 0-.517.24l-.516.912zm-1.538-3.614c-1.47.052-2.71-1.074-2.76-2.523-.05-1.449 1.107-2.659 2.578-2.71 1.47-.051 2.71 1.075 2.76 2.523.05 1.45-1.107 2.659-2.578 2.71zM19.9 35.08c.796-.028 1.413-.673 1.387-1.432-.027-.76-.687-1.36-1.483-1.333-.796.028-1.413.673-1.387 1.433.027.76.687 1.36 1.483 1.332zM34.509 31.79l.602.047a.223.223 0 0 0 .225-.306l-.204-.508a1.726 1.726 0 0 1 .499-1.971l.459-.382a.203.203 0 0 0-.053-.343l-.498-.204a1.726 1.726 0 0 1-1.063-1.77l.053-.535a.203.203 0 0 0-.278-.208l-.552.226a1.726 1.726 0 0 1-1.975-.485l-.353-.418a.223.223 0 0 0-.375.054l-.241.555a1.726 1.726 0 0 1-1.718 1.032l-.603-.047a.223.223 0 0 0-.224.305l.204.508c.28.696.078 1.493-.499 1.972l-.459.38a.203.203 0 0 0 .053.344l.498.204c.707.29 1.14 1.01 1.063 1.77l-.053.536a.203.203 0 0 0 .278.207l.552-.226a1.726 1.726 0 0 1 1.975.485l.352.419a.223.223 0 0 0 .376-.055l.241-.555a1.726 1.726 0 0 1 1.718-1.032zm-.827 2.079a1.458 1.458 0 0 1-2.452.357l-.353-.418a.49.49 0 0 0-.561-.138l-.552.226a1.438 1.438 0 0 1-1.976-1.474l.053-.536a.49.49 0 0 0-.302-.503l-.498-.204a1.438 1.438 0 0 1-.374-2.436l.46-.381a.49.49 0 0 0 .141-.561l-.204-.508a1.458 1.458 0 0 1 1.467-1.998l.603.048a.49.49 0 0 0 .488-.294l.242-.554a1.458 1.458 0 0 1 2.452-.358l.353.419a.49.49 0 0 0 .561.138l.552-.227a1.438 1.438 0 0 1 1.976 1.474l-.054.536a.49.49 0 0 0 .303.503l.498.204a1.438 1.438 0 0 1 .374 2.437l-.46.38a.49.49 0 0 0-.141.562l.204.507a1.458 1.458 0 0 1-1.467 1.998l-.603-.047a.49.49 0 0 0-.488.293l-.242.555zM32.12 31.35c-1.186.167-2.287-.64-2.452-1.813-.165-1.171.671-2.25 1.858-2.418 1.186-.166 2.287.64 2.452 1.813.164 1.172-.671 2.251-1.858 2.418zm-.172-1.223c.518-.073.875-.534.807-1.023-.07-.49-.54-.834-1.058-.762-.518.073-.875.534-.806 1.024.069.489.54.834 1.057.76z" fill="#FFF"/></g></svg>
                        </div>
                        <div>${linkDisplayName !== null ? linkDisplayName : fileName}</div>
                    </div>
                    <span class="popup-table-column">${fileType || ''}</span>
                    ${sizeColumnRender(hasSizeColumn, filesize)}
                    <span class="popup-table-column">${updatedOn}</span>
                    <span class="popup-table-column">
                        <div class="download-btn-wrapper"><a class="download-link btn-se btn-se_color_blue"
                        href="${link}${fileName}" download>${
                translations['pdp.label.download']
            }</a></div>
                    </span>
                </div>
            `;
        };
        const renderTemplate = ({ pic, partnumber, name }, { downloadLinks, translations }) => {
            const hasSizeColumn = downloadLinks.some(
                item => parseFloat(item.filesize) && parseFloat(item.filesize) !== 0,
            );

            return `
                <div class="popup-header">
                    <div class="popup-header__img-wrapper">
                        <img class="popup-header__img" src="${pic}" />
                    </div>
                    <div class="popup-header-content">
                        <div class="popup__product-name">${name}</div>
                        <span class="popup-sku">${partnumber}</span>
                    </div>
                </div>
                <div class="popup-content__files-content">
                    <div class="content-header">${
                        translations['finder.software.availableVersions']
                    }</div>
                    <div class="${
                        hasSizeColumn
                            ? 'popup-table'
                            : 'popup-table popup-table_without-size-column'
                    }">
                        <div class="popup-table-row popup-table-row_head-row">
                            <div class="popup-table-column">${
                                translations['software.download.fileTitle']
                            }</div>
                            <div class="popup-table-column">${
                                translations['software.download.fileType']
                            }</div>
                            ${sizeColumnRender(
                                hasSizeColumn,
                                translations['software.download.fileSize'],
                            )}
                            <div class="popup-table-column">${
                                translations['software.updatedOn']
                            }</div>
                            <div class="popup-table-column"></div>
                        </div>
                        ${downloadLinks
                            .map(item => renderItem(item, translations, hasSizeColumn))
                            .join('')}
                    </div>
                </div>
            `;
        };
        const popupWrapper = document.querySelector('.category-download-popup-wrapper');
        const content = document.querySelector('.category-download-popup-wrapper .popup-content');
        const handleResponse = (commonInfo, downloadItems) => {
            popupWrapper.style.display = 'block';
            document.body.classList.add('modal-open');
            popupWrapper.scrollTop = 0;
            content.innerHTML = renderTemplate(commonInfo, downloadItems);
        };

        const closePopup = () => {
            document.body.classList.remove('modal-open');
            popupWrapper.style.display = 'none';
        };

        if (popupWrapper) {
            window.addEventListener('keydown', e => {
                if (e.keyCode === 27 && document.body.classList.contains('modal-open')) {
                    closePopup();
                }
            });
        }

        /**
         * Creates and sends request to rest service to get all download files and information
         * returns es6 fetch
         * after successful resolve it calls handleResponse() class method
         * @param data {Object} - object contains additional common data for popup
         * ( img, sku name, partnumber)
         */
        const sendRequest = data => {
            const fetchHeaders = new Headers({ 'Content-Type': 'text/html' });
            const needImage = data.pic ? '' : '&softwareImageRequired=true';
            return fetch(
                `/rest/model/schneider/catalog/CatalogLookupActor/softwareDownloads?skuId=SKU-${data.partnumber}&pushSite=${data.pushsite}${needImage}`,
                {
                    method: 'get',
                    credentials: 'same-origin',
                    headers: fetchHeaders,
                    cache: 'default',
                },
            )
                .then(response => {
                    if (!response.ok) throw new Error(response.statusText);
                    return response.json();
                })
                .then(result => {
                    if (needImage) {
                        data.pic = result.softwareImage;
                    }
                    handleResponse(data, result);
                })
                .catch(error => {
                    console.error(error);
                });
        };

        const makeDownloadPopup = (popUpData, dom) => {
            const preloader = setPreloader(dom);
            sendRequest(popUpData).then(() => preloader.destroy());
        };

        const findDomElementUp = (el, predicate) =>
            predicate(el)
                ? el
                : (el.parentElement && findDomElementUp(el.parentElement, predicate)) || null;

        if (popupWrapper) {
            popupWrapper.addEventListener('click', ({ target }) => {
                if (
                    findDomElementUp(target, el => el.classList.contains('popup-close')) ||
                    !findDomElementUp(target, el => el.classList.contains('popup'))
                ) {
                    closePopup();
                }
            });
        }
        Array.from(document.querySelectorAll('.has-download-option')).forEach(item => {
            item.addEventListener('click', function(e) {
                e.preventDefault();
                makeDownloadPopup(this.dataset, this.querySelector('a'));
            });
        });
    });
})();
